(function () {
    'use strict';

    angular
        .module('stdlDigits', [
            'angular-storage',
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngSanitize',
            'ngTouch',
            'restangular',
            'ui.router',
            'duScroll',
            'ksSwiper',
            'mediaPlayer',
            'uuid',
            'jlareau.bowser',
            'angulartics',
            'angulartics.google.tagmanager'
        ]);

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('whenScrolled', whenScrolled);


    /** @ngInject */
    function whenScrolled () {
        var directive = {
            restrict: 'A',
            scope: true,
            controller: WhenScrolledController,
            controllerAs: 'ws',
            bindToController: {
                whenScrolled : "="
            }
        };

        return directive;

        /** @ngInject */
        function WhenScrolledController ($scope, $window, $timeout, reqAnimationFrame) {

            var vm = this;

            var scrolled = false;
            var threshold = 35;

            if(angular.isDefined(vm.whenScrolled.threshold)) {
                threshold = vm.whenScrolled.threshold;
            }

            var checkScrolling = function() {

                if($window.pageYOffset >= threshold && !scrolled) {

                    scrolled = true;
                    $scope.$eval(vm.whenScrolled.start);
                    $scope.$apply();

                }

                if($window.pageYOffset < threshold && scrolled) {

                    scrolled = false;
                    $scope.$eval(vm.whenScrolled.end);
                    $scope.$apply();

                }
            };

            $timeout(checkScrolling, 0); // fire once

            reqAnimationFrame(function() {

                checkScrolling(); // fire on scrolling via reqAnimateionFrame-Service

            });

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('whenInViewport', whenInViewport);


    /** @ngInject */
    function whenInViewport ($timeout, $window, $document) {
        var directive = {
            restrict: 'A',
            scope: true,
            link: linkFunc,
            controller: WhenInViewportController,
            controllerAs: 'vm',
            bindToController: {
                whenInViewport: '&',
                wivAt: '@', // can be top or bottom
                wivBuffer: '=?'
            }
        };

        return directive;


        function linkFunc (scope, element, attrs, vm) {


            var setProperties = function () {


                vm.positionTop = element[0].getBoundingClientRect().top + $window.pageYOffset;

                vm.height = element[0].offsetHeight;

                vm.bodyOffset = parseInt($window.getComputedStyle($document[0].body).getPropertyValue('padding-top'), 10);

                vm.winHeight = $window.innerHeight;
            };


            $timeout(setProperties, 0);


            scope.$on('dom::changed', setProperties);
        }


        /** @ngInject */
        function WhenInViewportController ($scope, reqAnimationFrame, $timeout) {


            var vm = this;


            if (!vm.wivAt) {

                vm.wivAt = 'top';
            }


            if (!vm.wivBuffer) {

                vm.wivBuffer = 50;
            }


            var buffer = vm.wivBuffer;


            var hasFired = false;


            var startWatcher = function () {


                reqAnimationFrame(function () {


                    var scrollPos = $window.pageYOffset;


                    var isInViewport;


                    switch (vm.wivAt) {

                        case 'top' :

                            isInViewport = scrollPos >= (vm.positionTop - vm.bodyOffset - buffer) && scrollPos < (vm.positionTop + vm.height - vm.bodyOffset - buffer);
                            break;


                        case 'bottom' :

                            isInViewport = scrollPos >= (vm.positionTop - vm.winHeight + buffer) && (scrollPos + vm.height) < (vm.positionTop + vm.height + buffer);
                            break;
                    }


                    if (isInViewport && !hasFired) {


                        hasFired = true;


                        vm.whenInViewport();


                        $scope.$apply();
                    }


                    if (!isInViewport) {

                        hasFired = false;
                    }
                });
            };


            $timeout(startWatcher, 0);
        }
    }
})();

/* global OpenSeadragon: false */

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiZoomimage', uiZoomimage);


    /** @ngInject */
    function uiZoomimage ($timeout) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-zoomimage/ui-zoomimage.html',
            scope: true,
            controller: UiZoomimageController,
            controllerAs: 'zi',
            link : linkFunc,
            bindToController: {
                options : "=",
                progress : "="
            },
            transclude: true
        };

        return directive;


        function linkFunc(scope, ele, attrs, vm) {


            vm.viewer = new OpenSeadragon({
               element: ele[0].querySelector('.ui-zoomimage__inner div'),
               tileSources: [vm.options.tiles],
               springStiffness : 15,
               showNavigationControl: false,
               mouseNavEnabled : false
           });

        //    window.v = vm.viewer;

           vm.viewer.addHandler("open", function() {

               // nicht schön, aber selten
               $timeout(function(){
                   vm.setZoom();
               },500);
           });
        }


        /** @ngInject */
        function UiZoomimageController ($scope, _) {


            var vm = this;


            var maxZoom = vm.options.maxZoom;


            vm.ratio = vm.options.height / vm.options.width;



            var viewportCenterOrigin = {
                x : vm.options.width / vm.options.width / 2,
                y : vm.options.height / vm.options.width / 2
            };


            var originCenter = new OpenSeadragon.Point(viewportCenterOrigin.x,viewportCenterOrigin.y);


            var viewportCenterOffset = {
                x : (vm.options.width + vm.options.offset.x) / vm.options.width / 2,
                y : (vm.options.height + vm.options.offset.y) / vm.options.width / 2
            };


            var newCenter = new OpenSeadragon.Point(viewportCenterOffset.x,viewportCenterOffset.y);


            if (vm.options.offsetEnd) {

                var viewportCenterOffsetEnd = {
                    x : (vm.options.width + vm.options.offsetEnd.x) / vm.options.width / 2,
                    y : (vm.options.height + vm.options.offsetEnd.y) / vm.options.width / 2
                };

                var newCenterEnd = new OpenSeadragon.Point(viewportCenterOffsetEnd.x,viewportCenterOffsetEnd.y);
            }


            vm.setZoom = function() {


                var f = 1;

                var hasTwoParts = !_.isUndefined(newCenterEnd);


                if (vm.progress) {


                    // start later, stop earlier
                    var progress = vm.progress * 1.6 - 0.2;


                    if (hasTwoParts) {

                        if(vm.progress > 0.5) {
                            progress = (1 - vm.progress) * 2 * 1.6 - 0.2;
                        }
                        else {
                            progress = vm.progress * 2 * 1.6 - 0.2;
                        }
                    }


                    f = 1 - (progress > 0 ? progress : 0);
                }


                // default (no) zoom is 1
                var newZoom = 1 + (f * maxZoom);



                if (newZoom >= 1) {

                    if (hasTwoParts && vm.progress > 0.5) {

                        vm.viewer.viewport.zoomTo(newZoom, newCenterEnd);
                    }
                    else {

                        vm.viewer.viewport.zoomTo(newZoom, newCenter);
                    }
                }
                else {

                    vm.viewer.viewport.zoomTo(1, originCenter);
                    vm.viewer.viewport.panTo(viewportCenterOrigin);
                }
            };



            $scope.$watch("zi.progress", function(newVal, oldVal){


                if (newVal !== oldVal) {

                    vm.setZoom();
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiZipper', uiZipper);


    /** @ngInject */
    function uiZipper ($timeout, $window, _) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-zipper/ui-zipper.html',
            scope: true,
            controller: UiZipperController,
            controllerAs: 'vm',
            link : linkFunc,
            bindToController: true,
            transclude: true
        };

        return directive;


        function linkFunc(scope, element, attrs, vm, transclude) {

            transclude(scope, function(clone) {

                var lines = clone[0].innerText.split(" | ");
                lines = _.without(_.map(lines, _.trim), "");

                vm.setupDom(lines);
            });

            var setProperties = function() {

                vm.positionTop = element[0].childNodes[0].getBoundingClientRect().top + $window.pageYOffset;
                vm.height = element[0].childNodes[0].offsetHeight;
                vm.winHeight = $window.innerHeight;
                vm.winWidth = $window.innerWidth;
                vm.words = element[0].querySelectorAll('.ui-zipper__word');

            };

            $timeout(setProperties, 0);

            scope.$on('dom::changed', setProperties);
        }

        /** @ngInject */
        function UiZipperController (reqAnimationFrame, $window) {

            var vm = this;

            vm.setupDom = function(lines) {

                vm.lines = [];

                _.each(lines, function(line, lineIndex){

                    var words = line.split(" ");

                    vm.lines[lineIndex] = [];

                    _.each(words, function(word, wordIndex, wordList){

                        var cssClass = "left";

                        if( (wordIndex + 1) > Math.ceil(wordList.length / 2) ) {
                            cssClass = "right";
                        }

                        vm.lines[lineIndex][wordIndex] = {
                            'word' : word,
                            'cssClass' : cssClass
                        };

                    });
                });

                reqAnimationFrame(setPositions);

            };


            var setPositions = function() {

                var scrollPos = $window.pageYOffset;
                var containerIsInViewport = scrollPos > vm.positionTop - vm.winHeight && scrollPos < vm.positionTop + vm.height;

                if(containerIsInViewport) {
                    _.each(vm.words, setPosition);
                }

            };


            var setPosition = function(ele) {

                // index in this line
                var i = parseInt(ele.attributes['data-index'].value, 10) + 1;

                var direction = -1;

                var factor = 0.2;
                var delayFactor = 1 - (factor * i);

                if (ele.className && ele.className.trim().split(/\s+/gi).indexOf('right') > -1) {
                    direction = 1;
                    delayFactor = factor * i;
                }


                var elePosTop = ele.getBoundingClientRect().top - (vm.winHeight * 0.1),
                    elePosRelative = elePosTop / vm.winHeight,
                    wayToGo = vm.winWidth / 2;

                var xShift = easeInCubic(elePosRelative) * delayFactor * wayToGo * direction;

                // set xShift to zero when at end
                if(! (direction === -1 && xShift < 0 || direction === 1 && xShift > 0)) {
                    xShift = 0;
                }

                var transform = "translate(" + xShift + "px, 0)";

                ele.style.transform = transform;
                ele.style['-ms-transform'] = transform;
            };


            // var easeInQuad = function(t) {
            //     return t*t;
            // };
            // var easeOutQuad = function (t) {
            //     return 1-easeInQuad(1-t);
            // };
            var easeInCubic = function(t) {
                return Math.pow(t,3);
            };

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiSocialicon', uiSocialicon);


    /** @ngInject */
    function uiSocialicon () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-socialicon/ui-socialicon.html',
            scope: true,
            replace: true,
            controller: UiSocialiconController,
            controllerAs: 'icon',
            link : linkFunc,
            bindToController: {
                type : '@',
                href : '@',
                theme : '@',
                newWindow : '=?'
            }
        };

        return directive;


        function linkFunc(scope, ele, attr, vm) {

            vm.link = ele[0].querySelector("a");
        }

        /** @ngInject */
        function UiSocialiconController (_) {

            var vm = this;

            if (_.isUndefined(vm.newWindow)) {
                vm.newWindow = true;
            }

            if(!vm.type){
                vm.type = 'tbd';
            }

            if(!vm.theme) {
                vm.theme = 'dark';
            }

            // if this is no real link, unfocus after click
            vm.blurCond = function() {

                if(!vm.href) {
                    vm.link.blur();
                }
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiScrollmove', uiScrollmove);


    /** @ngInject */
    function uiScrollmove ($timeout, $window) {
        var directive = {
            restrict: 'A',
            scope: true,
            controller: UiScrollmoveController,
            controllerAs: 'vm',
            link : linkFunc,
            bindToController: {
                uiScrollmove : '@',
                buffer : '=?',
                endAtY : '=?',
                endAtX : '=?',
                forcePosX : '=?'
            }
        };

        return directive;


        function linkFunc(scope, element, attrs, vm) {

            var setProperties = function() {

                vm.positionTop = element[0].getBoundingClientRect().top + $window.pageYOffset;
                vm.height = element[0].offsetHeight;
                vm.winHeight = $window.innerHeight;
                vm.winWidth = $window.innerWidth;
            };

            $timeout(setProperties, 0);

            scope.$on('dom::changed', setProperties);
        }

        /** @ngInject */
        function UiScrollmoveController (reqAnimationFrame, $element, _, $rootScope, $scope) {

            var vm = this;


            if(_.isUndefined(vm.endAtY)) {

                vm.endAtY = 0; // this defines on which height to end the animation, multiplyer for winHeight
            }

            if(_.isUndefined(vm.endAtX)) {

                vm.endAtX = 0; // this is rem shifting, from the center to left or right
            }

            if(_.isUndefined(vm.buffer)) {

                vm.buffer = 0;
            }


            var setPositions = function() {

                var scrollPos = $window.pageYOffset;
                var isInViewport = scrollPos > vm.positionTop - vm.winHeight - 50 && scrollPos < vm.positionTop + vm.height;

                if (isInViewport) {
                    $element.removeClass('trans');
                    setStyles($element[0]);
                }
            };


            var xShift;


            var setStyles = function(ele) {


                var direction = -1;

                if( vm.uiScrollmove === 'right' ) {
                    direction = 1;
                }


                var elePosTop = ele.getBoundingClientRect().top - (vm.winHeight * vm.endAtY),
                    elePosRelative = elePosTop / (vm.winHeight - vm.winHeight * vm.endAtY),
                    wayToGo = vm.winWidth / 2 + vm.buffer;


                xShift = easeInQuad(elePosRelative) * wayToGo * direction;

                // no more moving when top is reached

                if (elePosTop < 0) {

                    xShift = 0;
                }


                // adding the defined offset

                xShift = xShift / $rootScope.baseFontSize + vm.endAtX;


                // stay where you are when x is forced
                if (!vm.forcePosX) {

                    transformTo(ele, xShift);
                }
            };


            var transformTo = function(ele, xShift) {

                var transform = "translate(" + xShift + "rem, 0)";

                ele.style.transform = transform;
                ele.style['-ms-transform'] = transform;
            };


            var easeInQuad = function(t) {
                return t*t;
            };


            reqAnimationFrame(setPositions);


            $scope.$watch('vm.forcePosX', function(val){

                // when x is forced, immediately animate to this position

                if(!_.isUndefined(val) && val) {

                    $element.addClass('trans');
                    transformTo($element[0], (val));
                }
                else {

                    $element.addClass('trans');
                    transformTo($element[0], xShift);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiScrollfix', uiScrollfix);


    /** @ngInject */
    function uiScrollfix ($timeout, $window) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-scrollfix/ui-scrollfix.html',
            scope: true,
            controller: UiScrollfixController,
            controllerAs: 'sf',
            link : linkFunc,
            bindToController: {
                fixDuration : '=',
                progress : '=?',
                fixEdge : '@'
            },
            transclude: true
        };

        return directive;


        function linkFunc(scope, element, attrs, sf) {

            sf.inner = element[0].querySelector('.ui-scrollfix__content');


            var setProperties = function() {

                sf.positionTop = element[0].childNodes[0].getBoundingClientRect().top + $window.pageYOffset;
                sf.height = element[0].childNodes[0].offsetHeight;
                sf.innerHeight = sf.inner.offsetHeight;
                sf.winHeight = $window.innerHeight;
            };


            $timeout(setProperties, 0);

            scope.$on('dom::changed', setProperties);
        }



        /** @ngInject */
        function UiScrollfixController ($scope, reqAnimationFrame, $window) {

            var sf = this;

            sf.stylesOuter = {};
            sf.stylesInner = {};


            // fixDuration is noted in viewportHeight units (lik vh)
            var duration = sf.fixDuration / 100 * $window.innerHeight;

            sf.stylesOuter['padding-bottom'] = duration + 'px';


            var fixed = false;
            sf.progress = 0;



            reqAnimationFrame(function () {


                var containerIsInViewport = $window.pageYOffset > sf.positionTop - sf.winHeight && $window.pageYOffset < sf.positionTop + sf.height;

                if (containerIsInViewport) {
                    handleScrollfix();
                }
                else {
                    unfix();
                }

            });


            var handleScrollfix = function () {

                var topEdge = (sf.winHeight - sf.innerHeight) / 2; // trying to center the whole element on the screen


                if (sf.fixEdge === 'top') {

                    topEdge = sf.winHeight * 1/4; // stopping the top edge at the first quarter of the screen,
                }


                if (sf.fixEdge === 'bottom') {

                    topEdge = sf.innerHeight * -1 + sf.winHeight * 3/4; // stopping the bottom edge at the last quarter of the screen,
                }


                if (topEdge < 0 && sf.fixEdge !== 'bottom' && sf.fixEdge !== 'top') {

                    topEdge = 0; // when trying to center, don't stop top edge outside of viewport
                }



                var isAtTopEdge = $window.pageYOffset >= sf.positionTop - topEdge,
                    isAtBottomEdge = $window.pageYOffset >= sf.positionTop - topEdge + duration;


                if (isAtTopEdge && !isAtBottomEdge) {

                    sf.progress = ($window.pageYOffset - sf.positionTop + topEdge) / duration;

                    $scope.$apply();
                }


                // scrolling top down or bottom up, entering hot area

                if (isAtTopEdge && !isAtBottomEdge && !fixed) {

                    fixed = true;

                    sf.stylesOuter = {
                        'height' : sf.innerHeight + 'px',
                        'padding-bottom' : duration + 'px',
                        'padding-top' : 0
                    };

                    sf.stylesInner = {
                        position : 'fixed',
                        top: topEdge + 'px',
                        left: 0,
                        width: '100%'
                    };

                    $scope.$apply();
                }


                // scrolling bottom up, exiting hot area

                if (!isAtTopEdge && !isAtBottomEdge && fixed) {

                    fixed = false;

                    sf.stylesOuter.height = 'auto';
                    sf.stylesInner = {
                        position : 'relative',
                        top: 'auto',
                        left: 'auto',
                        width: 'auto'
                    };

                    sf.progress = 0;

                    $scope.$apply();
                }

                // scrolling top down, exiting hot area

                if (isAtBottomEdge && fixed) {

                    fixed = false;

                    sf.stylesOuter = {
                        'height' : 'auto',
                        'padding-bottom' : 0,
                        'padding-top' : duration + 'px'
                    };

                    sf.stylesInner = {
                        position : 'relative',
                        top: 'auto',
                        left: 'auto',
                        width: 'auto'
                    };

                    sf.progress = 1;

                    $scope.$apply();
                }
            };


            var unfix = function () {

                fixed = false;

                sf.stylesInner = {
                    position : 'relative',
                    top: 'auto',
                    left: 'auto',
                    width: 'auto'
                };

                $scope.$apply();
            };


        }
    }
})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiParallax', uiParallax);


    /** @ngInject */
    function uiParallax ($timeout) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-parallax/ui-parallax.html',
            scope: true,
            controller: UiParallaxController,
            link: linkFunc,
            controllerAs: 'vm',
            bindToController: {
                speed : "@"
            },
            transclude: true
        };

        return directive;


        function linkFunc(scope, element, attrs, vm){

            vm.ele = element[0].childNodes[0];

            var setProperties = function() {
                vm.offsetTop = vm.ele.offsetTop;
                vm.offsetHeight = vm.ele.offsetHeight;
            };


            $timeout(setProperties, 0);

            scope.$on('dom::changed', setProperties);

            vm.startParallaxing();

        }

        /** @ngInject */
        function UiParallaxController (reqAnimationFrame, $window) {

            var vm = this;

            if(!vm.speed) {
                vm.speed = 0.5;
            }

            vm.offsetTop = 0;
            vm.styles = {};

            vm.active = true;

            vm.startParallaxing = function() {


                reqAnimationFrame(function() {

                    var pixelsMoved = $window.pageYOffset - vm.offsetTop;

                    var x = 0;
                    var y = pixelsMoved * vm.speed * -1;
                    vm.styles.transform = "translate(" + x + "px, " + y + "px)";

                    if ($window.pageYOffset > vm.offsetHeight) {
                        vm.active = false;
                    }
                    else {
                        vm.active = true;
                    }
                });
            };
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('stdlDigits')
		.directive('uiMd', uiMd);


	/** @ngInject */
	function uiMd (Markdown) {
		var directive = {
			restrict: 'E',
			replace: true,
			// templateUrl: 'app/components/ui-img/ui-img.html',
			scope: {
				md: '='
			},
			link: linkFunc
		};

		return directive;


		function linkFunc (scope, element, attrs) {


			// create a pagedown converter - regular and sanitized versions are both supported
			var converter = new Markdown.Converter();


			// tell the converter to use Markdown Extra
			Markdown.Extra.init(converter);


			var unindent = function (text) {

				if (!text) { return text; }


				var lines = text
					.replace(/\t/g, '  ')
					.split(/\r?\n/);


				var min = null;


				var len = lines.length;


				for (var i = 0; i < len; i++) {

					var line = lines[i];

					var l = line.match(/^(\s*)/)[0].length;

					if (l === line.length) { continue; }

					min = (l < min || min === null) ? l : min;
				}


				if (min !== null && min > 0) {

					for (i = 0; i < len; i++) {

						lines[i] = lines[i].substr(min);
					}
				}


				return lines.join('\n');
			}


			var set = function (text) {

				text = unindent(text || '');

				element.html(converter.makeHtml(text));
			}


			set(scope.md || element.text() || '');


			if (attrs.md) {

				scope.$watch('md', set);
			}
		}
	}

})();

(function () {
    'use strict';

    angular
    .module('stdlDigits')
    .directive('uiMapline', uiMapline);


    /** @ngInject */
    function uiMapline () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-mapline/ui-mapline.html',
            scope: true,
            controller: UiMaplineController,
            controllerAs: 'ml',
            bindToController: {
                image : "@",
                progress : '='
            }
        };

        return directive;



        /** @ngInject */
        function UiMaplineController ($rootScope, $scope, $element) {

            var vm = this;

            var line = $element[0].querySelector('.ui-mapline__holder');


            vm.progressAcc = 1.3;


            $scope.$watch('ml.progress',function(val) {


                val = val * vm.progressAcc;

                var fullWidth = line.offsetWidth;


                if(val > 0 && val < 1) {

                    vm.lineLength = fullWidth * val / $rootScope.baseFontSize + 'rem';
                }

                if (val >= 1) {

                    vm.lineLength = fullWidth / $rootScope.baseFontSize + 'rem';
                }
                if (val <= 0) {

                    vm.lineLength = "0rem";
                }
            });
        }
    }

})();

(function () {
	'use strict';

	angular
		.module('stdlDigits')
		.directive('uiImg', uiImg);


	/** @ngInject */
	function uiImg ($window, $log, _, imgix, HOSTS, onImagesLoaded) {
		var directive = {
			restrict: 'AE',
			template: '<img ng-attr-alt="{{imgAlt}}"/><div class="loading" ng-if="loading"><b></b><b></b><b></b></div>',
			scope: {
				image: '@',
				crop: '@',
				cover: '=',
				fixedHeight : '=',
				rect : '@',
				onLoad : '&',
				alt : '@'
			},
			link: linkFunc
		};

		return directive;


		function linkFunc (scope, el) {



			// Select box

			var box = el[0];
			var img = box.children[0];


			// setup loading

			scope.loading = true;


			// tell the others when finished loading

			onImagesLoaded([img]).then(function () {

				if (!_.isUndefined(scope.onLoad) && _.isFunction(scope.onLoad)) {

					// avoid border arount image before load
					if (!_.isUndefined(scope.alt)) {

						scope.imgAlt = scope.alt;
					}

					// remove loading  animation
					scope.loading = false;

					// execute onload expression
					scope.onLoad();
				}
			});


			var roundByPx = 10;


			var image = _.debounce(function () {


				if (!scope.image || _.isUndefined(scope.image)) {

					return;
				}


				// Round the given dimensions

				var width = Math.ceil(box.offsetWidth/roundByPx) * roundByPx,
					height = Math.ceil(box.offsetHeight/roundByPx) * roundByPx;


				// Determine size

				var size = {
					w: scope.fixedHeight ? 'auto' : width,
					h: (scope.cover || scope.fixedHeight) ? height : 'auto'
				};


				if(size.w === 0 || size.h === 0) {
					return;
				}

				// create opts

				var opts = {
					w: size.w,
					h: size.h,
					auto: 'format',
					fm: 'jpg',
					fit: 'crop',
					crop: scope.crop || 'faces',
					dpr: ($window.devicePixelRatio ? $window.devicePixelRatio : 1)
				};

				if (scope.rect) {
					opts.rect = scope.rect;
				}


				// Generate image path

				var uri = new imgix.URL(HOSTS.imgix + scope.image, opts);


				// Set as source

				uri.attachImageTo(img);
			}, 100);


			// Listen for resize

			var reImage = function(){

				image();
				scope.$apply();
			};


			angular.element($window).bind('resize', reImage);

			scope.$on('$destroy', function () {

				angular.element($window).off('resize', reImage);
			});



			// init
			scope.$watch('image', image);
		}
	}

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiImagecarousel', uiImagecarousel);


    /** @ngInject */
    function uiImagecarousel () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-imagecarousel/ui-imagecarousel.html',
            scope: true,
            controller: UiImagecarouselController,
            controllerAs: 'vm',
            bindToController: {
                items : '=',
                type : '@',
                lang : '=',
                infinite : '=',
                ratio : '=?'
            }
        };

        return directive;

        /** @ngInject */
        function UiImagecarouselController ($log, $scope, rfc4122, $element, onImagesLoaded, egalizeHeight, _, bowser, $window, $timeout) {


            var vm = this;


            var isTouchDevice = !!('ontouchstart' in $window);


            var reallyInfinite = vm.infinite && (!bowser.msie && bowser.version.indexOf('9.') === -1) && !isTouchDevice;


            vm.slidesReady = false;


            vm.uuid = rfc4122.v4();



            if (angular.isUndefined(vm.type)) {

                vm.type = 'default';
            }

            if (angular.isUndefined(vm.ratio)) {

                vm.ratio = (406/458);
            }


            // setup first and last image for fake loop

            if (vm.items && vm.items.length > 0 && reallyInfinite) {

                var first = [vm.items[0]],
                    last = [vm.items[vm.items.length - 1]];

                vm.items = last.concat(vm.items).concat(first);
            }


            vm.carouselSwiperParams = {
                centeredSlides: true,
                initialSlide : reallyInfinite ? 1 : 0,
                loop : false,
                showNavButtons : false,
                slidesPerView : 'auto',
                spaceBetween : 24,
                paginationClickable : true,
                pagination: '.ui-imagecarousel__bullets--' + vm.uuid
            };


            vm.carouselSwiper =  {};



            vm.onReadySwiper = function (swiper) {


                update(swiper);


                swiper.on('slideChangeStart', function () {

                    update(swiper);
                });


                // click updates $scope, touch does not

                swiper.on('transitionEnd', function () {

                    $scope.$apply();
                });


                // outer bounds handling after touch movement

                if (reallyInfinite) {

                    swiper.on('slideChangeEnd', function (swiper) {

                        if(swiper.activeIndex === 0) {

                            // go to the one before last
                            swiper.slideTo(vm.items.length - 2, 0);
                        }

                        if(swiper.activeIndex === vm.items.length - 1) {

                            // go to the one after first
                            swiper.slideTo(1, 0);
                        }
                    });
                }
            };



            // click events

            vm.prev = function () {

                if(vm.carouselSwiper.activeIndex === 1 && reallyInfinite) {

                    // go to the one before last
                    vm.carouselSwiper.slideTo(vm.items.length - 2);
                }
                else {

                    vm.carouselSwiper.slidePrev();
                }
            };


            vm.next = function () {

                if(vm.carouselSwiper.activeIndex === vm.items.length - 2 && reallyInfinite) {

                    // go to the one after first
                    vm.carouselSwiper.slideTo(1);
                }
                else {

                    vm.carouselSwiper.slideNext();
                }
            };


            vm.goto = function(i) {

                vm.carouselSwiper.slideTo(i);
            };


            var update = function(swiper) {

                vm.isBeginning = swiper.isBeginning;
                vm.isEnd = swiper.isEnd;
                vm.activeIndex = swiper.activeIndex;
            };



            var egalizeCaptionHeight = function() {

                var captions = $element[0].querySelectorAll('figcaption');


                if(_.isUndefined(captions) || captions.length < 1) {

                    return;
                }

                _.each(captions, function(c){

                    c.style['min-height'] = 0; // reset
                    egalizeHeight.egalize(c.offsetHeight, 'caption-' + vm.uuid);
                });


                var minHeight = egalizeHeight.getHeightByGroup('caption-' + vm.uuid);


                _.each(captions, function(c){

                    c.style['min-height'] = minHeight + 'px';
                });
            };


            var setupNavButtons = function() {

                var referenceImg = $element[0].querySelector('figure div');

                vm.arrowsTop = referenceImg.offsetHeight / 2;
            };


            $timeout(function(){

                setupNavButtons();
                egalizeCaptionHeight();

            }, 100);


            angular.element(window).bind('resize', egalizeCaptionHeight);
            angular.element(window).bind('resize', setupNavButtons);

            $scope.$on("$destroy", function(){
                angular.element(window).off('resize', egalizeCaptionHeight);
                angular.element(window).off('resize', setupNavButtons);
            });



            $scope.$watch('vm.slidesReady', function (val) {

                if (val === true) {

                    var images = $element[0].querySelectorAll('img');

                    onImagesLoaded(images).then(function () {

                        // $log.debug('Imagecarousel-' + vm.uuid + ': images loaded');
                        vm.carouselSwiper.onResize();

                    }, function(error){

                        $log.debug(error);
                    });
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
    .module('stdlDigits')
    .directive('uiDropmore', uiDropmore);


    /** @ngInject */
    function uiDropmore ($timeout, _) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-dropmore/ui-dropmore.html',
            scope: true,
            controller: UiDropmoreController,
            link: linkFunc,
            controllerAs: 'dm',
            bindToController: {
                aniDir : "@?",
                color: "@",
                startPos : "=?",
                endPos : "=?"
            },
            transclude: true
        };

        return directive;


        function linkFunc(scope, element, attrs, vm){


            var updateInnerHeight = function(){

                var innerEle = element[0].querySelector('.ui-dropmore__inner');
                vm.innerHeight = innerEle.offsetHeight;
            };

            var lazyUpdateInnerHeight = _.debounce(updateInnerHeight, 300);


            $timeout(updateInnerHeight,0);

            angular.element(window).bind('resize', lazyUpdateInnerHeight);


            scope.$on("$destroy", function(){

                angular.element(window).off('resize', lazyUpdateInnerHeight);
            });
        }

        /** @ngInject */
        function UiDropmoreController ($element, $document, $window, BREAKPOINTS) {

            var vm = this;


            if (!vm.aniDir) {

                vm.aniDir = "left";
            }


            if (!vm.color) {

                vm.color = "dark";
            }

            vm.buttonStartPos = vm.startPos;
            vm.buttonEndPos = vm.endPos;

            // where the button sits when closed  in rem from the middle
            if (!vm.startPos || $window.innerWidth < BREAKPOINTS.mobile) {

                vm.buttonStartPos = 0; // default and mobile
            }


            // where the button sits when opened in rem from the middle

            if (!vm.endPos || $window.innerWidth < BREAKPOINTS.mobile) {

                vm.buttonEndPos = 8.6; // default and mobile
            }


            vm.state = 'closed';


            vm.innerHeight = 0;


            vm.toggle = function() {

                if(vm.state === 'open') {
                    vm.state = 'closed';
                    vm.forcedEndPos = false;
                }
                else {
                    vm.state = 'open';
                    vm.forcedEndPos = vm.buttonEndPos;
                }

                // if($element[0].getBoundingClientRect().top > $window.innerHeight/2 ) {
                //
                //     $document.scrollToElementAnimated($element[0], $window.innerHeight/3);
                // }
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiDragmove', uiDragmove);


    /** @ngInject */
    function uiDragmove () {
        var directive = {
            restrict: 'A',
            scope: true,
            link : linkFunc,
            controller: UiDragmoveController,
            controllerAs: 'vm',
            bindToController: {
                startX : '=?'
            }
        };

        return directive;


        function linkFunc(scope, element, attr, vm) {

            vm.originX = element[0].getBoundingClientRect().left;
            vm.originWidth = element[0].offsetWidth;

            vm.setupStart();
            vm.startWatcher();

        }

        /** @ngInject */
        function UiDragmoveController ($element, $log, $document, _, $window) {

            var vm = this;

            var isDragged = false,
                touchPoint = 0,
                startX;


            if (_.isUndefined(vm.startX)) {

                vm.startX = 50;
            }


            vm.setupStart = function() {

                startX = vm.startX/100 * $window.innerWidth - vm.originWidth/2;

                $element[0].style.position = 'relative';
                $element[0].style.left = startX + 'px';
            };



            vm.startWatcher = function() {

                angular.element($document).on('mousedown touchstart', function(e){

                    var clientX = e.clientX || e.touches[0].clientX;

                    isDragged = true;
                    touchPoint = clientX - $element[0].getBoundingClientRect().left;
                });

                angular.element($document).on('mouseup touchend', function(){

                    isDragged = false;
                });


                angular.element($element).on('mousemove touchmove', function(e){

                    e.preventDefault();

                    if (!e.clientX && !e.touches) {
                        return;
                    }

                    var clientX = e.clientX || e.touches[0].clientX;

                    if (isDragged) {

                        var newX = (vm.originX - clientX) * -1 - touchPoint - startX;

                        $element[0].style.transform = 'translate(' + newX + 'px, 0)';
                    }
                });
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiCheckDevice', uiCheckDevice);


    /** @ngInject */
    function uiCheckDevice () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-check-device/ui-check-device.html',
            scope: true,
            controller: UiCheckDeviceController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;


        /** @ngInject */
        function UiCheckDeviceController ($document, $log, bowser) {

            var vm = this;

            vm.testvar = true;


            var detectFeatures = function() {

                var hasAllFeatures = $document[0].createElement("detect").style.borderImage === "",
                    // isIE11 = bowser.msie && bowser.version.indexOf('11.') !== -1,
                    isIE10 = bowser.msie && bowser.version.indexOf('10.') !== -1;


                if (hasAllFeatures && !isIE10) {

                    vm.features = true;
                }
                else {

                    vm.features = false;
                }
            };

            vm.ratio = true;

            // initialization

            detectFeatures();
        }
    }
})();

(function () {
    'use strict';

    angular
    .module('stdlDigits')
    .directive('uiChaptercover', uiChaptercover);


    /** @ngInject */
    function uiChaptercover () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-chaptercover/ui-chaptercover.html',
            scope: true,
            controller: UiChaptercoverController,
            controllerAs: 'vm',
            transclude: true,
            bindToController: {
                img : '=',
                caption: '@',
                theme : '@',
                debug : '=',
                timeStart : '=',
                timeEnd : '='
            }
        };

        return directive;


        /** @ngInject */
        function UiChaptercoverController ($log, $scope, _, $element, reqAnimationFrame, $window) {

            var vm = this;

            if (_.isUndefined(vm.theme)) {

                vm.theme = 'dark';
            }


            vm.styles = {};


            vm.progress = 0;


            // setup the progressing measurement

            var progressor = $element[0].querySelector('.ui-chaptercover__progressor');

            var start = 66, // early start
                stop = -200 + 100; // this is because object is 300vh high


            start = start / 100 * $window.innerHeight;
            stop = stop / 100 * $window.innerHeight;


            reqAnimationFrame(function(){

                var pos = progressor.getBoundingClientRect().top;


                if(pos <= start && pos >= stop) {

                    vm.progress = 1 - (pos + Math.abs(stop)) / (start + Math.abs(stop));
                }
                if(pos > start) {
                    vm.progress = 0;
                }
                if(pos < stop) {
                    vm.progress = 1;
                }
            });



            // time defines a progress-point between 0 and 1

            // x and y are multipliers for transform x and y

            var keyframes_inner = [
                {
                    time : 0,
                    x : 0,
                    y : 1
                },
                {
                    time : 1,
                    x : 0,
                    y : 0
                }
            ];

            var keyframes_background = [
                {
                    time : 0,
                    x : -1,
                    y : 0
                },
                {
                    time : 0.8,
                    x : 0,
                    y : 0
                },
                {
                    time : 1,
                    x : 0,
                    y : 0
                }
            ];

            var keyframes_image = [
                {
                    time : 0,
                    x : 1,
                    y : 0
                },
                {
                    time : 0.8,
                    x : 0,
                    y : 0
                },
                {
                    time : 1,
                    x : 0,
                    y : 0
                }
            ];

            var keyframes_underlay = [
                {
                    time : 0,
                    opacity : 0
                },
                {
                    time : 0.8,
                    opacity : 0.75
                },
                {
                    time : 1,
                    opacity: 0
                }
            ];



            $scope.$watch('vm.progress', function(val){

                setStyles(val);

                if(val > 0 && val < 1) {
                    vm.active = true;
                }
                else {
                    vm.active = false;
                }

                if(val >= 1) {
                    vm.active = true;
                    vm.unfixed = true;
                }
                else {
                    vm.unfixed = false;
                }
            });



            var setStyles = function (val) {

                vm.styles.inner = getStyles(val, keyframes_inner);
                vm.styles.background = getStyles(val, keyframes_background);
                vm.styles.image = getStyles(val, keyframes_image);

                vm.styles.underlay = getStyles(val, keyframes_underlay);
            };




            var getStyles = function (p, keyframes) {


                var shiftX = 0,
                    shiftY = 0,
                    opacity = 0;


                var deltaX,
                    deltaY,
                    deltaOpacity;


                var hasXShift = !_.isUndefined(keyframes[0].x),
                    hasYShift = !_.isUndefined(keyframes[0].y),
                    hasOpacityChange = !_.isUndefined(keyframes[0].opacity);



                _.each(keyframes, function(kf, i){

                    var nextFrame = keyframes[i + 1] || keyframes[keyframes.length - 1];


                    if (hasXShift) {
                        deltaX = nextFrame.x - kf.x;
                    }

                    if (hasYShift) {
                        deltaY = nextFrame.y - kf.y;
                    }

                    if(hasOpacityChange) {
                        deltaOpacity = nextFrame.opacity - kf.opacity;
                    }


                    if (p >= kf.time && p <= nextFrame.time) {

                        var partProgress = (p - kf.time) / (nextFrame.time - kf.time);

                        if (hasXShift) {
                            shiftX = kf.x + partProgress * deltaX;
                        }
                        if (hasYShift) {
                            shiftY = kf.y + partProgress * deltaY;
                        }
                        if (hasOpacityChange) {
                            opacity = kf.opacity + partProgress * deltaOpacity;
                        }
                    }


                });


                // everything outer bounce

                if (p <= 0 ) {
                    shiftX = keyframes[0].x || 0;
                    shiftY = keyframes[0].y || 0;
                    opacity = keyframes[0].opacity || 0;
                }

                if (p >= 1 ) {
                    shiftX = keyframes[keyframes.length - 1].x || 0;
                    shiftY = keyframes[keyframes.length - 1].y || 0;
                    opacity = keyframes[keyframes.length - 1].opacity || 1;
                }


                var css = {
                    'transform' : 'translate(' + easeInCubic(shiftX) * 100 + '%, ' + easeInCubic(shiftY) * 100 + '%)'
                };


                if (hasOpacityChange) {
                    css.opacity = opacity;
                }


                return css;
            };



            var easeInCubic = function(t) {

                return Math.pow(t,3);
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiButton', uiButton);


    /** @ngInject */
    function uiButton () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-button/ui-button.html',
            scope: true,
            controller: UiButtonController,
            controllerAs: 'button',
            link: linkFunc,
            bindToController: {
                type: '@',
                text: '@',
                color: '@',
                ref: '@',
                state: '@'
            }
        };

        return directive;


        function linkFunc (scope, ele, attr, vm) {

            vm.link = ele[0].querySelector("a");
        }


        /** @ngInject */
        function UiButtonController () {

            var vm = this;


            if (!vm.type) {

                vm.type = 'default';
            }


            if (!vm.state) {

                vm.state = 'tbd';
            }


            // if this is no real link, unfocus after click

            vm.blurCond = function () {

                if (!vm.ref) {

                    vm.link.blur();
                }
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiBrand', uiBrand);


    /** @ngInject */
    function uiBrand ($window, $timeout, _) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-brand/ui-brand.html',
            scope: true,
            controller: UiBrandController,
            controllerAs: 'brand',
            bindToController: {
                brandTitle: '=',
                theme: '=',
                ref: '@',
                newWindow : '='
            }
        };

        return directive;


        /** @ngInject */
        function UiBrandController () {

            var vm = this;


            if (_.isUndefined(vm.theme)) {

                vm.theme = 'dark';
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('uiAudioplayer', uiAudioplayer);


    /** @ngInject */
    function uiAudioplayer () {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/ui-audioplayer/ui-audioplayer.html',
            scope: true,
            controller: UiAudioplayer,
            controllerAs: 'vm',
            bindToController: {
                audio: '@',
                title : '@'
            }
        };

        return directive;


        /** @ngInject */
        function UiAudioplayer ($scope, $element, $rootScope) {

            var vm = this;

            vm.isPlaying = false;

            vm.play = function(){


                // tell the other audioplayers, that we are playing now

                $rootScope.$broadcast('audioplayer::playing');

                $scope.player.play();
                vm.isPlaying = true;
            };


            vm.pause = function() {

                $scope.player.pause();
                vm.isPlaying = false;
            };


            // if another audioplayer starts playing

            $scope.$on('audioplayer::playing', function(){

                if(vm.isPlaying) {
                    vm.pause();
                }
            });


            // wait for player

            $scope.$watch('player', function(){

                initPlayer();
            });


            var initPlayer = function() {

                $scope.$watch('player.currentTime', function(){

                    updateProgress();
                });
            };


            vm.progress = 0;

            var updateProgress = function() {

                if($scope.player.duration && $scope.player.currentTime) {

                    vm.progress = $scope.player.currentTime / $scope.player.duration;
                }
            };


            vm.jumpToTime = function($event){

                var toTimePercentage = $event.clientX / $element[0].offsetWidth;

                var newTime = $scope.player.duration * toTimePercentage;

                $scope.player.seek(newTime);
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .service('sharing', sharing);

    /** @ngInject */
    function sharing($rootScope, $q) {


        var deferred = $q.defer();

        var lang = $rootScope.lang;

        var links = {};

        var data = {
            'url' : '',
            'hashtags' : '',
            'text' : {
                'de' : '',
                'en' : ''
            },
            'mailsubject' : {
                'de' : '',
                'en' : ''
            },
            'mailbody' :  {
                'de' : '',
                'en' : ''
            }
        };


        var setup = function(input) {

            data = input;

            links = {
                facebook : 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(data.url),
                pinterest : 'https://pinterest.com/pin/create/link/?url=' + encodeURIComponent(data.url) + '&description=' + encodeURIComponent(data.text[lang]),
                twitter : 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(data.text[lang]) + '&hashtags=' + encodeURIComponent(data.hashtags) + '&url=' + encodeURIComponent(data.url) + '&original_referer=' + encodeURIComponent(data.url),
                mail : 'mailto:?subject=' + encodeURIComponent(data.mailsubject[lang]) + '&body=' + encodeURIComponent(data.mailbody[lang])
            };

            deferred.resolve(links);
        };



        return {
            setup : setup,
            getLinks : deferred.promise
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('sameHeight', sameHeight);


    /** @ngInject */
    function sameHeight (egalizeHeight, $timeout, onImagesLoaded, _) {
        var directive = {
            restrict: 'A',
            scope: {
                sameHeight : "@"
            },
            link: function(scope, ele) {

                var group = scope.sameHeight;


                var getHeight = function() {

                    $timeout(function(){

                        var images = ele[0].querySelectorAll('img');

                        if( !_.isEmpty(images) ) {

                            onImagesLoaded(images).then(function () {

                                egalizeHeight.egalize(ele[0].offsetHeight, group);
                            });
                        }
                        else {

                            egalizeHeight.egalize(ele[0].offsetHeight, group);
                        }

                    },0);
                };


                getHeight();


                egalizeHeight.onChange(function(groups){

                    if (groups[group]) {
                        ele[0].style.minHeight = groups[group].height + 'px';
                    }
                });
            }
        };

        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .service('reqAnimationFrame', reqAnimationFrame);

    /** @ngInject */
    function reqAnimationFrame($window, $timeout, rfc4122, _) {

        // Detect request animation frame
        var reqAniFrame = $window.requestAnimationFrame ||
            $window.webkitRequestAnimationFrame ||
            $window.mozRequestAnimationFrame ||
            $window.msRequestAnimationFrame ||
            $window.oRequestAnimationFrame ||
            // IE Fallback, you can even fallback to onscroll
            function(callback){ $timeout(callback, 1000/60) ; };


            var AFLoopCallbacks = {};

            var collect = function(fn){
                var uuid = rfc4122.v4();
                AFLoopCallbacks[uuid] = fn;
            };

            var start = function(){

                var lastPos = $window.pageYOffset;

                var loop = function() {

                    if ($window.pageYOffset === lastPos) {
                        reqAniFrame(loop);
                        return false;
                    }
                    else{
                        lastPos = $window.pageYOffset;
                    }

                    _.each(AFLoopCallbacks, function(fn){
                        fn();
                    });

                    reqAniFrame(loop);

                };

                loop();

            };

            // start the loop
            $timeout(start, 0);


        return collect;


    }


})();

(function () {
    'use strict';

    angular
    .module('stdlDigits')
    .directive('remscaling', remscaling);


    /** @ngInject */
    function remscaling ($window, $timeout) {

        var directive = {
            restrict: 'A',
            scope: {
                remscaling : '=?'
            },
            controller: RemscalingController,
            link: RemscalingLinkFunc,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;


        function RemscalingLinkFunc (scope, el, attr, vm) {

            vm.rootElement = el[0];

            var baseFontSize = $window.getComputedStyle(vm.rootElement)['font-size'];
            vm.baseFontSize = parseInt(baseFontSize, 10);

            $timeout(function() {
                vm.calculateRem();
            }, 0);


            angular.element($window).bind("resize", vm.calculateRem);
        }


        /** @ngInject */
        function RemscalingController ($rootScope, BREAKPOINTS) {

            var vm = this;

            var defaultWidthDesktop = 1280,
                maxWidthDesktop = 1440,
                defaultWidthMobile = 320,
                maxWidthMobile = BREAKPOINTS.mobile - 1;

            var maxWidth = maxWidthDesktop,
                minWidth = defaultWidthMobile;


            vm.calculateRem = function () {


                var currentWidth = $window.innerWidth,
                    newWidth = currentWidth;


                // limit on small widths

                if (currentWidth <= minWidth) {
                    newWidth = minWidth;
                }


                // limit on large widths

                if(currentWidth >= maxWidth) {
                    newWidth = maxWidth;
                }

                // check if we are on mobile or desktop

                var targetWidth = defaultWidthMobile;

                if (currentWidth > maxWidthMobile) {

                    targetWidth = defaultWidthDesktop;
                }


                var newFontSize = newWidth / targetWidth * vm.baseFontSize;

                vm.rootElement.style.fontSize = newFontSize + 'px';
                $rootScope.baseFontSize = newFontSize;
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('onLastRepeat', onLastRepeat);


    /** @ngInject */
    function onLastRepeat ($timeout) {
        var directive = {
            restrict: 'A',
            scope: true,
            controller: OnLastRepeatController,
            link: linkFunc,
            controllerAs: 'vm',
            bindToController: {
                onLastRepeat : '&'
            }
        };

        function linkFunc(scope, ele, attr, vm) {

            if (scope.$last) {

                $timeout(function(){
                    vm.onLastRepeat();
                },1);

            }
        }

        function OnLastRepeatController () {

            var vm = this;

            vm.testvar = true;

        }


        return directive;

    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .service('onImagesLoaded', onImagesLoaded);

    /** @ngInject */
    function onImagesLoaded($timeout, $q, _) {


        var run = function (images) {

            var loadedImages = 0;

            var deferred = $q.defer();


            if (angular.isUndefined(images) || images.length < 1) {

                deferred.reject('No images defined or found');
            }


            $timeout(function () {

                _.each (images, function (i) {

                    if (i.src && i.src !== "" && i.complete) {

                        loadedImages++;

                        if (loadedImages === images.length) {

                            deferred.resolve('Images loaded');
                        }
                    }
                    else {

                        i.addEventListener('load', function (){

                            loadedImages++;

                            if (loadedImages === images.length) {

                                deferred.resolve('Images loaded');
                            }
                        });
                    }
                });
            },1);


            return deferred.promise;
        };


        return run;


    }


})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .service('egalizeHeight', egalizeHeight);

    /** @ngInject */
    function egalizeHeight(_) {

        var groups = {};

        var callbacks = [];


        var egalize = function (height, group) {


            if (_.isUndefined(group)) {
                // when theres no group, theres nothing to do
                return;
            }

            if (groups[group] && groups[group].height) {

                // when theres a group and a existing height, compare
                if (height > groups[group].height ) {

                    groups[group].height = height;
                }
            }
            else {

                // when this is the first time, create group and first height
                groups[group] = {
                    'height' : height
                };
            }


            _.each(callbacks, function(cb){

                if(_.isFunction(cb)) {
                    cb(groups);
                }
            });
        };


        var getHeightByGroup = function(group) {

            if(groups[group]) {
                return groups[group].height;
            }
        };



        var onChange = function(cb) {

            if(_.isFunction(cb)) {
                callbacks.push(cb);
            }
        };


        return {
            egalize : egalize,
            getHeightByGroup : getHeightByGroup,
            onChange : onChange
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('broadcastDomchange', broadcastDomchange);


    /** @ngInject */
    function broadcastDomchange ($rootScope, $document, $window, _) {
        var directive = {
            restrict: 'A',
            scope: true,
            link: function(scope) {

                var fireDomchangeNotification = function() {

                    $rootScope.$broadcast('dom::changed');
                };


                // watch for resized bodyheight due to new elements and stuff
                // only fired when $apply() is running (and rightly so)

                scope.$watch(function(){

                    return $document[0].body.offsetHeight;

                }, function(newVal, oldVal){

                    if(newVal !== oldVal) {
                        fireDomchangeNotification();
                    }
                });

                // watch for resized window

                var debouncedFireDomchangeNotification = _.debounce(fireDomchangeNotification, 150);

                angular.element($window).bind('resize', debouncedFireDomchangeNotification);

                scope.$on('$destroy', function() {

                    angular.element($window).off('resize', debouncedFireDomchangeNotification);
                });

            }
        };

        return directive;

    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('bowserClasses', bowserClasses);


    /** @ngInject */
    function bowserClasses (bowser) {

        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;


        function linkFunc (scope, el) {

            var classes = [];


            // browsers

            if (bowser.msie) {
                classes.push('msie');
            }

            if (bowser.chrome) {
                classes.push('chrome');
            }

            if (bowser.firefox) {
                classes.push('firefox');
            }

            if (bowser.msedge) {
                classes.push('msedge');
            }

            if (bowser.safari) {
                classes.push('safari');
            }

            if (bowser.opera) {
                classes.push('opera');
            }


            // os

            if (bowser.mac) {
                classes.push('mac');
            }

            if (bowser.linux) {
                classes.push('linux');
            }

            if (bowser.chromeos) {
                classes.push('chromeos');
            }

            if (bowser.android) {
                classes.push('android');
            }

            if (bowser.ios) {
                classes.push('ios');
            }

            if (bowser.firefoxos) {
                classes.push('firefoxos');
            }

            var osVersion = bowser.osversion ? bowser.osversion.replace('.', '-') : '';


            // browser names and version

            var browserName = bowser.name.replace(' ', '_').toLowerCase();
            var browserVersion = bowser.version.replace('.', '_');


            // add all those classes

            el.addClass(classes.join(', '))
                .addClass(browserName)
                .addClass('ver-' + browserVersion);

            if (osVersion !== '') {
                el.addClass('os-' + osVersion);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .controller('MainController', MainController);


    /** @ngInject */
    function MainController ($state, $window, $rootScope, sharing, $timeout) {

        var vm = this;


        vm.lang = $rootScope.lang;

        vm.en = vm.lang === 'en';
        vm.de = vm.lang === 'de';


        vm.reload = function(l) {

            $state.go($state.current, {lang : l}, {reload: true});

            $timeout(function(){
                $window.location.reload();
            },0);
        };


        sharing.getLinks.then(function(links){

            vm.sharing = links;
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .directive('digitBaselitzFooter', digitBaselitzFooter);


    /** @ngInject */
    function digitBaselitzFooter () {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/digit-baselitz-footer/digit-baselitz-footer.html',
            scope: true,
            transclude: {
                'copyrights': 'copyrights',
                'legals' : 'legals'
            },
            controller: DigitBaselitzFooterController,
            controllerAs: 'vm',
            bindToController: {
                showCopyrights : '='
            }
        };

        return directive;


        /** @ngInject */
        function DigitBaselitzFooterController (_, $timeout, $element, reqAnimationFrame, $window) {


            var vm = this;

            // initial
            vm.context = 'bottom';

            vm.showSidebar = false;


            var setupContainerHeight = function () {

                var inner = $element[0].querySelector('.digit-footer__inner-content');

                vm.outerHeight = inner.offsetHeight;
            };


            var setContext = function () {

                var threshold = $window.innerHeight * 1.2;

                if ($element[0].getBoundingClientRect().top < threshold) {

                    vm.context = 'bottom';
                }
                else {

                    vm.context = 'sidebar';
                }

            };


            $timeout(function(){

                setupContainerHeight();

                setContext();
                reqAnimationFrame(setContext);

            }, 100);
        }
    }

})();

(function () {
    'use strict';

    angular
    .module('stdlDigits')
    .directive('digitBaselitz', digitBaselitz);


    /** @ngInject */
    function digitBaselitz () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/digit-baselitz/digit-baselitz.html',
            scope: true,
            controller: DigitBaselitzController,
            controllerAs: 'digit',
            bindToController: true
        };

        return directive;



        /** @ngInject */
        function DigitBaselitzController ($rootScope, $document, $timeout, sharing, HOSTS) {


            var vm = this;


            // F O O T N O T E   H A N D L I N G

            vm.gotoFootnote = function(e) {

                e.preventDefault();

                vm.showCopyrights = true;


                var href = e.target.getAttribute('href'),
                    target = angular.element($document[0].querySelector(href));


                $timeout(function(){

                    $document.scrollToElementAnimated(target);
                }, 100);
            };



            // S E T U P   M E T A   A N D   S H A R I N G   I N F O R M A T I O N

            $rootScope.meta = {
                'url' : 'http://baselitz.staedelmuseum.de',
                'title' : {
                    'de' : 'Georg Baselitz im Städel Museum',
                    'en' : 'Georg Baselitz at the Städel Museum'
                },
                'description' : {
                    'de' : 'Georg Baselitz. Die Helden. Die große Sonderausstellung vom 30. Juni bis 23. Oktober im Städel Museum in Frankfurt am Main. Georg Baselitz, Ein neuer Typ (Detail), um 1966, Privatbesitz, &copy; Georg Baselitz, 2016',
                    'en' : 'Georg Baselitz. The Heroes. The major special exhibition from June 30th until October 23th at the Städel Museum in Frankfurt am Main. Georg Baselitz, Ein neuer Typ (Detail), um 1966, Privatbesitz, &copy; Georg Baselitz, 2016'
                },
                'keywords' : {
                    'de' : 'Städel, Staedel, Städel Musuem, Digitorial, Baselitz, Georg Baselitz, Kunstmuseum, Kunstausstellung, Helden, Kunst der 60er Jahre, deutsche Kunst, Nachkriegskunst',
                    'en' : 'Städel, Staedel, Städel Musuem, Digitorial, Baselitz, Georg Baselitz, Kunstmuseum, Kunstausstellung, Helden, Kunst der 60er Jahre, deutsche Kunst, Nachkriegskunst'
                },
                'image' : HOSTS.imgix + 'ein-neuer-typ_gb_m_1965_00_00_42.jpg?crop=top&fit=crop&h=740&w=1200'
            };


            sharing.setup({
                'url' : 'http://baselitz.staedelmuseum.de',
                'hashtags' : 'baselitz, staedel',
                'text' : {
                    'de' : 'Georg Baselitz. Die Helden (30.6. bis 23.10.). Die Sonderausstellung  im Städel Museum.',
                    'en' : 'The special exhibition from June 30th until October 23th at the Städel Museum.'
                },
                'mailsubject' : {
                    'de' : 'Georg Baselitz im Städel Museum',
                    'en' : 'Georg Baselitz at the Städel Museum'
                },
                'mailbody' :  {
                    'de' : 'Entdecken Sie das Digitorial zur großen Sonderausstellung „Georg Baselitz. Die Helden“\n\nhttp://www.baselitz.staedelmuseum.de\n\nViel Spaß beim Betrachten und Entdecken der dramatischen und widersprüchlichen „Helden“-Bilder.',
                    'en' : 'Be the first to discover the Digitorial for the exhibition “Georg Baselitz. The Heroes”\n\nhttp://baselitz.staedelmuseum.de/en/\n\nWe hope you enjoy discovering Baselitz’ dramatic and paradoxical Hero paintings.'
                }
            });




            // C O N T E N T   F O R   I M A G E C A R O U S E L S   A N D   Z O O M I M A G E S


            vm.carousel1 = [
                {
                    img : 'szphoto-h-00101458.jpg',
                    caption : {
                        'de' : 'Deutsche Vertriebene aus den ehemaligen Ostgebieten',
                        'en' : 'German expellees from the former Eastern territories'
                    },
                    text :  {
                        'de' : 'Auch Flucht und Vertreibung gehören zum Ost-West-Konflikt. Durch die nach Kriegsende veränderten Grenzlinien müssen rund 14 Millionen Menschen ab 1945 ihre Heimat verlassen. Sie werden bei Familien oder in Notunterkünften in ganz Deutschland zwangsuntergebracht. Der im zerstörten Land ohnehin begrenzte Wohnraum und die schlechte Lebensmittelversorgung führen zu einer aufgeheizten Stimmung innerhalb der Bevölkerung.',
                        'en' : 'Flight and forced migration were further symptoms of the conflict between East and West. National borders were redrawn after the war, causing some fourteen million to leave their native regions in the years that followed. They had to live with families or in emergency accommodations all over Germany. There was already a shortage of living space in the destroyed country even without the newcomers. That and the poor food supply led to a heated atmosphere among the people.'
                    }
                },
                {
                    img : 'szphoto-h-00103459.jpg',
                    caption : {
                        'de' : 'Lebensmittelration in Deutschland, 1947',
                        'en' : 'Daily food ration in Germany, 1947'
                    },
                    text :  {
                        'de' : 'Nach dem Krieg sind die Lebensmittelreserven aufgebraucht und viele landwirtschaftliche Flächen nicht mehr nutzbar. Das Essen ist streng rationiert und nur im Tausch gegen Lebensmittelkarten erhältlich. 1946 stehen einem Erwachsenen pro Tag rund 1450 Kalorien zu.',
                        'en' : 'After the war, food reserves were depleted and vast areas of farmland unfit for use. Food was strictly rationed and available only in exchange for ration cards. In 1946, an adult was entitled to about 1,450 calories per day.'
                    }
                },
                {
                    img : 'szphoto-h-00006380.jpg',
                    caption : {
                        'de' : 'Kriegsversehrter mit Tochter, 1951',
                        'en' : 'War invalid with his daughter, 1951'
                    },
                    text :  {
                        'de' : 'Kriegsversehrte bestimmen das Alltagsbild. Soldaten wie auch Zivilisten zählen zu den Verwundeten. Abgerissene Gliedmaßen, Hör- und Sehschädigungen, aber auch psychische Beeinträchtigungen sind die Folge. Viele der Kriegsversehrten sind gezwungen, auf der Straße um Almosen zu betteln.',
                        'en' : 'War invalids were everywhere to be seen. Not only veterans but also many civilians were among the wounded. There were people with missing limbs, hearing and vision impairments, but also mental and emotional disorders. Many invalids had no choice but to beg for alms on the street.'
                    }
                },

                {
                    img : 'szphoto-h-00601617.jpg',
                    caption : {
                        'de' : 'Zerstörtes Dresden nach dem Zweiten Weltkrieg, 1945',
                        'en' : 'Ruins of Dresden after World War II, 1945'
                    },
                    text :  {
                        'de' : 'Weit mehr als die Hälfte des Wohnraums in deutschen Städten ist den Bomben zum Opfer gefallen. Zahlreiche Brücken und wichtige Verkehrswege sind zerstört. Es gilt, die Trümmer zu beseitigen und die zerstörten Häuser wieder aufzubauen. ',
                        'en' : 'Bombs had destroyed more than half of the living space in the German cities. Countless bridges and important traffic routes lay in ruins. The first priority was to remove the rubble and reconstruct the destroyed houses.'
                    }
                }
            ];

            vm.carousel2 = [
                {
                    img : 'der-moderne-maler_gb_m_1965_00_00_48.jpg',
                    caption : {
                        'de' : 'Georg Baselitz, Der moderne Maler, 1965, Öl auf Leinwand, 162 x 130 cm, Privatbesitz',
                        'en' : 'Georg Baselitz, The Modern Painter, 1965, oil on canvas, 162 x 130 cm, Privately owned'
                    },
                    text :  {
                        'de' : 'Beinahe alle Gemälde haben das Format 162 x 130 cm. Die schlammigen Grau- und Ockertöne sind den Uniformfarben entnommen und werden mit einem Borstenpinsel ohne Vorzeichnung grob aufgetragen',
                        'en' : 'Nearly all of the paintings measure 162 by 130 centimetres. The muddy shades of grey and ochre were a reference to the colours of uniforms; the artist applied them coarsely with a bristle brush – without preliminary drawings.'
                    }
                },
                {
                    img : 'der-neue-typ_gb_m_1965_00_00_25.jpg',
                    caption : {
                        'de' : 'Georg Baselitz, Der neue Typ, 1965, Öl auf Leinwand, 162 x 130 cm, Sammlung Froehlich, Stuttgart',
                        'en' : 'Georg Baselitz, The New Type, 1965, oil on canvas, 162 x 130 cm, Froehlich Collection, Stuttgart'
                    },
                    text :  {
                        'de' : 'Verletzt, abgerissene Gliedmaßen, in Fallen gefangen, blutend oder mit Wundmalen an den Händen: Die Dargestellten sind in großer Not und fast durchweg versehrt. Sie stehen in Widerspruch zum allgemein gängigen Heldenbild.',
                        'en' : 'Injured, limbs torn off, caught in traps, bleeding or with stigmata on their hands: the figures are in great distress and almost all of them maimed in some way. They contrast starkly with the general conception of how to depict a hero.'
                    }
                },
                {
                    img : 'partisan_gb_m-1965_00_00_27.jpg',
                    caption : {
                        'de' : 'Georg Baselitz, Partisan, 1965, Öl auf Leinwand, 162 x 130 cm, Collection of Lisa and Steven Tananbaum',
                        'en' : 'Georg Baselitz, Partisan, 1965, oil on canvas, 162 x 130 cm, Collection of Lisa and Steven Tananbaum'
                    },
                    text :  {
                        'de' : 'Die Leinwand ist beinahe komplett mit den Figuren ausgefüllt, die mittig darauf platziert sind. Meist zeigt Baselitz seine Figuren so, als würde man von unten zu ihnen aufblicken. Der Kopf ist daher oft kleiner als der Körper dargestellt.',
                        'en' : 'The centrally placed figures fill the canvasses almost completely. Baselitz usually painted them in such a way as to suggest that the viewer is looking up at them from below. As a result, the head is often disproportionately small. '
                    }
                },
                {
                    img : 'ohne-titel_gb_m_1965_00_00_37_oleski.jpg',
                    caption : {
                        'de' : 'Georg Baselitz, Ohne Titel, 1965, Öl auf Leinwand, 101 x 80 cm, Privatbesitz',
                        'en' : 'Georg Baselitz, Untitled, 1965, oil on canvas, 101 x 80 cm, Privately owned'
                    },
                    text :  {
                        'de' : 'Mann oder Frau? Das ist häufig nicht genau erkennbar. Selbst wenn männliche Geschlechtsorgane sichtbar sind, könnten die Gesichtszüge auch auf eine Frau hinweisen.',
                        'en' : 'Man or woman? Often you can’t tell for sure. Even if the figure displays male sexual organs, the facial features can be feminine in appearance.'
                    }
                },
                {
                    img : 'verschiedene-zeichen_gb_m_1965_00_00_49.jpg',
                    caption : {
                        'de' : 'Georg Baselitz, Verschiedene Zeichen, 1965, Öl auf Leinwand, 162 x 130 cm, Fondation Beyeler, Riehen/Basel, Sammlung Beyeler',
                        'en' : 'Georg Baselitz, Different Signs, 1965, oil on canvas, 162 x 130 cm, Fondation Beyeler, Riehen/Basel, Collection Beyeler'
                    },
                    text :  {
                        'de' : 'Tornister, Flagge oder Werkzeuge: Die Dargestellten führen verschiedene Objekte mit sich. Einige davon verweisen auf Baselitz‘ Kindheit auf dem Land, andere auf den Beruf eines Malers. In ihrer Kombination haben sie eine irritierende Wirkung.',
                        'en' : 'Haversack, flag, tools: the protagonists carry various objects with them. Some of these attributes refer to Baselitz’s rural childhood, others to the painting profession. In combination, they have a disconcerting effect.'
                    }
                },
                {
                    img : 'ein-versperrter_gb_m_1965_00_00_50_oleski.jpg',
                    caption : {
                        'de' : 'Georg Baselitz, Ein Versperrter, 1965, Öl auf Leinwand, 162 x 130 cm, Kunsthalle Bielefeld',
                        'en' : 'Georg Baselitz, A Blocked One, 1965, oil on canvas, 162 x 130 cm, Kunsthalle Bielefeld '
                    },
                    text :  {
                        'de' : 'Die Kleidung erinnert an Uniformen. Sie sind löchrig und zerschlissen, es fehlen Ärmel oder Beine. Welcher Nationalität die Menschen sind, die sie tragen, ist nicht erkennbar.',
                        'en' : 'The clothing is reminiscent of uniforms. It is worn out and full of holes; sleeves and trouser legs are missing. It is impossible to identify the nationalities of the people wearing it.'
                    }
                }
            ];



            vm.zoomImg2 = {

                width : 461,
                height: 589,
                maxZoom : 5,
                offset : {
                    x : 75,
                    y : -589
                },
                tiles : "assets/dzi/versperrter_maler_gb_m_1966_00_00_02.dzi"

            };

            vm.zoomImg3 = {

                width : 466,
                height: 618,
                maxZoom : 1.6,
                offset : {
                    x : -40,
                    y : -200
                },
                tiles : "assets/dzi/grossenachtimeimer.dzi"

            };

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .run(runBlock);


    /** @ngInject */
    function runBlock (FastClick, $window, $document, $log, $rootScope, $stateParams, LANGUAGES, Modernizr) {


        // don't let the browser get in our way

        // $window.history.scrollRestauration = 'manual';

        // Check for outdated Browser

        $rootScope.isOutdatedBrowser = !Modernizr.boxshadow;


        // Apply Fastclick

        FastClick.attach($document[0].body);


        // get all those juicy meta informations from context



        var metaData = $rootScope.$on('$stateChangeSuccess', function () {
            if ($stateParams.lang && LANGUAGES.indexOf($stateParams.lang) !== -1) {

                $rootScope.lang = $stateParams.lang;
            }
            else {

                $rootScope.lang = LANGUAGES[0];
            }
        });

        $rootScope.$on('$destroy', metaData);



        $log.debug('runBlock end');
    }
})();

(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .config(routerConfig);


    /** @ngInject */
    function routerConfig ($stateProvider, $urlRouterProvider) {

        $stateProvider
            .state('home', {
                url: '/:lang',
                templateUrl: 'app/main/main.html',
                controller: 'MainController',
                controllerAs: 'main',
                cache: false
            });

        $urlRouterProvider.otherwise('/home');
    }

})();

/* global _:false */
/* global FastClick:false */
/* global imgix:false */
/* global Markdown:false */
/* global Modernizr:false */
(function () {
    'use strict';

    angular
        .module('stdlDigits')
        .constant('_', _)
        .constant('FastClick', FastClick)
        .constant('imgix', imgix)
        .constant('Markdown', Markdown)
        .constant('FORCE_LINEAR', false)
        .constant('Modernizr', Modernizr)
        .constant('HOSTS', {
            imgix: 'https://dne.staedel.de/_api/_520/img/baselitz/'
        })
        .constant('BREAKPOINTS', {
            mobile: 600
        })
        .constant('LANGUAGES',['de','en']); // first one is default
})();

(function () {
    'use strict';

    angular
    .module('stdlDigits')
    .config(config);


    /** @ngInject */
    function config ($locationProvider, $logProvider, HOSTS, RestangularProvider) {


        // Enable HTML5 mode

        $locationProvider.html5Mode(true);


        // Enable log

        $logProvider.debugEnabled(false);


        // API base URI

        RestangularProvider.setBaseUrl(HOSTS.api);
    }


    angular.module('stdlDigits')
    .value('mp.throttleSettings', {
        enabled: true,
        time: 100
    });

})();

angular.module("stdlDigits").run(["$templateCache", function($templateCache) {$templateCache.put("app/digit-baselitz/digit-baselitz-copyrights-de.html","<div class=\"g-row g-drop-2 g-push-2\"><div class=\"g-col-12\"><h3>BILDNACHWEISE</h3><p>Georg Baselitz, Ein Versperrter, 1965<br>Öl auf Leinwand, 162 x 130 cm<br>Kunsthalle Bielefeld<br>&copy; Georg Baselitz 2016, Foto: Frank Oleski, Köln</p><p>Georg Baselitz, Falle, 1966<br>Öl auf Leinwand, 162 x 130 cm<br>Collection Fielding Mellish<br>&copy; Georg Baselitz 2016, Foto: Frank Oleski, Köln</p><p>Georg Baselitz, Der Held, 1965<br>Öl auf Leinwand, 120 x 105 cm<br>Privatsammlung<br>&copy; Georg Baselitz 2016, Foto: Frank Oleski, Köln</p><p>Georg Baselitz, Acker, 1962<br>Öl auf Leinwand, 139 x 189 cm<br>Städel Museum, Frankfurt am Main<br>&copy; Georg Baselitz 2016,Foto: Städel Museum, Frankfurt am Main, ARTOTHEK</p><p>Georg Baselitz, Versperrter Maler, 1965<br>Öl auf Leinwand, 162 x 130 cm<br>MKM Museum Küppersmühle für Moderne Kunst, Duisburg, Sammlung Ströher<br>&copy; Georg Baselitz 2016, Foto: Archiv Sammlung Ströher</p><p>Georg Baselitz, Die große Nacht im Eimer, 1962 – 1963, Öl auf Leinwand, 250 x 180 cm, Museum Ludwig, Köln<br>&copy; Georg Baselitz 2016, Foto: Jochen Littkemann, Berlin</p><p>Jacopo Pontormo (nach einem Entwurf von Michelangelo Buonarotti), Venus und Amor, um 1533<br>Öl auf Holz, 128 x 194 cm<br>Florenz, Galleria dell‘ Accademia<br>Foto: Antonio Quattrone</p><p>Giuseppe Maria Mitelli, Ein ambulanter Medizin-Händer tritt mit einer Schlange auf der Bühne auf, um seine Waren zum Verkauf anzubieten<br>Radierung, 28,1 x 19,7 cm</p><p>Gian Giacomo Caraglio, Diogenes<br>Kupferstich, 28,4 x 21,7 cm<br>Genf, Cabinet des estampes (Sammlung Georg Baselitz), Album Spencer<br>Genf, Cabinet des estampes (Sammlung Georg Baselitz) (Peter Ertl, Albertina)</p><p>Georg Baselitz, Der moderne Maler, 1965<br>Öl auf Leinwand, 162 x 130 cm<br>Privatbesitz<br>&copy; Georg Baselitz 2016, Foto: Frank Oleski, Köln</p><p>Georg Baselitz, Der neue Typ, 1965<br>Öl auf Leinwand, 162x130 cm<br>Sammlung Froehlich, Stuttgart<br>&copy; Georg Baselitz 2016, Foto: Archiv Sammlung Froehlich, Stuttgart</p><p>Georg Baselitz, Partisan, 1965<br>Öl auf Leinwand, 162 x 130 cm<br>Collection of Lisa and Steven Tananbaum<br>&copy; Georg Baselitz 2016</p><p>Georg Baselitz, Ohne Titel, 1965<br>Öl auf Leinwand, 101 x 80 cm<br>Privatbesitz<br>&copy; Georg Baselitz 2016, Foto: Jochen Littkemann, Berlin</p><p>Georg Baselitz, Verschiedene Zeichen, 1965<br>Öl auf Leinwand, 162 x 130 cm<br>Fondation Beyeler, Riehen/Basel, Sammlung Beyeler<br>&copy; Georg Baselitz 2016, Foto: Peter Schibli, Basel</p><p>Georg Baselitz, Ohne Titel, 1965<br>Tuschfeder und Tusche laviert auf Papier, 39 x 26,3 cm<br>Sammlung Ludwig, Ludwig Forum für internationale Kunst, Aachen<br>&copy; Georg Baselitz 2016, Foto: Anne Gold, Aachen</p><p>Georg Baselitz, Die großen Freunde, 1965<br>Öl auf Leinwand, 250 x 300 cm<br>Museum Ludwig Köln<br>&copy; Georg Baselitz 2016, Foto: Frank Oleski, Köln</p><p>Georg Baselitz, Ein neuer Typ, 1966<br>Öl auf Leinwand, 162 x 130 cm<br>Privatbesitz<br>&copy; Georg Baselitz 2016, Foto: Frank Oleski, Köln</p><p>Georg Baselitz, 3. Kopf, 1966<br>Öl auf Leinwand, 100 x 81 cm<br>Privatbesitz<br>&copy; Georg Baselitz 2016, Foto: Jochen Littkemann, Berlin</p><p>Georg Baselitz, Gr. Nacht im Eimer – Heimat, 1966<br>Öl auf Leinwand, 180 x 140 cm<br>Privatbesitz<br>&copy; Georg Baselitz 2016, Foto: Jochen Littkemann, Berlin</p><h3>FOTOGRAFIEN</h3><p>Deutsche Vertriebene aus den ehemaligen Ostgebieten<br>Foto: Süddeutsche Zeitung Photo</p><p>Tägliche Lebensmittelration in Deutschland, 1947<br>Foto: Süddeutsche Zeitung Photo</p><p>Kriegsversehrter mit Tochter, 1951<br>Foto: Heinz Hering/ Süddeutsche Zeitung Photo</p><p>Zerstörtes Dresden nach dem 2. Weltkrieg, 1945<br>Foto: dpa/ Süddeutsche Zeitung Photo</p><p>Georg Baselitz in seinem Atelier, Berlin, 1966<br>Foto: Elke Baselitz</p><p>Zeitungsausschnitt aus der Nacht-Depesche vom 4. Oktober 1964<br>Foto: Jochen Littkemann, Berlin</p><p>Villa Romana, Florenz<br>Foto: Yann Monel</p><p>Wolfgang Frommel bei seinem Berliner Atelierbesuch, 1966<br>Foto: Elke Baselitz, genehmigt durch Archiv Castrum Peregrini Amsterdam</p><p>Georg Baselitz, „Warum das Bild ‚Die großen Freunde‘ ein gutes Bild ist!“, Galerie Springer, Berlin 1966<br>Foto: Frank Oleski, Köln</p><h3>ZITATE</h3><p><sup id=\"quote1-footnote\">1</sup>„Ich bin in eine zerstörte Ordnung hineingeboren worden, in eine zerstörte Landschaft, in ein zerstörtes Volk, in eine zerstörte Gesellschaft.“ Georg Baselitz<br>Kuspit [1995] 2011, S. 266. <a href=\"#quote-1\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote2-footnote\">2</sup>„Wenn ich anders geboren wäre, woanders geboren wäre, hätte ich ganz sicherlich glücklichere Bilder machen können.“ Georg Baselitz<br>zitiert nach Schneede, 2004, S. 191. <a href=\"#quote-2\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote3-footnote\">3</sup>„Ich war ein wütender Künstler, ein wütender junger Mann und war mit nichts einverstanden, was um mich herum stattfand. Mit gar nichts.“ Georg Baselitz, 2016<br>Interview mit Dr. Eva Mongi-Vollmer, 2016. <a href=\"#quote-3\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote4-footnote\">4</sup>„Günstig für mich waren die relativ niedrigen Preise der Blätter. Die manieristische Grafik wurde schlecht bewertet, sie litt unter dem Missverständnis, dass es sich hierbei um Reproduktionsgrafik handele. Ich aber fand, sie manifestiere den Entwurf, also die persönliche Ausformung und Erfindung in den Zeichnungen, jener Künstler mehr und prägnanter, als das die Grafik nördlich der Alpen tat. Sie war unmittelbarer, willkürlicher und offensiver in ihrer Art.“ Georg Baselitz<br>Staatliche Graphische Sammlung München (Hrsg.), Parmigianino und sein Kreis, Ostfildern 2007, S. 6. <a href=\"#quote-4\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote5-footnote\">5</sup>„… es roch nach Übermut und Freiheit. Der Stumpfsinn der Reichen und der Stumpfsinn der Armen kümmerte uns nicht, die stumpfsinnige Politik auch nicht, ob der Oberbürgermeister eine Schnapsnase hatte und betrunken war oder schwul, war uns egal. Wahnsinnig aufregend dagegen waren Berichte aus 500 Pariser Galerien mit Neuigkeiten auf den Leinwänden und Artistenscheiße in Büchsen oder 20 Quadratmeter Drippings aus Amerika, geschüttet und gepisst. Der wichtigste Ort in Berlin war für lange Zeit Springers Galerie.“ Georg Baselitz, 2009<br>http://www.bz-berlin.de/artikel-archiv/baselitz-gratuliert-springer [Stand 03.06.2016]. <a href=\"#quote-5\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote6-footnote\">6</sup>„… sie sollten angefüllt sein von Pathos, das war wichtig. Dazu, zum Pathos, gehört ein dunkler Hintergrund, wenn es geht Sterne am Himmel. Dazu gehört eine Fahne und wenn die Fahne nicht aufrecht flattert, sondern fällt und so weiter … Alle diese Sachen habe ich bedacht.“ Georg Baselitz, 2016<br>Interview mit Dr. Eva Mongi-Vollmer, 2016. <a href=\"#quote-6\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote7-footnote\">7</sup>„Und ich dachte, je größer, umso deutlicher, je größer, umso manifester, je größer, umso mutiger und je größer, umso unverschämter und so weiter. Und diese Bilder sind entstanden aus, einfach aus Bescheidenheit. Du musst das hinkriegen auf dem kleinen Format. […] und das habe ich dann auch hingekriegt, aber es war sehr, sehr schwierig.“ Georg Baselitz, 2016<br>Interview mit Dr. Eva Mongi-Vollmer, 2016. <a href=\"#quote-7\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p></div></div>");
$templateCache.put("app/digit-baselitz/digit-baselitz-copyrights-en.html","<div class=\"g-row g-drop-2 g-push-2\"><div class=\"g-col-12\"><h3>Picture Credits</h3><p>Georg Baselitz, A Blocked One, 1965<br>Oil on canvas, 162 x 130 cm<br>Kunsthalle Bielefeld<br>&copy; Georg Baselitz 2016, Photo: Frank Oleski, Cologne</p><p>Georg Baselitz, Trap, 1966<br>Oil on canvas, 162 x 130 cm<br>Collection Fielding Mellish<br>&copy; Georg Baselitz 2016, Photo: Frank Oleski, Cologne</p><p>Georg Baselitz, The Hero, 1965<br>Oil on canvas, 120 x 105 cm<br>Private Collection<br>&copy; Georg Baselitz 2016, Photo: Frank Oleski, Cologne</p><p>Georg Baselitz, Field, 1962<br>Oil on canvas, 139 x 189 cm<br>Städel Museum, Frankfurt am Main<br>Acquired in 2010 as a gift from Dorette Hildebrand-Staab<br>&copy; Georg Baselitz 2016, Photo: Städel Museum, Frankfurt am Main, ARTOTHEK</p><p>Georg Baselitz, Blocked Painter, 1965<br>Oil on canvas, 162 x 130 cm<br>MKM Museum Küppersmühle für Moderne Kunst, Duisburg, Sammlung Ströher<br>&copy; Georg Baselitz 2016, Photo: Archiv Sammlung Ströher</p><p>Georg Baselitz, The Big Night Down the Drain, 1962–1963<br>Oil on canvas, 250 x 180 cm, Museum Ludwig, Cologne<br>&copy; Georg Baselitz 2016, Photo: Jochen Littkemann, Berlin</p><p>Jacopo Pontormo (after a cartoon by Michelangelo Buonarotti), Venus and Cupid, c. 1533<br>Oil on panel, 128 x 194 cm<br>Florence, Galleria dell‘ Accademia<br>Photo: Antonio Quattrone</p><p>Giuseppe Maria Mitelli, An itinerant medicine vendor performing on stage with a snake in an attempt to sell his wares<br>Etching, 28.1 x 19.7 cm</p><p>Gian Giacomo Caraglio, Diogenes<br>Engraving, 28.4 x 21.7 cm<br>Geneva, Cabinet des estampes (Georg Baselitz collection), Album Spencer<br>Geneva, Cabinet des estampes (Georg Baselitz collection) (Peter Ertl, Albertina)</p><p>Georg Baselitz, The Modern Painter, 1965<br>Oil on canvas, 162 x 130 cm<br>Privately owned<br>&copy; Georg Baselitz 2016, Photo: Frank Oleski, Cologne</p><p>Georg Baselitz, The New Type, 1965<br>Oil on canvas, 162 x 130 cm<br>Froehlich Collection, Stuttgart<br>&copy; Georg Baselitz 2016, Photo: Archiv Sammlung Froehlich, Stuttgart</p><p>Georg Baselitz, Partisan, 1965<br>Oil on canvas, 162 x 130 cm<br>Collection of Lisa and Steven Tananbaum<br>&copy; Georg Baselitz 2016</p><p>Georg Baselitz, Untitled, 1965<br>Oil on canvas, 101 x 80 cm<br>Privately owned<br>&copy; Georg Baselitz 2016, Photo: Jochen Littkemann, Berlin</p><p>Georg Baselitz, Different Signs, 1965<br>Oil on canvas, 162 x 130 cm<br>Fondation Beyeler, Riehen/Basel, Collection Beyeler<br>&copy; Georg Baselitz 2016, Photo: Peter Schibli, Basel</p><p>Georg Baselitz, Untitled, 1965<br>India ink and ink wash on paper, 39 x 26.3 cm<br>Sammlung Ludwig, Ludwig Forum für internationale Kunst, Aachen<br>&copy; Georg Baselitz 2016, Photo: Anne Gold, Aachen</p><p>Georg Baselitz, The Great Friends, 1965<br>Oil on canvas, 250 x 300 cm<br>Museum Ludwig Cologne<br>&copy; Georg Baselitz 2016, Photo: Frank Oleski, Cologne</p><p>Georg Baselitz, A New Type, 1966<br>Oil on canvas, 162 x 130 cm<br>Privately owned<br>&copy; Georg Baselitz 2016, Photo: Frank Oleski, Cologne</p><p>Georg Baselitz, 3rd Head, 1966<br>Oil on canvas, 100 x 81 cm<br>Privately owned<br>&copy; Georg Baselitz 2016, Photo: Jochen Littkemann, Berlin</p><p>Georg Baselitz, Big Night Down the Drain – Native Country, 1966<br>Oil on canvas, 180 x 140 cm<br>Privately owned<br>&copy; Georg Baselitz 2016, Photo: Jochen Littkemann, Berlin</p><h3>PHOTOGRAPHS</h3><p>German expellees from the former Eastern territories<br>Photo: Süddeutsche Zeitung Photo</p><p>Daily food ration in Germany, 1947<br>Photo: Süddeutsche Zeitung Photo</p><p>War invalid with his daughter, 1951<br>Photo: Heinz Hering/ Süddeutsche Zeitung Photo</p><p>Ruins of Dresden after World War II, 1945<br>Photo: dpa/ Süddeutsche Zeitung Photo</p><p>Georg Baselitz in his studio in Berlin, 1966<br>Photo: Elke Baselitz</p><p>Newspaper clipping from Nacht-Depesche, 4 October 1964<br>Photo: Jochen Littkemann, Berlin</p><p>Villa Romana, Florence<br>Photo: Yann Monel</p><p>Wolfgang Frommel during his visit to Baselitz’s studio in Berlin in 1966<br>Photo: Elke Baselitz, courtesy Archiv Castrum Peregrini Amsterdam</p><p>Poster and manifesto of the exhibition at Galerie Springer Berlin 1966<br>Photo: Frank Oleski, Cologne</p><h3>QUOTATIONS</h3><p><sup id=\"quote1-footnote\">1</sup>“I was born into a destroyed order, a destroyed landscape, a destroyed nation, a destroyed society.” Georg Baselitz<br>See Kuspit [1995] 2011, p. 266. <a href=\"#quote-1\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote2-footnote\">2</sup>“If I had been born differently, and somewhere else, I would quite certainly have been able to make happier pictures.” Georg Baselitz<br>See Schneede, 2004, p. 191. <a href=\"#quote-2\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote3-footnote\">3</sup>“I was an enraged artist, an enraged young man; I didn’t approve of anything that was going on around me. Anything at all.”<br>Georg Baselitz, 2016<br>Interview with Dr. Eva Mongi-Vollmer, 2016. <a href=\"#quote-3\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote4-footnote\">4</sup>“The prints’ relatively low prices were an advantage for me. People thought badly of Mannerist printmaking; it suffered from the misunderstanding that it was nothing but reproductions. In my view, however, these works manifested the designs – that is, the personal formal decisions and inventiveness of the artists’ drawings – to a greater and more striking extent than printmaking north of the Alps. It was more immediate, more capricious and more aggressive in manner.” Georg Baselitz<br>Staatliche Graphische Sammlung München (Hrsg.), Parmigianino und sein Kreis, Ostfildern 2007, p. 6. <a href=\"#quote-4\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote5-footnote\">5</sup> “… it smelled of audacity and freedom. We didn’t care about the stupor of the rich or the stupor of the poor or the stupor of politics; it didn’t matter to us whether the mayor had a drinker’s nose or was drunk or gay. What we found incredibly interesting, on the other hand, were reports from 500 Paris galleries about new things on canvasses and artist’s shit in cans or 20 square metres of drippings from America, poured and pissed. For a long time, the most important place in Berlin was Springer’s gallery.”<br>Georg Baselitz, 2009<br>http://www.bz-berlin.de/artikel-archiv/baselitz-gratuliert-springer [status 03.06.2016]. <a href=\"#quote-5\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote6-footnote\">6</sup>“… they were to be filled with pathos; that was important. Pathos needs a dark background, if possible stars in the sky. It needs a flag, and the flag shouldn’t flutter, upright, but fall, etc. … I took all of these things into account.”<br>Georg Baselitz, 2016<br>Interview with Dr. Eva Mongi-Vollmer, 2016. <a href=\"#quote-6\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p><p><sup id=\"quote7-footnote\">7</sup>“And I thought, the bigger the more distinct, the bigger the more manifest, the bigger the bolder, the bigger the more outrageous, etc. And these works developed out of, simply out of modesty. You’ve got to manage this in the small format. …and I did manage it, but it was very, very hard.”<br>Georg Baselitz, 2016<br>Interview with Dr. Eva Mongi-Vollmer, 2016. <a href=\"#quote-7\" du-smooth-scroll=\"\" offset=\"50\"><ui-button type=\"arrow-plain-up\"></ui-button></a></p></div></div>");
$templateCache.put("app/digit-baselitz/digit-baselitz-legals-de.html","<div class=\"g-row g-drop-2 g-push-2\"><div class=\"g-col-12\"><h3>Impressum</h3><p>Rechtliche Hinweise</p><p>Anbieterkennzeichnung i.S.d. § 5 TMG / § 55 II RStV</p><p>Anbieter dieser Internetpräsenz ist das Städelsche Kunstinstitut, eine Stiftung des bürgerlichen Rechts.</p><p>Postanschrift:<br>Städel Museum / Städelsches Kunstinstitut und Städtische Galerie<br>Dürerstraße 2<br>60596 Frankfurt am Main<br>Telefon: 069-605098-0<br>Telefax: 069-605098-111<br>E-Mail: info@staedelmuseum.de</p><p>Geschäftsführende Direktion: Prof. Dr. Jochen Sander und Heinz-Jürgen Bokler<br>Vorsitzender der Administration des Städelschen Kunstinstituts: Prof. Dr. h.c. mult. Nikolaus Schweickart<br>USt-ID-Nr.: DE 157 031 434</p><h4>TECHNISCHE KONZEPTION, GESTALTUNG UND UMSETZUNG</h4><p>agenturfuerkrankemedien GmbH, Berlin (<a target=\"_blank\" href=\"http://agenturfuerkrankemedien.de\">&rarr;&nbsp;agenturfuerkrankemedien.de</a>)</p><p>&nbsp;</p><p>Das Digitorial wird gefördert durch die Aventis Foundation</p><img src=\"assets/images/aventisfoundation.svg\" alt=\"Aventis Foundation\"></div></div>");
$templateCache.put("app/digit-baselitz/digit-baselitz-legals-en.html","<div class=\"g-row g-drop-2 g-push-2\"><div class=\"g-col-12\"><h3>Imprint</h3><p>Provider identification in accordance with Art. 5 TMG (German Teleservices Act) / Art. 55 II RStV (Interstate Broadcasting Agreement)</p><p>The provider of this Internet presence as defined by German law is the Städelsches Kunstinstitut und Städtische Galerie, referred to below as “Städel Museum”.</p><p>Postal address:<br>Städel Museum / Städelsches Kunstinstitut und Städtische Galerie<br>Dürerstraße 2<br>60596 Frankfurt am Main<br>Phone: 069-605098-0<br>Fax: 069-605098-111<br>E-Mail: info@staedelmuseum.de</p><p>Acting Directors: Prof. Dr. Jochen Sander and Heinz-Jürgen Bokler<br>Chairman of the Board of Trustees: Prof. Dr. h.c. mult. Nikolaus Schweickart<br>VAT ID: DE 157 031 434</p><h4>Technical concept, design and realisation</h4><p>agenturfuerkrankemedien GmbH, Berlin (<a target=\"_blank\" href=\"http://agenturfuerkrankemedien.de\">&rarr;&nbsp;agenturfuerkrankemedien.de</a>)</p><p>&nbsp;</p><p>The Digitorial is supported by the Aventis Foundation</p><img src=\"assets/images/aventisfoundation.svg\" alt=\"Aventis Foundation\"></div></div>");
$templateCache.put("app/digit-baselitz/digit-baselitz.html","<div class=\"digit-baselitz digit-theme-bright\" id=\"top\"><section class=\"digitorial__intro digit-baselitz__intro\"><ui-parallax speed=\"0.3\"><div class=\"image\" ui-img=\"\" alt=\"Ein neuer Typ (Detail), um 1966, Privatbesitz, &copy; Georg Baselitz, 2016\" image=\"ein-neuer-typ_gb_m_1965_00_00_42.jpg\" crop=\"top\" cover=\"true\" on-load=\"main.titleImgLoaded = true\"></div></ui-parallax><div class=\"digitorial__intro-inner\"><div class=\"g-row\"><div class=\"g-col-12 g-align-m-center g-col-m-7\"><h1 class=\"digitorial__title digit-baselitz__title\" ng-attr-style=\"background-image: url(assets/images/baselitz-title_{{main.lang}}.svg)\" ng-class=\"{\'show\' : main.titleImgLoaded}\"><span ng-if=\"main.de\">Georg Baselitz – Die Helden – 30.6. - 23.10.2016</span> <span ng-if=\"main.en\">Georg Baselitz – The Heroes – 30.6. - 23.10.2016</span></h1></div></div></div><ui-button type=\"down-trans\" class=\"digitorial__startbutton\" du-smooth-scroll=\"baselitz-start\"></ui-button></section><section class=\"digit-baselitz__section-1\" id=\"baselitz-start\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-1\"><p class=\"intro\"><span ng-if=\"main.de\">Baselitz’ Helden sind nicht die Helden, die wir kennen.</span> <span ng-if=\"main.en\">Baselitz’s heroes are not the heroes we know.</span></p></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p ng-if=\"main.de\">Ob Herkules, Perseus oder Odysseus: Helden faszinieren die Menschheit seit jeher. Mit übermenschlicher Kraft setzen sie sich für das Gute ein, kämpfen tapfer ohne Rücksicht auf Verluste. Auch das Christentum kennt Helden, die für ihre Überzeugungen einstehen und notfalls dafür mit dem Leben bezahlen. In der Literatur sind Helden als König Artus, Jeanne d’Arc, El Cid oder Robin Hood bekannt. Mit den Superhelden-Comics beginnt im 20. Jahrhundert eine neue Ära. 1938 zieht die erste Superman-Geschichte die Leser in ihren Bann. Helden wie Batman, Wonder Woman, Spider-Man oder der unglaubliche Hulk folgen und sind bis heute Kassenschlager im Kino.</p><p ng-if=\"main.en\">Hercules, Perseus, Ulysses: since time immemorial, heroes have held great fascination for human beings. They apply their superhuman powers to championing the good; they fight bravely without regard for the consequences. Christianity also has its heroes who stand up for their convictions – and pay for them with their lives if need be. The heroes of literature include King Arthur, Jeanne d’Arc, El Cid, Robin Hood and many others. In the twentieth century, the superhero comics ushered in a new generation of heroes. The first Superman story enthralled readers in 1938. Heroes like Batman, Wonder Woman, Spider-Man and The Incredible Hulk followed and are still movie theater blockbusters today.</p></div></div><div class=\"g-row g-drop-4\"><div class=\"g-col-12\"><h2 ng-if=\"main.de\">Was macht einen Helden aus?</h2><h2 ng-if=\"main.en\">What are the distinguishing features of heroes?</h2></div></div><ui-zipper ng-if=\"main.de\">kühn furchtlos tapfer | unerschrocken unverletzlich | tatkräftig mutig stark | überlegen muskulös</ui-zipper><ui-zipper ng-if=\"main.en\">bold fearless brave | unflinching invulnerable | energetic courageous strong | superior muscular</ui-zipper><div class=\"g-row g-drop-5\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><h2 ng-if=\"main.de\">Wie sehen Helden aus in einer Zeit,&nbsp;<br>die all ihre Helden verloren hat?</h2><h2 ng-if=\"main.en\">What do heroes look like in an age&nbsp;<br>that has lost all its heroes?</h2></div></div><div class=\"g-row g-drop-1\"><div class=\"g-col-12 g-col-m-3\"><figure ng-if=\"main.de\"><h3>Verletzt</h3><ui-img alt=\"Werk: Georg Baselitz, Ein Versperrter, 1965\" image=\"ein-versperrter_gb_m_1965_00_00_50_oleski.jpg\" cover=\"true\" style=\"height: 18.75rem\"></ui-img><figcaption>Georg Baselitz, Ein Versperrter, 1965, Öl auf Leinwand, 162 x 130 cm, Kunsthalle Bielefeld</figcaption></figure><figure ng-if=\"main.en\"><h3>Wounded</h3><ui-img alt=\"Artwork: Baselitz, A Blocked One, 1965\" image=\"ein-versperrter_gb_m_1965_00_00_50_oleski.jpg\" cover=\"true\" style=\"height: 18.75rem\"></ui-img><figcaption>Georg Baselitz, A Blocked One, 1965, oil on canvas, 162 x 130 cm, Kunsthalle Bielefeld</figcaption></figure></div><div class=\"g-col-12 g-col-m-3 g-offset-m-1\"><figure ng-if=\"main.de\"><h3>Hoffnungslos</h3><ui-img alt=\"Werk: Georg Baselitz, Falle, 1966\" image=\"falle_gb_m-1965_00_00_46_2.jpg\" cover=\"true\" style=\"height: 18.75rem\"></ui-img><figcaption>Georg Baselitz, Falle, 1966, Öl auf Leinwand, 162 x 130 cm, Collection Fielding Mellish</figcaption></figure><figure ng-if=\"main.en\"><h3>Hopeless</h3><ui-img alt=\"Artwork: Georg Baselitz, Trap, 1966\" image=\"falle_gb_m-1965_00_00_46_2.jpg\" cover=\"true\" style=\"height: 18.75rem\"></ui-img><figcaption>Georg Baselitz, Trap, 1966, oil on canvas, 162 x 130 cm, Collection Fielding Mellish</figcaption></figure></div><div class=\"g-col-12 g-col-m-3 g-offset-m-1\"><figure ng-if=\"main.de\"><h3>Schutzlos</h3><ui-img alt=\"Werk: Georg Baselitz, Der Held, 1965\" image=\"held_gb_m-1965_00_00_32_oleski.jpg\" cover=\"true\" style=\"height: 18.75rem\"></ui-img><figcaption>Georg Baselitz, Der Held, 1965, Öl auf Leinwand, 120 x 105 cm, Privatsammlung</figcaption></figure><figure ng-if=\"main.en\"><h3>Defenceless</h3><ui-img alt=\"Artwork: Georg Baselitz, The Hero, 1965\" image=\"held_gb_m-1965_00_00_32_oleski.jpg\" cover=\"true\" style=\"height: 18.75rem\"></ui-img><figcaption>Georg Baselitz, The Hero, 1965, oil on canvas, 120 x 105 cm, Private Collection</figcaption></figure></div></div></section><ui-chaptercover img=\"\'versperrter-maler_gb_m_1966_00_00_02.jpg\'\" class=\"digit-baselitz__chapter-2\" caption=\"Versperrter Maler\" debug=\"true\"><h1 ng-if=\"main.de\"><strong>Nach&shy;kriegs&shy;zeit</strong><br><small>Die Zeit der Helden ist vorbei</small></h1><h1 ng-if=\"main.en\"><strong>The post-war era</strong><br><small>The heroic days are past.</small></h1></ui-chaptercover><section class=\"digit-baselitz__section-2\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-7 g-offset-m-2\"><p class=\"intro\" ng-if=\"main.de\">Georg Baselitz’ Heldenbilder werfen Fragen auf. Wer sie verstehen will, muss tief in die Biografie des Künstlers eintauchen.</p><p class=\"intro\" ng-if=\"main.en\">Georg Baselitz’s hero paintings raise questions. To understand them, we have to delve deep into the artist’s biography.</p></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-8 g-offset-m-3\"><p ng-if=\"main.de\">Kurz vor Ausbruch des Zweiten Weltkriegs wird Georg Baselitz 1938 im von den Nationalsozialisten beherrschten Deutschland geboren. Als Kind erlebt er die Gräueltaten des Krieges mit. Nach der Kapitulation ist das besiegte Deutschland in vier Zonen eingeteilt. Die alliierten Mächte USA, Großbritannien und Frankreich kontrollieren die westdeutschen, die UdSSR die ostdeutschen Gebiete. Hier wächst der junge Georg Baselitz in einem Dorf in der Nähe Dresdens auf.</p><p ng-if=\"main.en\">Georg Baselitz was born in Nazi-ruled Germany in 1938 – shortly before the outbreak of World War II. As a child he witnessed the atrocities of war. After the capitulation, the Allied powers divided the defeated country into four zones. The USA, Britain and France controlled the West German territories, the USSR those in the East. It was there that the young Georg Baselitz grew up in a village near Dresden.</p></div></div><div class=\"g-row g-drop-4 g-push-3\"><div class=\"g-col-12 g-col-m-8 g-offset-m-1\"><blockquote class=\"animated-blockquote\" when-in-viewport=\"bq1.animate = true\" wiv-at=\"bottom\" wiv-buffer=\"300\" ng-class=\"{\'in-viewport\' : bq1.animate}\" id=\"quote-1\"><p ng-if=\"main.de\">Ich bin in eine zerstörte Ordnung hineingeboren worden, in eine zerstörte Landschaft, in ein zerstörtes Volk, in eine zerstörte Gesellschaft.</p><p ng-if=\"main.en\">I was born into a destroyed order, a destroyed landscape, a destroyed nation, a destroyed society.</p><cite>Georg Baselitz<sup><a href=\"#quote1-footnote\" ng-click=\"digit.gotoFootnote($event)\">1</a></sup></cite></blockquote></div></div><div class=\"g-row g-push-2\"><div class=\"g-col-12 g-col-m-7 g-offset-m-4\"><p ng-if=\"main.de\">Die beiden Gebiete unterscheiden sich stark durch ihre politisch-ökonomischen Systeme: Während die westdeutsche Zone kapitalistisch organisiert wird und die Marktwirtschaft herrscht, gelten in Ostdeutschland der Kommunismus und die Planwirtschaft. Alles wird hier zentral verwaltet. Die Euphorie der Befreiung nach Kriegsende währt nur kurz. Die politischen Interessenskonflikte zwischen den westlichen Siegermächten und der UdSSR eskalieren im Kalten Krieg. Aus der Teilung in Besatzungszonen resultiert die deutsche Teilung in BRD und DDR, die bis 1989 andauert. Beide deutsche Staaten erfahren nach 1945 erhebliche Umstrukturierungen bei zeitgleichem Mangel an Grundversorgung.</p><p ng-if=\"main.en\">The two regions differed strongly with regard to their political-economic systems. Whereas the western German zone was organized as a capitalist country with a market economy, in eastern Germany Communism and the planned economy prevailed. The latter had a strongly centralized administration. The euphoria triggered by the liberation from Nazism faded rapidly. The conflicts of political interests between the Western victorious powers and the USSR escalated in the Cold War. The division into occupation zones split the country in two – the Federal Republic and the Democratic Republic –, a state of affairs that endured until 1989. After 1945, both states underwent major restructuring accompanied by shortages in basic supplies.</p></div></div><ui-imagecarousel items=\"digit.carousel1\" lang=\"main.lang\" infinite=\"false\"></ui-imagecarousel><div class=\"g-row g-drop-2 g-push-4\"><div class=\"g-col-12 g-col-m-8 g-offset-m-1\"><p ng-if=\"main.de\">Viel schwieriger als der materielle Wiederaufbau ist die Aufarbeitung der Gräueltaten der Deutschen im Nationalsozialismus. Die Unfähigkeit vieler Deutscher, sich mit der eigenen Schuld und den körperlichen und seelischen Verwundungen der Opfer moralisch auseinanderzusetzen, führen zu einer kollektiven Verdrängung. Eine ganze Gesellschaft ist traumatisiert.</p><p ng-if=\"main.en\">Far more difficult than the country’s material reconstruction, however, was the task of coming to terms with the atrocities committed by the Germans in the National Socialist period. The inability of many Germans to cope with their own feelings of guilt and the physical and mental injuries suffered by the victims led to collective repression. The entire society was traumatized.</p></div></div><ui-dropmore class=\"digit-baselitz__dropmore-1\" ani-dir=\"left\" start-pos=\"-10\" end-pos=\"29.375\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-10 g-offset-m-2\"><article><div class=\"g-row g-drop-3\"><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><h3>Georg Baselitz</h3></div></div><div class=\"g-row g-drop-1 g-push-3\"><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><p ng-if=\"main.de\">Im sächsischen Deutschbaselitz wird Georg Baselitz 1938 unter dem Namen Hans-Georg Kern geboren. Er wächst zwar im ländlichen Gebiet der Oberlausitz auf, die Bilder der nahegelegenen und vollkommen zerstörten Stadt Dresden sind ihm aber bekannt. 1956 schreibt er sich an der Hochschule für bildende und angewandte Kunst im ostberlinischen Weißensee ein. Als er nach zwei Semestern von dort verwiesen wird, wechselt er nach Westberlin und führt sein Studium an der Hochschule für Bildende Künste fort. Auf Reisen nach Amsterdam und Paris lernt er alte und neue Kunst kennen.</p><p ng-if=\"main.en\">Georg Baselitz was born in the Saxon village of Deutschbaselitz in 1938 as Hans-Georg Kern. He grew up in the rural area of Upper Lusatia. He was familiar, however, with images of the devastating ruins of nearby Dresden. In 1956 he enrolled at the Hochschule für bildende und angewandte Kunst, an art academy in Weissensee, a district of East Berlin. Expelled from the school after two semesters, he changed to West Berlin and continued his studies at the Hochschule für Bildende Künste. On travels to Amsterdam and Paris he became acquainted with art of the past and his own present.</p></div><div class=\"g-col-12 g-col-m-4\"><p ng-if=\"main.de\">1961 ändert er seinen Namen in Georg Baselitz. 1962, im Jahr seiner Hochzeit, beendet Baselitz sein Studium und kann 1963 seine erste Einzelausstellung in der neu gegründeten Galerie Werner & Katz verzeichnen, die im Skandal endet. Wegen „Unsittlichkeit“ der Darstellung werden Gemälde beschlagnahmt. Dennoch erhält der Künstler 1965 ein halbjähriges Stipendium der Villa Romana in Florenz, wo er mit der Werkgruppe der „Helden“ beginnt. Nach seiner Rückkehr führt er in Berlin diese Serie fort, bis er 1966 nach Osthofen bei Worms zieht.</p><p ng-if=\"main.en\">In 1962 he changed his name to Georg Baselitz. He finished his studies in 1962, the year of his marriage, and in 1963 staged his first solo exhibition at the newly founded Galerie Werner & Katz. The show ended in a scandal; paintings were confiscated on account of the “immorality” of the depictions. In 1965, the artist nevertheless received a grant for a half-year stay at the Villa Romana in Florence, where he began the “Heroes” workgroup. After his return, he continued the series in Berlin until moving to Osthofen near Worms in 1966.</p></div></div></article></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-3\"><figure><ui-img ng-if=\"main.de\" alt=\"Foto: Georg Baselitz in seinem Atelier, Berlin, 1966\" image=\"baselitz-in-seinem-atelier_1966_foto_elke_baselitz.jpg\" style=\"height: 17rem\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Photograph: Georg Baselitz in his studio in Berlin, 1966\" image=\"baselitz-in-seinem-atelier_1966_foto_elke_baselitz.jpg\" style=\"height: 17rem\"></ui-img><figcaption ng-if=\"main.de\">Georg Baselitz in seinem Atelier, Berlin, 1966</figcaption><figcaption ng-if=\"main.en\">Georg Baselitz in his studio in Berlin, 1966</figcaption></figure></div></div></ui-dropmore><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-9 g-offset-m-2\"><p ng-if=\"main.de\">Kartoffeln, Steine, Leichen? Auf dem dunklen, schrundig gemalten Acker sind die verstümmelten Menschenkörper kaum noch zu erkennen. Baselitz’ traumatische Erinnerungen an die Kriegs- und Nachkriegszeit scheinen sich in den düster atmosphärischen Bildern seines Frühwerks widerzuspiegeln. Das Leid hat sich auf die Leinwand übertragen. Die gemarterten Körper erscheinen wie von einem anderen Stern.</p><p ng-if=\"main.en\">Potatoes? Stones? Corpses? The mutilated human bodies are hardly recognizable as such on the dark, coarsely painted field. The sombre atmosphere of Baselitz’s early paintings seems to mirror his traumatic memories of the war and post-war period. It is if he had translated the suffering onto the canvas. The martyred bodies look like beings from another planet.</p></div></div><div class=\"g-row g-drop-4\"><div class=\"g-col-12 g-col-m-10\"><figure><ui-img ng-if=\"main.de\" alt=\"Werk: Georg Baselitz, Acker, 1962\" image=\"baselitz_acker.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Artwork: Georg Baselitz, Field, 1962\" image=\"baselitz_acker.jpg\"></ui-img><figcaption ng-if=\"main.de\">Georg Baselitz, Acker, 1962, Öl auf Leinwand, 139 x 189 cm, Städel Museum, Frankfurt am Main, erworben 2010 als Schenkung von Dorette Hildebrand-Staab</figcaption><figcaption ng-if=\"main.en\">Georg Baselitz, Field, 1962, oil on canvas, 139 x 189 cm, Städel Museum, Frankfurt am Main, acquired in 2010 as a gift from Dorette Hildebrand-Staab</figcaption></figure></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-9 g-offset-m-2\"><p ng-if=\"main.de\">Auch Baselitz’ Heimat hat sich sehr verändert. Die sowjetischen Soldaten sind nicht weit von seinem Wohnort entfernt stationiert. Die Besatzung führt mit dem kommunistischen System andere Ideologien in dem ostdeutschen Land ein. Der junge Baselitz passt sich an und stellt die neue Ordnung nicht in Frage. Er widmet sich der Bürgerkriegsliteratur aus Russland und sieht im Vorprogramm der Lichtspielhäuser russische Kulturpropagandafilme. Auch von Bildern russischer Soldaten ist er stets umgeben.</p><p ng-if=\"main.de\">Dennoch widerstrebt es Baselitz, sich einer Ideologie unterzuordnen. Auch als junger Student in Berlin fühlt er sich anders, was er auch äußerlich sichtbar macht: Seine lockigen Haare lässt er lang wachsen und er trägt zu jeder Jahreszeit einen schwarzen langen Mantel. Von der Hochschule für bildende und angewandte Kunst im ostberlinischen Weißensee wird Baselitz nach zwei Semestern verwiesen – wegen „gesellschaftspolitischer Unreife“.</p><p ng-if=\"main.en\">Baselitz’s native region had also changed significantly. Soviet soldiers were stationed not far from where he lived. The occupiers introduced the Communist system to the East German zone, and with it new ideologies. The young Baselitz adapted and did not question the new order. He devoted himself to civil war literature and watched the Russian propaganda films shown in the cinemas before the main feature. He was also constantly surrounded by images of Russian soldiers.</p><p ng-if=\"main.en\">He was nevertheless reluctant to bow to an ideology. He felt somehow different from the others, also as a young student in Berlin, and this difference showed on the outside as well: he grew his curly hair long and went around in a long black coat all year round. After two semesters, he was expelled from the Hochschule für bildende und angewandte Kunst in East Berlin’s Weissensee district on grounds of “sociopolitical immaturity”.</p></div></div><div class=\"g-row g-drop-4 g-push-5\"><div class=\"g-col-12 g-col-m-6 g-offset-m-3\"><blockquote class=\"animated-blockquote\" when-in-viewport=\"bq2.animate = true\" wiv-at=\"bottom\" wiv-buffer=\"300\" ng-class=\"{\'in-viewport\' : bq2.animate}\" id=\"quote-2\"><p ng-if=\"main.de\">Wenn ich anders geboren wäre, woanders geboren wäre, hätte ich ganz sicherlich glücklichere Bilder machen können</p><p ng-if=\"main.en\">If I had been born differently, and somewhere else, I would quite certainly have been able to make happier pictures.</p><cite>Georg Baselitz <sup><a href=\"#quote2-footnote\" ng-click=\"digit.gotoFootnote($event)\">2</a></sup></cite></blockquote></div></div></section><section class=\"digit-baselitz__section-3\"><div class=\"g-row\"><div class=\"g-col-12\"><h1 ng-if=\"main.de\">Zum Studieren&nbsp;<br>in den Westen</h1><h1 ng-if=\"main.en\">To the West&nbsp;<br>to continue his studies</h1></div></div><div class=\"g-row g-drop-2 g-push-4\"><div class=\"g-col-12 g-col-m-8\"><p class=\"intro\" ng-if=\"main.de\">Der Hochschule wegen wechselt Baselitz nach Westberlin – und muss sich in einem völlig anderen politischen System wiederfinden.</p><p class=\"intro\" ng-if=\"main.en\">On account of the academy, Baselitz goes to West Berlin – and has to find his bearings in a totally different political system.</p></div></div><ui-scrollfix fix-duration=\"100\" progress=\"sf1progress\"><div class=\"g-row\"><div class=\"g-col-12\"><ui-mapline image=\"416868.jpeg\" progress=\"sf1progress\"></ui-mapline></div></div></ui-scrollfix><div class=\"g-row g-drop-3\"><div class=\"g-col-12 g-col-m-5\"><figure><ui-img ng-if=\"main.de\" alt=\"Grenzschild in Berlin: \'You are entering the american sector\'\" image=\"you-are-entering-the-american_sector.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Border sign in Berlin: \'You are entering the american sector\'\" image=\"you-are-entering-the-american_sector.jpg\"></ui-img><figcaption ng-if=\"main.de\">Grenzschild in Berlin</figcaption><figcaption ng-if=\"main.en\">Border sign in Berlin</figcaption></figure></div><div class=\"g-col-12 g-col-m-5 g-offset-m-1 g-drop-2\"><p ng-if=\"main.de\">1957 wechselt Georg Baselitz an die Hochschule für Bildende Künste ins westberlinische Charlottenburg. Trotz der Teilung der Stadt durch die Alliierten kann der angehende Künstler zu dieser Zeit noch ungehindert von Ost nach West gelangen.</p><p ng-if=\"main.en\">In 1957, Georg Baselitz transferred to the Hochschule für Bildende Künste in Charlottenburg, West Berlin. Even though the Allies had divided the city into two parts, at the time the budding artist was still able to move freely from East to West.</p></div></div><div class=\"g-row g-drop-3 g-push-3\"><div class=\"g-col-12 g-col-m-8 g-offset-m-1\"><p ng-if=\"main.de\">Ab 1958 verlegt Baselitz seinen Wohnsitz nach Westberlin. Anstelle des sozialistischen Aufbaus der Gesellschaft steht hier die individuelle Entwicklung des einzelnen Menschen im Vordergrund. Geprägt von einem starken Wirtschaftswachstum folgen viele Bürger dem Leitbild im Westen blind. Nur wenige arbeiten die Gräuel der NS-Zeit und des Krieges auf. Baselitz fühlt sich entwurzelt und fremd. Das gilt auch für die Kunst: Während im Osten der sozialistische Realismus regierte, fördern die amerikanischen Alliierten in ihren Gebieten die abstrakte Kunst. Auch Baselitz’ Lehrer Hann Trier malt abstrakt. Mit seiner gegenständlichen Malerei steht Baselitz fast allein.</p><p ng-if=\"main.en\">In 1958, Baselitz went to live in West Berlin. Rather than the project of building a socialist society, here the main focus was on the individual and his personal development. In a society strongly shaped by rapid economic growth, many citizens blindly followed the guiding principle of the West. Only few people set about the task of critically re-evaluating the atrocities of the Nazi era and the war. Baselitz felt uprooted, like a stranger. He was also in a completely different world with regard to art: whereas Socialist Realism reigned in the East, the American Allies encouraged abstract art in the territories they occupied. The work of Baselitz’s teacher Hann Trier was also abstract. Baselitz was very much alone with his representational painting style.</p></div></div><ui-dropmore class=\"digit-baselitz__dropmore-2\" ani-dir=\"right\" start-pos=\"8.75\" end-pos=\"19.375\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><article ng-if=\"main.de\"><h3>Im Westen: Siegeszug der Abstraktion</h3><p>Im Nationalsozialismus hatte die Kunst Propagandazwecken zu dienen. Gefordert war eine heroische, an klassizistischen Vorbildern orientierte gegenständliche Malweise. Sämtliche Entwicklungen der Moderne hingegen waren als entartet diffamiert. Nach dem Zweiten Weltkrieg soll moderne Kunst wieder rehabilitiert werden. Vor allem die amerikanischen Alliierten fördern die Abstraktion – für sie ein Sinnbild für die Freiheit der Künstler in einer demokratischen Gesellschaftsordnung. Sie unterstützen Verkäufe, stellen Ausstellungsraum zur Verfügung, organisieren Vorträge und Diskussionsrunden zur gegenstandslosen Kunst.</p></article><article ng-if=\"main.en\"><h3>In the West: the triumphal advance of abstraction</h3><p>In National Socialism, art had had to serve propaganda purposes. Artists were expected to practise a heroic painting style modelled after classicist examples. All modernist developments were vilified as degenerate. After World War II, the aim was to rehabilitate modern art. Above all the American Allies encouraged abstraction, which they considered a symbol of artistic freedom in a democratic social order. They supported sales, made exhibition spaces available, and organized lectures and discussion forums on non-representational art.</p></article></div></div></ui-dropmore><div class=\"g-drop-m-3\"></div><ui-scrollfix fix-duration=\"150\" progress=\"sf2progress\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-5 g-drop-5\"><p ng-if=\"main.de\">So entwurzelt wie Georg Baselitz als Künstler zwischen zwei Welten wirken auch die später entstandenen Helden. Desorientiert stehen sie hoffnungslos in einer zerstörten Landschaft. Beim Anblick der abgerissenen Gliedmaßen und zerfetzten Uniformen werden auch die Bilder der Kriegsversehrten sofort wieder abgerufen.</p><p ng-if=\"main.en\">The sense of being uprooted and between two worlds defined how Baselitz felt as an artist – and the mood conveyed by his later “Heroes”. They stand in destroyed landscapes, without orientation or hope. The sight of their torn-off limbs and tattered uniforms immediately called to mind the omnipresent images of war invalids.</p></div><div class=\"g-col-12 g-col-m-6 g-offset-m-1\"><figure><ui-zoomimage options=\"digit.zoomImg2\" progress=\"sf2progress\"></ui-zoomimage><figcaption ng-if=\"main.de\">Georg Baselitz, Versperrter Maler, 1965, Öl auf Leinwand, 162 x 130 cm, MKM Museum Küppersmühle für Moderne Kunst, Duisburg, Sammlung Ströher</figcaption><figcaption ng-if=\"main.en\">Georg Baselitz, Blocked Painter, 1965, oil on canvas, 162 x 130 cm, MKM Museum Küppersmühle für Moderne Kunst, Duisburg, Collection Ströher</figcaption></figure></div></div></ui-scrollfix><div class=\"g-drop-s-2\"></div><ui-dropmore class=\"digit-baselitz__dropmore-3\" ani-dir=\"left\" start-pos=\"-18.75\" end-pos=\"-24.375\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-1\"><article><div class=\"g-row g-drop-3 g-drop-m-5 g-push-2\"><div class=\"g-col-12 g-col-m-6 g-offset-m-1\"><h3 ng-if=\"main.de\">Military look</h3><h3 ng-if=\"main.en\">The military look</h3><p ng-if=\"main.de\">Militärische Bekleidung ist nicht nur robust und langlebig, sondern auch günstig zu erwerben: Gegen Ende der 1960er-Jahre kommt der Military Look schließlich in Mode. Alte Uniformen werden gebraucht gekauft. Auch Baselitz und seine Frau decken sich auf dem Flohmarkt damit ein.</p><p ng-if=\"main.en\">Military uniforms are not only robust and durable; they were also available at low prices: towards the end of the sixties, the military look came into fashion. People bought old uniforms second-hand. Baselitz and his wife also stocked up at flea markets.</p></div></div></article></div></div></ui-dropmore><div class=\"g-row g-drop-3 g-push-3\"><div class=\"g-col-12 g-col-m-5 g-drop-3\"><figure><ui-img ng-if=\"main.de\" alt=\"Zeitungsausschnitt, Titel: \'Galerie mußte Bilder entfernen\'\" image=\"nacht-depesche_4_oktober_1964.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Newspaper clipping, title: \'Galerie mußte Bilder entfernen\'\" image=\"nacht-depesche_4_oktober_1964.jpg\"></ui-img><figcaption ng-if=\"main.de\">Zeitungsausschnitt aus der Nacht-Depesche vom 4. Oktober 1964</figcaption><figcaption ng-if=\"main.en\">Newspaper clipping from Nacht-Depesche, 4 October 1964</figcaption></figure></div><div class=\"g-col-12 g-col-m-5 g-offset-m-1\"><p ng-if=\"main.de\">Für junge Künstler ist es eine schwierige Zeit. Es stehen kaum Ausstellungsräume zur Verfügung, in denen sie ihre Werke zeigen können. Für Baselitz ist es also ein Glücksfall, dass die Berliner Galerie Werner & Katz seine Werke für die Eröffnungsausstellung 1963 auswählt. Doch es kommt zum Eklat und mehrere Werke werden beschlagnahmt: Die Bilder zeigen unsittliche Darstellungen. Was heute als künstlerische Freiheit gilt, muss juristisch erstritten werden. Baselitz wird gemeinsam mit den Galeristen Michael Werner und Benjamin Katz wegen Erregung öffentlichen Ärgernisses angeklagt, das zunächst gegen ihn gefällte Urteil jedoch vorm Bundesgerichtshof wieder aufgehoben. Schlagartig ist der Künstler nun einer breiten Öffentlichkeit bekannt – jedoch mit zweifelhaftem Ruf. Er wird fortan immer wieder erwähnt, wenn es um die Darstellung von Unanständigkeit oder Unsittlichkeit geht.</p><p ng-if=\"main.en\">It was a difficult time for young artists. There were hardly any exhibition spaces where they could show their works. So for Baselitz it was a stroke of luck that the Galerie Werner & Katz in Berlin chose his works for their opening exhibition in 1963. The show ended in a scandal, however, and the authorities seized several works on account of their indecent depictions. What today is considered artistic licence had to be fought for in legal proceedings. The state prosecutor indicted Georg Baselitz as well as the gallery owners Michael Werner and Benjamin Katz for causing a public scandal. The verdict issued by the trial court was not in his favour, but it was reversed before the German supreme court. Practically overnight, the artist was known to a wide public – but with a dubious reputation. From this time forward, his name was frequently linked with the depiction of obscenity or indecency.</p><p class=\"hide-medium-up\" ng-if=\"main.de\">Heute ist es im Museum Ludwig in Köln zu sehen – zu seiner Entstehungszeit wurde es aus der Ausstellung entfernt: Baselitz’ Werk „Die große Nacht im Eimer“. Der erigierte Penis des kleinen Mannes während der Masturbation fällt sofort ins Auge. Auf den zweiten Blick wird mit Seitenscheitel, beigem Hemd und kurzer brauner Hose ein Bezug zur Uniform eines Mitglieds der Hitler-Jugend hergestellt.</p><p class=\"hide-medium-up\" ng-if=\"main.en\">Today it is on view in the Museum Ludwig in Cologne – at the time of its making it was removed from the exhibition: Baselitz’s “Big Night Down the Drain”. The erect penis the little man is masturbating immediately catches the eye. On closer inspection, we discover references to the Hitler Youth uniform in the side-parted hair, beige shirt and brown trousers.</p></div></div><ui-scrollfix fix-duration=\"150\" progress=\"sf3progress\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-5 g-drop-5 hide-small\"><p ng-if=\"main.de\">Heute ist es im Museum Ludwig in Köln zu sehen – zu seiner Entstehungszeit wurde es aus der Ausstellung entfernt: Baselitz’ Werk „Die große Nacht im Eimer“. Der erigierte Penis des kleinen Mannes während der Masturbation fällt sofort ins Auge. Auf den zweiten Blick wird mit Seitenscheitel, beigem Hemd und kurzer brauner Hose ein Bezug zur Uniform eines Mitglieds der Hitler-Jugend hergestellt.</p><p ng-if=\"main.en\">Today it is on view in the Museum Ludwig in Cologne – at the time of its making it was removed from the exhibition: Baselitz’s Big Night Down the Drain. The erect penis the little man is masturbating immediately catches the eye. On closer inspection, we discover references to the Hitler Youth uniform in the side-parted hair, beige shirt and brown trousers.</p></div><div class=\"g-col-12 g-col-m-6 g-offset-m-1\"><figure><ui-zoomimage options=\"digit.zoomImg3\" progress=\"sf3progress\"></ui-zoomimage><figcaption ng-if=\"main.de\">Georg Baselitz, Die große Nacht im Eimer, 1962–1963, Öl auf Leinwand, 250 x 180 cm, Museum Ludwig, Köln</figcaption><figcaption ng-if=\"main.en\">Georg Baselitz, The Big Night Down the Drain, 1962–1963, oil on canvas, 250 x 180 cm, Museum Ludwig, Cologne</figcaption></figure></div></div></ui-scrollfix><div class=\"g-drop-s-2\"></div><ui-dropmore class=\"digit-baselitz__dropmore-4\" ani-dir=\"left\" start-pos=\"-16.25\" end-pos=\"-19.375\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-2\"><article><div class=\"g-row g-drop-5 g-push-3\"><div class=\"g-col-12 g-col-m-7 g-offset-m-1\"><h3 ng-if=\"main.de\">Georg Baselitz – ein Skandalmaler?</h3><h3 ng-if=\"main.en\">Georg Baselitz – a scandal painter?</h3><p ng-if=\"main.de\">Die Ausstellung fällt in die Zeit einer Sittlichkeitsdebatte in Deutschland, die den Verfall von Moral und den Schutz der Öffentlichkeit thematisiert. Gesetzesänderungen werden gefordert und dabei auch der Kulturbetrieb unter die Lupe genommen. Aufgrund seiner expliziten Darstellungen gilt Baselitz fortan als Inbegriff von Sittenverfall. Eindeutige Presseartikel schüren dieses Bild. Zwar ist Baselitz nun schlagartig bekannt, doch durch die aggressive Stimmung fühlt er sich bedroht.</p><p ng-if=\"main.en\">The exhibition took place at a time when German society was intensely engaged in debates over moral decline and the protection of the public. People demanded amendments to the laws; cultural activities as a whole were subject to close inspection. On account of his explicit depictions, Baselitz now came to be viewed as the quintessence of moral decay. Unequivocal press articles reinforced this image. To make things worse, Baselitz felt personally threatened by the aggressive mood.</p></div></div></article></div></div></ui-dropmore><div class=\"g-row g-drop-3 g-push-3\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><blockquote class=\"animated-blockquote\" when-in-viewport=\"bq3.animate = true\" wiv-at=\"bottom\" wiv-buffer=\"300\" ng-class=\"{\'in-viewport\' : bq3.animate}\" id=\"quote-3\"><p ng-if=\"main.de\">Ich war ein wütender Künstler, ein wütender junger Mann und war mit nichts einverstanden, was um mich herum stattfand. Mit gar nichts.</p><p ng-if=\"main.en\">I was an enraged artist, an enraged young man; I didn’t approve of anything that was going on around me. Anything at all.</p><cite>Georg Baselitz, 2016<sup><a href=\"#quote3-footnote\" ng-click=\"digit.gotoFootnote($event)\">3</a></sup></cite></blockquote></div></div></section><ui-chaptercover img=\"\'partisan_gb_m-1965_00_00_27.jpg\'\" class=\"digit-baselitz__chapter-4\" caption=\"Der Partisan\"><h1 ng-if=\"main.de\"><strong>Florenz</strong><br><small>Vom Einfluss italienischer Kunst</small></h1><h1 ng-if=\"main.en\"><strong>Florence</strong><br><small>The influence of Italian art</small></h1></ui-chaptercover><section class=\"digit-baselitz__section-4\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-1\"><p class=\"intro\" ng-if=\"main.de\">Vom Skandalkünstler zum Stipendiaten: Georg Baselitz widmet sich in Florenz voll und ganz der Kunst. Der Auslandsaufenthalt bereichert sein künstlerisches Schaffen.</p><p class=\"intro\" ng-if=\"main.en\">From scandal artist to grant recipient: in Florence Georg Baselitz devotes himself entirely to art. The stay abroad enriches his artistry.</p></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-9 g-offset-m-2\"><p ng-if=\"main.de\">Aufgrund des ihm vorauseilenden Rufs sind die Förderer des Künstlerhauses Villa Romana irritiert, als der Vorstand Baselitz 1965 ein Stipendium verleiht. Der Künstler kann damit ein halbes Jahr in der Villa Romana verbringen und künstlerisch tätig sein. Der Aufenthalt dort fällt ihm allerdings nicht unbedingt leicht: Ohne Sprachkenntnisse und in einem neuen Kulturraum fühlt er sich häufig isoliert, als Außenseiter. Baselitz versteht sich als stiller Beobachter – und nutzt die Zeit zur intensiven Auseinandersetzung mit der Kunst.</p><p ng-if=\"main.en\">In view of Baselitz’s reputation, the Villa Romana’s patrons were anything but pleased when the executive committee awarded him a grant in 1965. This gave him the opportunity to spend half a year at the Florentine villa pursuing his artistic development. However, his stay there was not necessarily easy for him. In a cultural sphere that was new to him and without command of the language, he frequently felt isolated and like an outsider. The artist conceived of himself as a quiet observer – and used the time for an intensive investigation of art.</p></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-5 g-offset-m-1\"><figure style=\"margin-top: 0.65rem\"><ui-img ng-if=\"main.de\" alt=\"Foto der Villa Romana\" image=\"villa-romana.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Photograph of Villa Romana\" image=\"villa-romana.jpg\"></ui-img><figcaption ng-if=\"main.de\">Villa Romana, Florenz</figcaption><figcaption ng-if=\"main.en\">Villa Romana, Florence</figcaption></figure></div><div class=\"g-col-12 g-col-m-5 g-offset-m-1\"><p ng-if=\"main.de\">Im 1905 ins Leben gerufenen privaten Künstlerhaus Villa Romana sollen Künstler frei von staatlicher Förderung tätig sein. Georg Baselitz arbeitet im großen Gartenatelier, was ihm auch Malerei in größerem Format ermöglicht. Der damalige Direktor Harro Siegel berichtet: „Der grüblerische Baselitz malt und malt.“</p><p ng-if=\"main.en\">Founded in 1905, the Villa Romana is a privately financed place of contemporary artistic production where artists are given the chance to work independently of state support. Georg Baselitz had use of the large garden studio that enabled him to paint larger works than before. According to Harro Siegel, the Villa’s director at the time, “the brooding Baselitz paints and paints”.</p></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-9 g-offset-m-2\"><figure><ui-img ng-if=\"main.de\" alt=\"Werk: Jacopo Pontormo, Venus und Amor\" image=\"36_florenz_galleria_dell_accademia_pontormo_v.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Artwork: Jacopo Pontormo, Venus and Cupid\" image=\"36_florenz_galleria_dell_accademia_pontormo_v.jpg\"></ui-img><figcaption ng-if=\"main.de\">Jacopo Pontormo (nach einem Entwurf von Michelangelo Buonarotti), Venus und Amor, um 1533, Öl auf Holz, 128 x 194 cm, Florenz, Galleria dell‘ Accademia</figcaption><figcaption ng-if=\"main.en\">Jacopo Pontormo (after a cartoon by Michelangelo Buonarotti), Venus and Cupid, c. 1533, oil on panel, 128 x 194 cm, Florence, Galleria dell’ Accademia</figcaption></figure></div></div><div class=\"g-row g-drop-1 g-push-3\"><div class=\"g-col-12 g-col-m-8 g-offset-m-3\"><p ng-if=\"main.de\">Florenz galt im 16. Jahrhundert als Hochburg des Manierismus. Maler wie Pontormo, Bronzino oder Vasari experimentierten mit raffinierten, teils bizarren Formen, Farben und Kompositionen. Auch zu Baselitz’ Zeiten waren diese Gemälde allgegenwärtig. Er interessierte sich vor allem für diesen Stil. Nun hat er die Gelegenheit, diese Kunstrichtung im Original vor Ort zu betrachten: Verdrehte Figuren, kleine Köpfe auf überlängten Körpern, experimentierfreudige Kompositionen.</p><p ng-if=\"main.en\">In the sixteenth century, Florence was considered the stronghold of Mannerism. Painters like Pontormo, Bronzino and Vasari experimented with sophisticated and sometimes even bizarre forms, colours and compositions. Their paintings were still omnipresent in Baselitz’s time. He was interested above all in this style. Now he had the opportunity to view this art current in the original and on location: contorted figures, small heads on overly long bodies, compositions that had emerged from pleasure in experimentation.</p></div></div><ui-dropmore class=\"digit-baselitz__dropmore-5\" ani-dir=\"left\" start-pos=\"4.375\" end-pos=\"24.375\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-10 g-offset-m-1\"><article><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-8 g-offset-m-1\"><h3 class=\"g-push-3\" ng-if=\"main.de\">Baselitz’ Sammlung</h3><h3 class=\"g-push-3\" ng-if=\"main.en\">Baselitz’s collection</h3><blockquote class=\"small negative\" id=\"quote-4\"><p ng-if=\"main.de\">Günstig für mich waren die relativ niedrigen Preise der Blätter. Die manieristische Grafik wurde schlecht bewertet, sie litt unter dem Missverständnis, dass es sich hierbei um Reproduktionsgrafik handele. Ich aber fand, sie manifestiere den Entwurf, also die persönliche Ausformung und Erfindung in den Zeichnungen, jener Künstler mehr und prägnanter, als das die Grafik nördlich der Alpen tat. Sie war unmittelbarer, willkürlicher und offensiver in ihrer Art.</p><p ng-if=\"main.en\">The prints’ relatively low prices were an advantage for me. People thought badly of Mannerist printmaking; it suffered from the misunderstanding that it was nothing but reproductions. In my view, however, these works manifested the designs – that is, the personal formal decisions and inventiveness of the artists’ drawings – to a greater and more striking extent than printmaking north of the Alps. It was more immediate, more capricious and more aggressive in manner.</p><cite>Georg Baselitz<sup><a href=\"#quote4-footnote\" ng-click=\"digit.gotoFootnote($event)\">4</a></sup></cite></blockquote></div></div><div class=\"g-row g-drop-4 g-push-2\"><div class=\"g-col-12 g-col-m-5 g-offset-m-1\"><p ng-if=\"main.de\">Druckgrafiken des Manierismus sind in den 1960er-Jahren in Florenz recht günstig auf Flohmärkten zu erwerben. Baselitz beginnt damit, besonders außergewöhnliche Exemplare zu sammeln. Verdrehte Figuren, vollkommen außerhalb jeglicher Darstellung eines natürlichen Bewegungsablaufs, faszinieren ihn. Als „unsicheres Terrain“ bezeichnet Baselitz den Moment, wenn sich die Figur vom realen Abbild immer weiter entfernt. Erst später erwirbt er auch kostbare Druckgrafiken der Manieristen. Bis heute besitzt er eine der feinsten Sammlungen.</p><p ng-if=\"main.en\">In the 1960s it was possible to purchase Mannerist prints quite inexpensively at the flea markets of Florence. Baselitz began collecting especially exceptional specimens. Contorted figures completely defying any depiction of natural movement fascinated him. When a figure departed ever further from a realistic likeness, he referred to it as “uncertain terrain”. It would be several years before he began purchasing expensive Mannerist prints as well. To this day, he owns one of the finest collections of these works.</p></div></div></article></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-4 g-offset-m-8\"><figure><ui-img ng-if=\"main.de\" alt=\"Werk: Gian Giacomo Caraglio, Diogenes\" image=\"caraglio_kasten_sammlung.jpg\" style=\"height: 24.5625rem\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Artwork: Gian Giacomo Caraglio, Diogenes\" image=\"caraglio_kasten_sammlung.jpg\" style=\"height: 24.5625rem\"></ui-img><figcaption ng-if=\"main.de\">Gian Giacomo Caraglio (nach Parmigianino), Diogenes, Kupferstich, 28,4 x 21,7 cm, Genf, Cabinet des estampes (Sammlung Georg Baselitz), Album Spencer</figcaption><figcaption ng-if=\"main.en\">Gian Giacomo Caraglio (after Parmigianino), Diogenes, engraving, 28.4 x 21.7 cm, Geneva, Cabinet des estampes (Georg Baselitz collection), Album Spencer</figcaption></figure></div></div></ui-dropmore><div class=\"g-row g-drop-2 g-push-2\"><div class=\"g-col-12 g-col-m-5\"><figure><ui-img ng-if=\"main.de\" alt=\"Werk von Giuseppe Maria Mitelli\" image=\"maria-mitelli.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Artwork by Giuseppe Maria Mitelli\" image=\"maria-mitelli.jpg\"></ui-img><figcaption ng-if=\"main.de\">Giuseppe Maria Mitelli, Ein ambulanter Medizin-Händler tritt mit einer Schlange auf der Bühne auf, um seine Waren zum Verkauf anzubieten, Radierung, 28,1 x 19,7 cm</figcaption><figcaption ng-if=\"main.en\">Giuseppe Maria Mitelli, An itinerant medicine vendor performing on stage with a snake in an attempt to sell his wares, etching, 28.1 x 19.7 cm</figcaption></figure></div><div class=\"g-col-12 g-col-m-5 g-offset-m-1 g-drop-s-2 g-drop-m-5 g-push-s-3\"><p ng-if=\"main.de\">Inspirierend sind für Baselitz die kleinen Druckgrafiken von Giuseppe Maria Mitelli, die er auf einem Flohmarkt findet. Der italienische Künstler des ausgehenden 17. Jahrhunderts hielt darauf die Berufe seiner Zeit fest. In der Mitte jedes Blattes steht immer ein Mann. Durch mitgeführte Objekte wie Werkzeug, Pinsel oder Taschen verrät Mitelli dessen jeweilige Profession als Händler, Holzfäller, Obstverkäufer oder Wasserträger.</p><p ng-if=\"main.en\">Baselitz also found inspiration in the small prints by Giuseppe Maria Mitelli, which he found at a flea market. In the late seventeenth century, the Italian artist had documented the professions of his time. There is always a man standing at the centre of the print. The objects accompanying him, for example tools, brushes or bags, reveal whether he is a merchant, woodcutter, fruit seller, water carrier, etc.</p></div></div><ui-audioplayer ng-if=\"main.de\" audio=\"assets/audio/de_spur_1_101.mp3\" title=\"Georg Baselitz’ Erinnerungen an Florenz\"></ui-audioplayer><ui-audioplayer ng-if=\"main.en\" audio=\"assets/audio/en_101_VO.mp3\" title=\"Georg Baselitz’s memories of Florence\"></ui-audioplayer><div class=\"g-row g-drop-4 g-push-3\"><div class=\"g-col-12 g-col-m-7 g-offset-m-3\"><p ng-if=\"main.de\">Im Laufe von nur einem Jahr entstehen 1965/66 60 Gemälde, 130 Zeichnungen und 38 Druckgrafiken gleichen Themas. Zahlreiche Eindrücke aus Baselitz’ Leben kehren in den sogenannten „Neuen Typen“ wieder. Ihren übergreifenden Titel „Heldenbilder“ erhalten sie übrigens erst 1973 in einem Ausstellungskatalog.</p><p ng-if=\"main.en\">In the course of a single year – 1965/66 – Baselitz produced 60 paintings, 130 drawings and 38 prints on the same theme. Numerous impressions from the artist’s past reappeared in the so-called “New Types”. Incidentally, it was not until 1973 that an exhibition catalogue subsumed these works under the term Hero Paintings.</p></div></div><ui-imagecarousel items=\"digit.carousel2\" lang=\"main.lang\" infinite=\"true\" ratio=\"(544/455)\"></ui-imagecarousel><div class=\"g-row g-drop-4\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p ng-if=\"main.de\">Hat die Welt alle ihre Helden verloren? Hoffnungslos und ohne Halt, ernüchtert und kraftlos, passiv und taumelnd – so erscheinen die Menschen auf den Gemälden. Die Helden tragen ganz konkret die Atmosphäre der Nachkriegszeit in sich.<br>Eine klare Deutung fällt schwer – doch die Werke vermitteln einen Gefühlszustand. Es herrscht eine Stimmung zwischen Trauer, Wut und Ohnmacht, eine Spannung zwischen Aggression und Verletzlichkeit.</p><p ng-if=\"main.en\">Has the world lost all its heroes? Hopeless and lost, disillusioned and feeble, passive and faltering – that’s how the human beings on these canvasses look. The heroes are infused with the atmosphere of the post-war period.<br>It is difficult to arrive at a clear interpretation – in any case, the works convey an emotional state. A mood between grief, rage and impotence prevails, a tension between aggression and vulnerability.</p></div></div></section><ui-chaptercover img=\"\'die-grossen-freunde_gb_m_1965_00_00_41.jpg\'\" class=\"digit-baselitz__chapter-5\" caption=\"Große Freunde\" theme=\"bright\"><h1 ng-if=\"main.de\"><strong>Berlin</strong><br><small>Die Hochphase der Helden</small></h1><h1 ng-if=\"main.en\"><strong>Berlin</strong><br><small>The Heroes’ heyday</small></h1></ui-chaptercover><section class=\"digit-baselitz__section-5\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-7 g-offset-m-1\"><p class=\"intro\" ng-if=\"main.de\">Mit den ersten Heldenbildern im Gepäck kehrt Baselitz nach Ende des Stipendiums nach Berlin zurück. Er hat eine Zeit unermüdlichen Schaffens vor sich.</p><p class=\"intro\" ng-if=\"main.en\">When his grant period is over, Baselitz returns to Berlin with his first Hero pictures in his luggage. He has a phase of tireless production ahead of him.</p></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-8 g-offset-m-3\"><p ng-if=\"main.de\">In seinem Atelier in Berlin-Charlottenburg widmet sich Georg Baselitz nun verstärkt diesen Werken. Er malt mit großem Einsatz daran weiter. Ausgestellt werden jedoch immer nur einzelne Gemälde. Lediglich die Menschen, die Baselitz in seinem Atelier besuchen, können die gesamte Werkgruppe betrachten und mit ihm über die Bilder diskutieren.</p><p ng-if=\"main.en\">Back in his studio in Berlin-Charlottenburg, Baselitz now devoted himself more intensively than ever to these works. Yet he exhibited only isolated examples in public. Only the people who visited him in his studio had the opportunity to see the entire workgroup and discuss the paintings with him.</p></div></div><div class=\"g-row g-collapse g-drop-4 g-push-4\"><div class=\"g-m-boxline\"><div class=\"g-box\"><figure class=\"text-center\"><ui-img ng-if=\"main.de\" alt=\"Wolfgang Frommel bei seinem Berliner Atelierbesuch, 1966\" image=\"1966_atelier_berlin_frommel_3.jpg\" style=\"height: 15.25rem\" cover=\"true\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Wolfgang Frommel during his visit to Baselitz’s studio in Berlin in 1966\" image=\"1966_atelier_berlin_frommel_3.jpg\" style=\"height: 15.25rem\" cover=\"true\"></ui-img></figure></div><div class=\"g-box\"><figure class=\"text-center\"><ui-img ng-if=\"main.de\" alt=\"Wolfgang Frommel bei seinem Berliner Atelierbesuch, 1966\" image=\"1966_atelier_berlin_frommel_1.jpg\" style=\"height: 15.25rem\" cover=\"true\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Wolfgang Frommel during his visit to Baselitz’s studio in Berlin in 1966\" image=\"1966_atelier_berlin_frommel_1.jpg\" style=\"height: 15.25rem\" cover=\"true\"></ui-img></figure></div><div class=\"g-box\"><figure class=\"text-center\"><ui-img ng-if=\"main.de\" alt=\"Wolfgang Frommel bei seinem Berliner Atelierbesuch, 1966\" image=\"1966_atelier_berlin_frommel_2.jpg\" style=\"height: 15.25rem\" cover=\"true\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Wolfgang Frommel during his visit to Baselitz’s studio in Berlin in 1966\" image=\"1966_atelier_berlin_frommel_2.jpg\" style=\"height: 15.25rem\" cover=\"true\"></ui-img></figure></div></div><div class=\"g-col-10 g-offset-1 g-col-m-8 g-offset-m-2\"><figcaption class=\"text-center\" ng-if=\"main.de\">Wolfgang Frommel bei seinem Berliner Atelierbesuch, 1966</figcaption><figcaption class=\"text-center\" ng-if=\"main.en\">Wolfgang Frommel during his visit to Baselitz’s studio in Berlin in 1966</figcaption></div></div><ui-dropmore class=\"digit-baselitz__dropmore-6\" ani-dir=\"right\" start-pos=\"0\" end-pos=\"24.375\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-10 g-offset-m-1\"><article><div class=\"g-row g-drop-3\"><div class=\"g-col-12 g-col-m-5 g-offset-m-4\"><h3 ng-if=\"main.de\">Die zeichnerischen Kräfte</h3><h3 ng-if=\"main.en\">The powers of drawing</h3></div></div><div class=\"g-row g-drop-1 g-push-3\"><div class=\"g-col-12 g-col-m-5 g-offset-m-4\"><p ng-if=\"main.de\">Papierarbeiten haben für Georg Baselitz die gleiche Bedeutung wie Gemälde. Die Zeichnungen dienen ihm nicht einfach als Vorzeichnung, sondern bestechen durch eigene künstlerische Ausdruckskraft. Sie werden jedoch nicht ausgestellt und finden kaum Beachtung. Wer sie sehen will, muss Baselitz’ Atelier aufsuchen. Der Künstler geht mit seinen Zeichnungen experimentell um. Die Striche variieren und flimmern, sind unsauber und voller Energie gesetzt. Sowohl Bleistift und Aquarell als auch Tusche und Gouache kommen zum Einsatz.</p><p ng-if=\"main.en\">Works on paper held the same significance for Baselitz as paintings. The drawings did not simply serve him as preliminary studies, but owe their captivating quality to an expressive artistic force of their own. The artist did not exhibit them, however, and they hardly attracted notice. To see them, you had to visit the artist’s studio. Baselitz took an experimental approach to his drawings. The lines vary and flicker, are messy and full of energy. The artist employed a range of media including pencil, watercolour, drawing ink and gouache.</p></div></div></article></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-4\"><figure><ui-img ng-if=\"main.de\" alt=\"Werk: Georg Baselitz, Ohne Titel, 1965\" image=\"ohne-titel_zeichnung_dsc_5544.jpg\" style=\"height: 27.1875rem\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Artwork: Georg Baselitz, Untitled, 1965\" image=\"ohne-titel_zeichnung_dsc_5544.jpg\" style=\"height: 27.1875rem\"></ui-img><figcaption ng-if=\"main.de\">Georg Baselitz, Ohne Titel, 1965, Tuschfeder und Tusche laviert auf Papier, 39 x 26,3 cm, Sammlung Ludwig, Ludwig Forum für internationale Kunst, Aachen</figcaption><figcaption ng-if=\"main.en\">Georg Baselitz, Untitled, 1965, India ink and ink wash on paper, 39 x 26.3 cm, Sammlung Ludwig, Ludwig Forum für Internationale Kunst, Aachen</figcaption></figure></div></div></ui-dropmore></section><section class=\"digit-baselitz__section-6\"><div class=\"g-row\"><div class=\"g-col-12\"><h1 ng-if=\"main.de\">Erster Erfolg</h1><h1 ng-if=\"main.en\">Initial success:<br>the exhibition at Galerie Springer</h1></div></div><div class=\"g-row g-drop-3\"><div class=\"g-col-12 g-col-m-7\"><p class=\"intro\" ng-if=\"main.de\">Selbstbewusst zeigt Baselitz eine Auswahl seiner Heldenbilder in einer Ausstellung.</p><p class=\"intro\" ng-if=\"main.en\">Baselitz confidently shows a selection of his “Hero” works in an exhibition.</p></div></div><div class=\"g-row g-drop-3\"><div class=\"g-col-12 g-col-m-8 g-offset-m-1\"><p ng-if=\"main.de\">Während einige Werke noch unfertig im Atelier stehen, können im Februar 1966 mehrere der Heldenbilder in der Galerie Springer in Berlin besichtigt werden. Es ist die erste Ausstellung dieser Werke. Da junge Künstler kaum Möglichkeiten haben, ihre Werke zu präsentieren, ist die Ausstellung in der Galerie Springer umso bedeutender.</p><p ng-if=\"main.en\">Whereas a number of works remained in the studio unfinished, in February 1966 the public had the opportunity to view several of the “Hero” paintings at Galerie Springer in Berlin. It was the first exhibition of these works. As young artists hardly had any means of presenting their works, the show at Galerie Springer was all the more significant.</p></div></div><div class=\"g-row g-drop-5\"><div class=\"g-col-12 g-col-m-9 g-offset-m-2\"><blockquote class=\"animated-blockquote\" when-in-viewport=\"bq4.animate = true\" wiv-at=\"bottom\" wiv-buffer=\"300\" ng-class=\"{\'in-viewport\' : bq4.animate}\" id=\"quote-5\"><p ng-if=\"main.de\">… es roch nach Übermut und Freiheit. Der Stumpfsinn der Reichen und der Stumpfsinn der Armen kümmerte uns nicht, die stumpfsinnige Politik auch nicht, ob der Oberbürgermeister eine Schnapsnase hatte und betrunken war oder schwul, war uns egal. Wahnsinnig aufregend dagegen waren Berichte aus 500 Pariser Galerien mit Neuigkeiten auf den Leinwänden und Artistenscheiße in Büchsen oder 20 Quadratmeter Drippings aus Amerika, geschüttet und gepisst. Der wichtigste Ort in Berlin war für lange Zeit Springers Galerie.</p><p ng-if=\"main.en\">… it smelled of audacity and freedom. We didn’t care about the stupor of the rich or the stupor of the poor or the stupor of politics; it didn’t matter to us whether the mayor had a drinker’s nose or was drunk or gay. What we found incredibly interesting, on the other hand, were reports from 500 Paris galleries about new things on canvasses and artist’s shit in cans or 20 square metres of drippings from America, poured and pissed. For a long time, the most important place in Berlin was Springer’s gallery.</p><cite>Georg Baselitz, 2009<sup><a href=\"#quote5-footnote\" ng-click=\"digit.gotoFootnote($event)\">5</a></sup></cite></blockquote></div></div><div class=\"g-row g-drop-5\"><div class=\"g-col-12 g-col-m-8 g-offset-m-1\"><figure><ui-img ng-if=\"main.de\" alt=\"Werk: Georg Baselitz, Die großen Freunde, 1965\" image=\"die-grossen-freunde_gb_m_1965_00_00_41.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Artwork: Georg Baselitz, The Great Friends, 1965\" image=\"die-grossen-freunde_gb_m_1965_00_00_41.jpg\"></ui-img><figcaption ng-if=\"main.de\">Georg Baselitz, Die großen Freunde, 1965, Öl auf Leinwand, 250 x 300 cm, Museum Ludwig Köln</figcaption><figcaption ng-if=\"main.en\">Georg Baselitz, The Great Friends, 1965, oil on canvas, 250 x 300 cm, Museum Ludwig, Cologne</figcaption></figure></div></div><div class=\"g-row g-drop-2 g-push-3\"><div class=\"g-col-12 g-col-m-7 g-offset-m-3\"><p ng-if=\"main.de\">„Die großen Freunde“ ist das zentrale Werk der Ausstellung. Es ist deutlich größer als die bisherigen Heldenbilder und zeigt nun zwei Menschen. In der Mehrfigurigkeit erkennt Baselitz das Potenzial, noch mehr Spannung zu erzeugen.</p><p ng-if=\"main.en\">“The Great Friends” was the core work in the exhibition. It was substantially larger than the previous Hero paintings, and different in that it depicted two figures. Baselitz had come to recognize the multifigural composition as a potential means of creating even more tension than before.</p></div></div><ui-audioplayer ng-if=\"main.de\" audio=\"assets/audio/de_spur_2_115.mp3\" title=\"Georg Baselitz’ Erinnerungen an die Ausstellung\"></ui-audioplayer><ui-audioplayer ng-if=\"main.en\" audio=\"assets/audio/en_115_VO.mp3\" title=\"Georg Baselitz’s memories of the exhibition\"></ui-audioplayer><div class=\"g-row g-drop-4\"><div class=\"g-col-12 g-col-m-5 g-drop-m-4\"><p ng-if=\"main.de\">Das zentrale Werk ist auch auf dem Ausstellungsplakat zu sehen – darunter lässt Baselitz ein Manifest mit dem Titel „Warum das Bild Die großen Freunde ein gutes Bild ist!“ abdrucken. Wichtige Aspekte des Manifests entnimmt er den Kriterien für Kunst von „Geisteskranken“ aus dem Buch „Die Merkmale schizophrener Malerei“ von Helmut Rennert, 1962. Baselitz, der sich selbst als Außenseiter empfand, war neugierig auf nicht konforme, unangepasste Ausdrucksformen. So interessierte er sich auch sehr für die Kunst von „Geisteskranken“.</p><p ng-if=\"main.en\">The exhibition poster also featured the core work, and beneath the illustration Baselitz had a manifesto reprinted with the heading “Why the work The Great Friends is a good painting!”. He derived important aspects of the manifesto from criteria for the art of the mentally ill introduced in a book about the characteristics of schizophrenic painting by Helmut Rennert, 1962. Baselitz, who saw himself as an outsider, was intrigued by non-conformist forms of expression. He was accordingly also very interested in art by mental patients.</p></div><div class=\"g-col-12 g-col-m-5 g-offset-m-1\"><figure><ui-img ng-if=\"main.de\" alt=\"Plakat und Manifest zur Ausstellung in der Galerie Springer Berlin, 1966\" image=\"1966-01-29_galerie_springer.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Poster and manifesto of the exhibition at Galerie Springer Berlin, 1966\" image=\"1966-01-29_galerie_springer.jpg\"></ui-img><figcaption ng-if=\"main.de\">Plakat und Manifest zur Ausstellung in der Galerie Springer Berlin, 1966</figcaption><figcaption ng-if=\"main.en\">Poster and manifesto of the exhibition at Galerie Springer Berlin, 1966</figcaption></figure></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-7 g-offset-m-3\"><p ng-if=\"main.de\">Nicht nur, dass in „Die großen Freunde“ zwei Personen dargestellt sind – auch der dunkle Hintergrund verleiht dem Werk ungeahnte Spannung. Die hellen Figuren heben sich deutlich vom Hintergrund ab und scheinen daher noch stärker entwurzelt. Baselitz setzt diese Gestaltungsweise auch für weitere Werke ein.</p><p ng-if=\"main.en\">It was not just the fact that “The Great Friends” depicts two persons – the dark background also lends the composition unsuspected tension. The bright figures stand out clearly against the background and seem all the more uprooted as a result. Baselitz also employed this device in other works.</p></div></div><div class=\"g-row g-drop-4\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><figure><ui-img ng-if=\"main.de\" alt=\"Werk: Georg Baselitz, Ein neuer Typ, 1966\" image=\"ein-neuer-typ_gb_m_1965_00_00_42.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Artwork: Georg Baselitz, A New Type, 1966\" image=\"ein-neuer-typ_gb_m_1965_00_00_42.jpg\"></ui-img><figcaption ng-if=\"main.de\">Georg Baselitz, Ein neuer Typ, 1966, Öl auf Leinwand, 162 x 130 cm, Privatbesitz</figcaption><figcaption ng-if=\"main.en\">Georg Baselitz, A New Type, 1966, oil on canvas, 162 x 130 cm, Privately owned</figcaption></figure></div></div><div class=\"g-row g-drop-4\"><div class=\"g-col-12 g-col-m-10 g-offset-m-1\"><blockquote class=\"animated-blockquote\" when-in-viewport=\"bq5.animate = true\" wiv-at=\"bottom\" wiv-buffer=\"300\" ng-class=\"{\'in-viewport\' : bq5.animate}\" id=\"quote-6\"><p ng-if=\"main.de\">… sie sollten angefüllt sein von Pathos, das war wichtig. Dazu, zum Pathos, gehört ein dunkler Hintergrund, wenn es geht Sterne am Himmel. Dazu gehört eine Fahne und wenn die Fahne nicht aufrecht flattert, sondern fällt und so weiter … Alle diese Sachen habe ich bedacht.</p><p ng-if=\"main.en\">… they were to be filled with pathos; that was important. Pathos needs a dark background, if possible stars in the sky. It needs a flag, and the flag shouldn’t flutter, upright, but fall, etc. … I took all of these things into account.</p><cite>Georg Baselitz, 2016<sup><a href=\"#quote6-footnote\" ng-click=\"digit.gotoFootnote($event)\">6</a></sup></cite></blockquote></div></div></section><ui-chaptercover img=\"\'kopf_gb_m_1966_00_00_14.jpg\'\" class=\"digit-baselitz__chapter-7\" caption=\"Bildunterschrift\" theme=\"bright\"><h1 ng-if=\"main.de\"><strong>Fokus&shy;sierung</strong><br><small>Besondere Aspekte der Helden</small></h1><h1 ng-if=\"main.en\"><strong>Focus</strong><br><small>Special aspects of the Heroes</small></h1></ui-chaptercover><section class=\"digit-baselitz__section-7\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-1\"><p class=\"intro\" ng-if=\"main.de\">Seine Helden nehmen neue Formen an – doch dem Thema bleibt Georg Baselitz treu.</p><p class=\"intro\" ng-if=\"main.en\">The heroes take on new forms – but Georg Baselitz remains faithful to the theme.</p></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-6 g-offset-m-1\"><p ng-if=\"main.de\">Baselitz beschränkt einige Werke auf Köpfe und lässt diese nur noch aus gemalten Linien entstehen. Sie erinnern somit an eine Zeichnung – der Hintergrund wird zum Vordergrund. Den Charakter vermitteln sie dennoch: Das Leid spricht den Helden aus dem Gesicht.</p><p ng-if=\"main.de\">Der Künstler verwendet für die Köpfe ein kleineres Format. Dies stellt Baselitz jedoch vor neue Herausforderungen – vor allem, weil er mit dickem Borstenpinsel arbeitet. Doch entscheidet er sich bewusst gegen die Verwendung von feineren Pinseln.</p><p ng-if=\"main.en\">Baselitz now limited many of his works to mere heads consisting of nothing but painted lines. They thus take on a drawing-like quality – the background becomes the foreground. Nevertheless, they convey a mood: these heroes’ faces speak of suffering.</p><p ng-if=\"main.en\">For the heads, the artist used a smaller format. This change confronted Baselitz with new challenges – above all because he worked with a thick bristle brush. Yet he deliberately decided against using finer brushes.</p></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1 g-drop-s-2\"><figure><ui-img ng-if=\"main.de\" alt=\"Werk: Georg Baselitz, 3. Kopf, 1966\" image=\"kopf_gb_m_1966_00_00_14.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"Artwork: Georg Baselitz, 3rd Head, 1966\" image=\"kopf_gb_m_1966_00_00_14.jpg\"></ui-img><figcaption ng-if=\"main.de\">Georg Baselitz, 3. Kopf, 1966, Öl auf Leinwand, 100 x 81 cm, Privatbesitz</figcaption><figcaption ng-if=\"main.en\">Georg Baselitz, 3rd Head, 1966, oil on canvas, 100 x 81 cm, Privately owned</figcaption></figure></div></div><div class=\"g-row g-drop-2 g-push-4\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><blockquote class=\"animated-blockquote\" when-in-viewport=\"bq6.animate = true\" wiv-at=\"bottom\" wiv-buffer=\"300\" ng-class=\"{\'in-viewport\' : bq6.animate}\" id=\"quote-7\"><p ng-if=\"main.de\">Und ich dachte, je größer, umso deutlicher, je größer, umso manifester, je größer, umso mutiger und je größer, umso unverschämter und so weiter. Und diese Bilder sind entstanden aus, einfach aus Bescheidenheit. Du musst das hinkriegen auf dem kleinen Format. […] und das habe ich dann auch hingekriegt, aber es war sehr, sehr schwierig.</p><p ng-if=\"main.en\">And I thought, the bigger the more distinct, the bigger the more manifest, the bigger the bolder, the bigger the more outrageous, etc. And these works developed out of, simply out of modesty. You’ve got to manage this in the small format. …and I did manage it, but it was very, very hard.</p><cite>Georg Baselitz, 2016<sup><a href=\"#quote7-footnote\" ng-click=\"digit.gotoFootnote($event)\">7</a></sup></cite></blockquote></div></div></section><section class=\"digit-baselitz__section-8\"><div class=\"g-row\"><div class=\"g-col-12\"><h1 ng-if=\"main.de\"><em>Geheimtipp</em> Fraktur&shy;bilder</h1><h1 ng-if=\"main.en\"><em>Insiders’ tip</em> The Fracture Paintings</h1></div></div><div class=\"g-row g-drop-5\"><div class=\"g-col-12 g-col-m-7 g-offset-m-2\"><p class=\"intro\" ng-if=\"main.de\">Baselitz interessiert der Inhalt seiner Gemälde immer weniger. Viel wichtiger werden ihm formale Aspekte und die Wahrnehmung der Objekte.</p><p class=\"intro\" ng-if=\"main.en\">Baselitz is ever less interested in the content of his paintings. Now formal aspects and the perception of objects become much more important to him.</p></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-7 g-offset-m-3\"><p ng-if=\"main.de\">Ab 1966 entwickelt Georg Baselitz sogenannte Frakturbilder, die das Thema der Helden weiterführen. Er teilt dafür die Leinwand in zwei oder drei horizontale Abschnitte und malt die Körperfragmente unabhängig voneinander. Sie beziehen sich zwar aufeinander – fügen sich aber nie so recht zu einer Gestalt zusammen.</p><p ng-if=\"main.en\">Starting in 1966, Georg Baselitz developed the so-called “Fracture Paintings”, which continued the heroes theme. Now he divided the canvas into two or three horizontal sections and painted the body fragments independently of one another. They are interrelated – but somehow don’t really join to form a cohesive figure.</p></div></div><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-6 g-offset-m-5\"><figure><div ui-scrollmove=\"\" end-at-y=\"0.33\"><ui-img alt=\"\" image=\"grosse-nacht_heimat_gb_m_1966_00_00_27.jpg\" rect=\"0,0,3305,1412\"></ui-img></div><div ui-scrollmove=\"right\" end-at-y=\"0.43\" class=\"hide-small\"><ui-img alt=\"\" image=\"grosse-nacht_heimat_gb_m_1966_00_00_27.jpg\" rect=\"0,1413,3305,1386\"></ui-img></div><div ui-scrollmove=\"left\" end-at-y=\"0.56\" class=\"hide-small\"><ui-img alt=\"\" image=\"grosse-nacht_heimat_gb_m_1966_00_00_27.jpg\" rect=\"0,2790,3305,1393\"></ui-img></div><div ui-dragmove=\"\" start-x=\"100\" class=\"hide-medium-up\"><ui-img alt=\"\" image=\"grosse-nacht_heimat_gb_m_1966_00_00_27.jpg\" rect=\"0,1413,3305,1386\"></ui-img></div><div ui-dragmove=\"\" start-x=\"0\" class=\"hide-medium-up\"><ui-img alt=\"\" image=\"grosse-nacht_heimat_gb_m_1966_00_00_27.jpg\" rect=\"0,2790,3305,1393\"></ui-img></div><figcaption ng-if=\"main.de\">Georg Baselitz, Gr. Nacht im Eimer – Heimat, 1966, Öl auf Leinwand, 180 x 140 cm, Privatbesitz</figcaption><figcaption ng-if=\"main.en\">Georg Baselitz, Big Night Down the Drain – Native Country, 1966, oil on canvas, 180 x 140 cm, Privately owned</figcaption></figure></div></div><div class=\"g-row g-drop-2 g-push-2\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p ng-if=\"main.de\">Vom skandalösen „Malerschwein“ zum analytischen Maler: Baselitz versucht nun, eine Ordnung für seine stark emotionale Malerei zu schaffen. Eine regulierende Gliederung zu finden, ist sein Ziel. Der Inhalt rückt dabei in den Hintergrund – stattdessen ist ihm der rein formale Aspekt seiner Kunst wichtiger.</p><p ng-if=\"main.en\">From scandalous “painter swine” to analytical painter: now Baselitz endeavoured to create an order for his strongly emotional paintings. His aim was to find a regulatory structure. The contents receded to the background – and for the artist the purely formal aspects of his art now came to the fore.</p></div></div><ui-audioplayer ng-if=\"main.de\" audio=\"assets/audio/de_spur_3_123.mp3\" title=\"Georg Baselitz’ Überlegungen zu den Frakturbildern\"></ui-audioplayer><ui-audioplayer ng-if=\"main.en\" audio=\"assets/audio/en_123_VO.mp3\" title=\"Georg Baselitz’s thoughts on the Fracture Paintings\"></ui-audioplayer><div class=\"g-drop-3\"></div><ui-dropmore class=\"digit-baselitz__dropmore-7\" ani-dir=\"left\" start-pos=\"0\" end-pos=\"19.375\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><article><div class=\"g-row g-drop-3\"><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><h3 ng-if=\"main.de\">Baselitz’ Inspiration</h3><h3 ng-if=\"main.en\">Baselitz’s inspiration</h3></div></div><div class=\"g-row g-drop-1 g-push-3\"><div class=\"g-col-12 g-col-m-6 g-offset-m-1\"><p ng-if=\"main.de\">Die Methode, die Baselitz für seine Frakturbilder nutzt, wandten bereits die Surrealisten an. „Cadavre Exquis“ (dt.: köstliche Leiche) nannten sie die eher spielerische Methode. Dafür falteten sie ein Blatt Papier in mehrere Teile. Jeder malte nur an seinem eigenen Abschnitt, konnte aber nicht das gesamte Bild sehen. Anschließend gaben sie das Papier weiter und der nächste Teil wurde bemalt. Erst am Ende wurde es geöffnet und das Resultat begutachtet. Das Unvorhersehbare, Unkomponierte faszinierte die Künstler. Auf diese Weise entstanden fantastisch komponierte Figuren.</p><p ng-if=\"main.en\">Already the Surrealists had employed the method Baselitz used for his Fracture Paintings. They had called this playful technique “cadaver exquis” (“exquisite corpse”). To this end they folded a piece of paper into several sections. Each painter worked only on his own section, but without being able to see the overall picture. Then he passed the paper on and the next section was painted. Only after everyone was finished did they unfold the paper and evaluate the result. The artists were fascinated by the unforeseeable, uncomposed quality of the image. It was a method that produced fantastically composed figures.</p></div></div></article></div></div></ui-dropmore><div class=\"g-row g-drop-2 g-push-5\"><div class=\"g-col-12 g-col-m-8 g-offset-m-1\"><p ng-if=\"main.de\">Mit dem verstärkten Interesse an der Form eines Gemäldes rückte der Inhalt für Baselitz immer stärker in den Hintergrund. Indem er seine Motive auf den Kopf stellt, nimmt er sich fortan die Freiheit, sich nur noch mit rein malerischen Problemen zu befassen. Diese Entscheidung sollte Baselitz’ Durchbruch bedeuten und prägt seine Malerei bis heute.</p><p ng-if=\"main.en\">As his interest in the form of a painting grew, content receded ever further into the background for Baselitz. By turning his motifs upside down, he now took the liberty of concerning himself solely with problems of a purely painterly nature. This decision was to bring about the artist’s breakthrough and is still of formative importance for his painting today.</p></div></div></section><digit-baselitz-footer show-copyrights=\"digit.showCopyrights\"><copyrights><ng-include src=\"\'app/digit-baselitz/digit-baselitz-copyrights-\' + main.lang + \'.html\'\"></ng-include></copyrights><legals><ng-include src=\"\'app/digit-baselitz/digit-baselitz-legals-\' + main.lang + \'.html\'\"></ng-include></legals></digit-baselitz-footer></div>");
$templateCache.put("app/digit-baselitz-footer/digit-baselitz-footer.html","<footer class=\"digit-footer digit-footer--{{vm.context}}\"><div ng-style=\"{\'min-height\' : vm.outerHeight + \'px\'}\"><div class=\"digit-footer__inner\" ng-class=\"{\'show\' : vm.showSidebar}\"><div class=\"digit-footer__toggle\" ng-if=\"vm.context === \'sidebar\'\" ng-click=\"vm.showSidebar = !vm.showSidebar\"><em>i</em></div><div class=\"digit-footer__inner-content\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-3 g-align-m-right text-right-m g-push-3\" ng-if=\"vm.context === \'bottom\'\"><a class=\"cta cta--filled\" href=\"#top\" du-smooth-scroll=\"top\"><span ng-if=\"main.de\">Nach oben</span> <span ng-if=\"main.en\">To top</span><ui-button type=\"arrow-plain-up\"></ui-button></a></div><div class=\"g-col-12 g-col-m-9\"><h2 ng-if=\"main.de\">Rund um die Ausstellung</h2><h2 ng-if=\"main.en\">About the exhibition</h2></div></div><div class=\"g-row\"><div class=\"digit-footer__teaser digit-footer__teaser--sharing\" ng-if=\"vm.context === \'sidebar\'\"><h3>Sharing</h3><a target=\"_blank\" href=\"{{main.sharing.facebook}}\"><ui-button type=\"facebook\"></ui-button>Facebook</a> <a target=\"_blank\" href=\"{{main.sharing.twitter}}\"><ui-button type=\"twitter\"></ui-button>Twitter</a> <a target=\"_blank\" href=\"{{main.sharing.pinterest}}\"><ui-button type=\"pinterest\"></ui-button>Pinterest</a> <a href=\"{{main.sharing.mail}}\"><ui-button type=\"email\"></ui-button>E-Mail</a></div><div class=\"digit-footer__teaser\"><h3 ng-if=\"main.de\">Online-Ticket</h3><h3 ng-if=\"main.en\">Online ticket</h3><figure><ui-img alt=\"\" image=\"tickets.jpg\"></ui-img><figcaption ng-if=\"main.de\">Ihre Eintrittskarte bequem von zu Hause.</figcaption><figcaption ng-if=\"main.en\">Skip the line</figcaption></figure><a target=\"_blank\" class=\"cta\" href=\"https://ticketathome.de/Home.aspx?shopid=5&ac=1\"><span ng-if=\"main.de\">Zum Ticketkauf</span> <span ng-if=\"main.en\">Tickets</span><ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser\"><h3 ng-if=\"main.de\">Katalog</h3><h3 ng-if=\"main.en\">Catalogue</h3><figure><ui-img alt=\"\" ng-if=\"main.de\" image=\"katd.jpg\"></ui-img><ui-img alt=\"\" ng-if=\"main.en\" image=\"kate.jpg\"></ui-img><figcaption ng-if=\"main.de\">Wissen vertiefen. Demnächst im Städel Online-Shop erhältlich</figcaption><figcaption ng-if=\"main.en\">Learn more: coming soon in the Städel Online Shop</figcaption></figure><a target=\"_blank\" class=\"cta\" href=\"https://ticketathome.de/Shop/Index.aspx?group=255&shopid=5&ac=1\"><span ng-if=\"main.de\">Katalog bestellen</span> <span ng-if=\"main.en\">Catalogue</span><ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser\"><h3>Service</h3><figure><ui-img alt=\"\" image=\"service.jpg\"></ui-img><figcaption ng-if=\"main.de\">Öffnungszeiten, Ticketpreise, Anfahrt, etc.</figcaption><figcaption ng-if=\"main.en\">Opening hours, ticket prices, directions etc.</figcaption></figure><a target=\"_blank\" ng-if=\"main.de\" class=\"cta\" href=\"http://www.staedelmuseum.de/de/informationen-service?utm_source=baselitz.staedelmuseum.de&utm_medium=display&utm_campaign=Baselitz_Digitorial_dt\">Mehr Informationen<ui-button type=\"arrow-plain-right\"></ui-button></a> <a target=\"_blank\" ng-if=\"main.en\" class=\"cta\" href=\"http://www.staedelmuseum.de/en/information-service?utm_source=baselitz.staedelmuseum.de&utm_medium=display&utm_campaign=Baselitz_Digitorial_en\">More<ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser\" ng-if=\"main.de\"><h3>Kalender</h3><figure><ui-img alt=\"\" image=\"kalender.jpg\"></ui-img><figcaption>Unsere Veranstaltungstipps</figcaption></figure><a target=\"_blank\" class=\"cta\" href=\"http://www.staedelmuseum.de/de/kalender?utm_source=baselitz.staedelmuseum.de&utm_medium=display&utm_campaign=Baselitz_Digitorial_dt\">Zum Kalender<ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser\" ng-if=\"main.de\"><h3>Newsletter</h3><figure><ui-img alt=\"\" image=\"newsletter.jpg\"></ui-img><figcaption>Schnell und individuell informiert.</figcaption></figure><a target=\"_blank\" class=\"cta\" href=\"http://mailing.staedelmuseum.de/anmeldung_staedel_newsletter.jsp\">Newsletter abonnieren<ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser\"><h3 ng-if=\"main.de\">Wissenswert</h3><h3 ng-if=\"main.en\">Good to know</h3><figure><ui-img ng-if=\"main.de\" alt=\"\" image=\"onlinekurs.jpg\"></ui-img><ui-img ng-if=\"main.en\" alt=\"\" image=\"arthistoryonline.jpg\"></ui-img><figcaption ng-if=\"main.de\">Finden Sie es heraus: Kunstgeschichte Online – Der Städel Kurs zur Moderne</figcaption><figcaption ng-if=\"main.en\">Knowing more, seeing more. Discover the online course on modern art by the Städel Museum</figcaption></figure><a ng-if=\"main.de\" target=\"_blank\" class=\"cta\" href=\"http://onlinekurs.staedelmuseum.de/?utm_source=baselitz.staedelmuseum.de&utm_medium=display&utm_campaign=Baselitz_Digitorial_dt\">Zum Kurs<ui-button type=\"arrow-plain-right\"></ui-button></a> <a ng-if=\"main.en\" target=\"_blank\" class=\"cta\" href=\"http://onlinekurs.staedelmuseum.de/en/?utm_source=baselitz.staedelmuseum.de&utm_medium=display&utm_campaign=Baselitz_Digitorial_dt\">Take the course<ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser noborder-m\"><h3 ng-if=\"main.de\">Zuletzt</h3><h3 ng-if=\"main.en\">Last but not least</h3><figure><ui-img alt=\"\" image=\"zuletzt.jpg\"></ui-img><figcaption ng-if=\"main.de\">Mit dem Digitorial auch nach der Ausstellung bestens informiert</figcaption><figcaption ng-if=\"main.en\">Well informed – take the digitorial</figcaption></figure><a ng-if=\"main.de\" target=\"_blank\" class=\"cta\" href=\"http://maniera.staedelmuseum.de/?utm_source=baselitz.staedelmuseum.de&utm_medium=display&utm_campaign=Baselitz_Digitorial_dt\">Zum Digitorial<ui-button type=\"arrow-plain-right\"></ui-button></a> <a ng-if=\"main.en\" target=\"_blank\" class=\"cta\" href=\"http://maniera.staedelmuseum.de/en/?utm_source=baselitz.staedelmuseum.de&utm_medium=display&utm_campaign=Baselitz_Digitorial_en\">Digitorial<ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser noborder\" ng-if=\"vm.context === \'bottom\'\"><h3 ng-if=\"main.de\">Mit dem Städel vernetzen</h3><h3 ng-if=\"main.en\">Network with the Städel</h3><p ng-if=\"main.de\">Rundum informiert sein über Ausstellungen und Veranstaltungen</p><p ng-if=\"main.en\">Find all you need to know about the exhibitions and events here</p><div class=\"digit-footer__socials\"><ui-socialicon new-window=\"true\" type=\"facebook\" theme=\"bright\" href=\"https://www.facebook.com/staedelmuseum\"></ui-socialicon><ui-socialicon new-window=\"true\" type=\"twitter\" theme=\"bright\" href=\"https://twitter.com/staedelmuseum\"></ui-socialicon><ui-socialicon new-window=\"true\" type=\"youtube\" theme=\"bright\" href=\"https://www.youtube.com/user/staedelmuseum\"></ui-socialicon><ui-socialicon new-window=\"true\" type=\"instagram\" theme=\"bright\" href=\"https://www.instagram.com/staedelmuseum/\"></ui-socialicon><ui-socialicon new-window=\"true\" type=\"gplus\" theme=\"bright\" href=\"https://plus.google.com/104640651245729551978/posts\"></ui-socialicon></div></div></div><div class=\"g-row\" ng-if=\"vm.context === \'bottom\'\"><div class=\"g-col-12\"><div class=\"digit-footer__partner\"><p>Das Digitorial wird ermöglicht durch die</p><img src=\"assets/images/aventisfoundation.svg\" alt=\"Aventis Foundation\"></div></div></div><div class=\"g-row\" ng-if=\"vm.context === \'bottom\'\"><div class=\"g-col-12 g-col-m-12\"><div class=\"digit-footer__terminal\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-6 g-align-m-right clearfix\"><ul class=\"digit-footer__metanav\" ng-if=\"main.de\"><li><a href=\"http://www.staedelmuseum.de/de/datenschutz\" target=\"_blank\">Datenschutz</a></li><li><a href=\"http://www.staedelmuseum.de/de/impressum-digitorial-afkm\" target=\"_blank\">Impressum</a></li><li><a href=\"#copyrights\" du-smooth-scroll=\"\" ng-click=\"vm.showCopyrights = !vm.showCopyrights\">Quellen und Bildnachweise</a></li></ul><ul class=\"digit-footer__metanav\" ng-if=\"main.en\"><li><a href=\"http://www.staedelmuseum.de/en/privacy-policy\" target=\"_blank\">Privacy Policy</a></li><li><a href=\"http://www.staedelmuseum.de/en/imprint-digitorial-afkm\" target=\"_blank\">Imprint</a></li><li><a href=\"#copyrights\" du-smooth-scroll=\"\" ng-click=\"vm.showCopyrights = !vm.showCopyrights\">Sources and picture credits</a></li></ul></div><div class=\"g-col-12 g-col-m-6 g-drop-s-2\"><p>Copyright &copy; 2016 Städel Museum. All rights reserved</p></div></div></div></div></div></div></div></div><aside class=\"digit-footer__copyrights\" id=\"copyrights\" ng-show=\"vm.showCopyrights\"><div ng-transclude=\"copyrights\"></div></aside></footer>");
$templateCache.put("app/main/main.html","<div class=\"view-main lang-{{main.lang}}\"><div class=\"site-header\"><div class=\"g-row\"><div class=\"g-col-6\"><ui-brand theme=\"\'bright\'\" brand-title=\"true\" ref=\"http://www.staedelmuseum.de/\" new-window=\"false\"></ui-brand></div><div class=\"g-col-6 g-offset-6\"><div class=\"site-languages\"><ui-button ng-click=\"main.reload(\'de\')\" type=\"lang-de\" ng-if=\"main.lang === \'en\'\"></ui-button><ui-button ng-click=\"main.reload(\'en\')\" type=\"lang-en\" ng-if=\"main.lang === \'de\'\"></ui-button></div><div class=\"site-sharing\"><ui-button type=\"share\" ng-click=\"main.showSharing = !main.showSharing\"></ui-button><div ng-show=\"main.showSharing\"><a target=\"_blank\" href=\"{{main.sharing.facebook}}\"><ui-button type=\"facebook\"></ui-button></a> <a target=\"_blank\" href=\"{{main.sharing.twitter}}\"><ui-button type=\"twitter\"></ui-button></a> <a target=\"_blank\" href=\"{{main.sharing.pinterest}}\"><ui-button type=\"pinterest\"></ui-button></a> <a href=\"{{main.sharing.mail}}\"><ui-button type=\"email\"></ui-button></a></div></div></div></div></div><main class=\"digitorial\" broadcast-domchange=\"\"><digit-baselitz></digit-baselitz></main></div>");
$templateCache.put("app/components/ui-audioplayer/ui-audioplayer.html","<div class=\"ui-audioplayer\"><div class=\"g-row\"><div class=\"g-col-12 g-offset-m-1 g-col-m-10\"><audio media-player=\"player\"><source ng-src=\"{{vm.audio}}\" type=\"audio/mp3\"></audio><ui-button type=\"play\" ng-if=\"!vm.isPlaying\" ng-click=\"vm.play()\"></ui-button><ui-button type=\"pause\" ng-if=\"vm.isPlaying\" ng-click=\"vm.pause()\"></ui-button><h4>{{vm.title}}</h4><em class=\"ui-audioplayer__time\" ng-if=\"vm.progress > 0\">{{player.formatTime}}</em></div></div><div class=\"ui-audioplayer__progress\" ng-click=\"vm.jumpToTime($event)\"><span ng-style=\"{width : (vm.progress * 100) + \'%\'}\"></span></div></div>");
$templateCache.put("app/components/ui-brand/ui-brand.html","<h1 class=\"ui-brand ui-brand--{{brand.theme}}\"><a href=\"{{brand.ref}}\" ng-attr-target=\"{{brand.newWindow ? \'_blank\' : \'\'}}\"><div class=\"ui-brand__logo\"><svg width=\"42\" height=\"69\" viewbox=\"0 0 42 69\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><g fill=\"#000\"><path d=\"M36.928 52.248c.773-2.49 3.006-9.624-20.87-17.874C8.074 31.624.947 27.584.947 18.218.946 7.048 9.962 0 20.696 0c6.01 0 12.625 2.233 17.176 4.382v13.234h-.687C33.665 4.468 28.082 1.03 20.61 1.03c-5.58 0-9.53 3.438-9.618 8.078 0 9.54 17.26 12.462 26.365 20.712 6.7 6.1 4.98 17.874.086 22.86l-.515-.432zM21.47 60.844C6.955 60.414 1.202 44.6.86 41.164H0l.773 15.21c7.04 3.523 14.857 5.758 21.297 5.243l-.6-.773zM.766 68.88h40.94v-1.568H.766v1.57z\"></path></g></g></svg></div><div ng-if=\"brand.brandTitle\" class=\"ui-brand__title\"><span>Städel Museum</span><svg width=\"42\" height=\"20\" viewbox=\"0 0 42 20\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M3.313 8.305c-.908 0-1.792-.293-2.523-.682L.436 9.18c.685.388 1.744.67 2.84.67 1.935 0 3.02-.988 3.02-2.393 0-1.403-1.182-1.922-2.312-2.228-.884-.25-1.556-.44-1.556-.922 0-.4.318-.626.966-.626.732 0 1.652.26 2.38.648l.367-1.545c-.706-.388-1.602-.648-2.758-.648-1.826 0-2.828.91-2.828 2.276 0 1.476 1.298 1.97 2.37 2.267.978.27 1.508.435 1.508.93 0 .45-.46.695-1.12.695zm10.155-4.433v-1.57H6.903v1.57H9.25v5.802h1.873V3.872h2.345zm3.498-.118l-.978 2.89h1.92l-.942-2.89zm1.898 5.92l-.542-1.57h-2.735l-.53 1.57h-1.862l2.616-7.372h2.346l2.57 7.372h-1.862zm7.828-3.667c0-1.524-.765-2.206-2.298-2.206h-.78V8.18h.873c1.357 0 2.205-.696 2.205-2.17zm1.885-.07c0 2.264-1.497 3.737-4.196 3.737h-2.64V2.302h2.77c2.595 0 4.067 1.44 4.067 3.634zm6.673 3.737v-1.51H31.7v-1.44h2.853V5.23H31.7V3.81h3.55v-1.51h-5.388v7.372h5.388zm6.458 0v-1.57h-2.96V2.303h-1.873v7.372h4.833zM16.45.882c0-.512-.317-.788-.808-.788-.48 0-.807.276-.807.788 0 .513.327.79.807.79.49 0 .81-.277.81-.79zm2.564 0c0-.512-.317-.788-.81-.788-.477 0-.806.276-.806.788 0 .513.33.79.807.79.492 0 .81-.277.81-.79zM40.52 19.44h.953l-.222-6.927h-1.23l-2.113 5.695-2.128-5.695h-1.253l-.233 6.927h.92l.078-5.775 2.114 5.675h.943l2.103-5.664.067 5.764zm-7.442-2.673v-4.254h-.93v4.278c0 1.297-.665 1.93-1.74 1.93-1.23 0-1.827-.744-1.827-1.996v-4.21h-.93v4.354c0 1.663.964 2.738 2.702 2.738 1.818 0 2.726-1.086 2.726-2.84zm-6.68 2.673v-.876h-3.445v-2.162h2.868v-.876h-2.867v-2.138H26.4v-.875h-4.39v6.927h4.39zm-8.22-.677c-.81 0-1.44-.277-2.027-.664l-.31.852c.665.42 1.507.654 2.316.654 1.45 0 2.436-.876 2.436-2.074 0-1.307-1.03-1.795-2.04-2.06-1.095-.3-1.683-.544-1.683-1.24 0-.58.41-1.033 1.407-1.033.62 0 1.306.22 1.84.576l.332-.82c-.666-.41-1.386-.61-2.184-.61-1.373 0-2.315.787-2.315 1.95 0 1.34 1.086 1.763 2.073 2.03 1.13.3 1.66.564 1.66 1.274 0 .687-.63 1.163-1.506 1.163zm-3.443-1.996v-4.254h-.93v4.278c0 1.297-.665 1.93-1.74 1.93-1.23 0-1.828-.744-1.828-1.996v-4.21h-.93v4.354c0 1.663.963 2.738 2.703 2.738 1.818 0 2.725-1.086 2.725-2.84zm-7.71 2.673h.95l-.22-6.927h-1.23L4.41 18.208l-2.127-5.695H1.03L.8 19.44h.918l.077-5.775L3.91 19.34h.942l2.104-5.664.068 5.764z\" fill=\"#000\"></path></g></svg></div></a></h1>");
$templateCache.put("app/components/ui-button/ui-button.html","<div class=\"ui-button ui-button--{{button.type}} is-{{button.state}}\"><a ng-if=\"button.ref\" ui-sref=\"{{button.ref}}\" ng-click=\"button.blurCond()\"></a><div ng-if=\"button.type === \'plus\' || button.type === \'openclose\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#000\" fill-rule=\"evenodd\"><path d=\"M30.426 53.426c12.703 0 23-10.297 23-23 0-12.702-10.297-23-23-23-12.702 0-23 10.298-23 23 0 12.703 10.298 23 23 23zm0 7c-16.568 0-30-13.43-30-30 0-16.568 13.432-30 30-30 16.57 0 30 13.432 30 30 0 16.57-13.43 30-30 30z\"></path><path d=\"M43.616 34.39l-.163-7.546h-8.956v-9.228h-8.142v9.228H17.4l-.164 7.545h9.12v9.226h8.14V34.39z\"></path></g></svg></div><div ng-if=\"button.type === \'arrow-plain-right\' || button.type === \'arrow-plain-up\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"61\" viewbox=\"0 0 61 62\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#1A1918\" d=\"M27.48 60.257L60 31.44v-2.624L27.48 0l-1.86 2.165 25.686 25.882H0v4.166H51.3l-25.68 25.88 1.86 2.164\" fill-rule=\"evenodd\"></path></svg></div><div ng-if=\"button.type === \'down-trans\' || button.type === \'play\' || button.type === \'arrow-right\' || button.type === \'arrow-left\' || button.type === \'arrow-up\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M7 30c0 12.703 10.297 23 23 23s23-10.297 23-23S42.703 7 30 7 7 17.297 7 30zm-7 0C0 13.43 13.43 0 30 0s30 13.43 30 30-13.43 30-30 30S0 46.57 0 30z\"></path><path d=\"M18.245 25.573s12.072 15.277 12.15 15.18l12.178-15.18H18.245z\"></path></g></svg></div><div ng-if=\"button.type === \'pause\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M30 53c12.703 0 23-10.297 23-23S42.703 7 30 7 7 17.297 7 30s10.297 23 23 23zm0 7C13.43 60 0 46.57 0 30S13.43 0 30 0s30 13.43 30 30-13.43 30-30 30z\"></path><path d=\"M32 20h8v20h-8zM20 20h8v20h-8z\"></path></g></svg></div><div ng-if=\"button.type === \'lang-en\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M30 53c12.703 0 23-10.297 23-23S42.703 7 30 7 7 17.297 7 30s10.297 23 23 23zm0 7C13.43 60 0 46.57 0 30S13.43 0 30 0s30 13.43 30 30-13.43 30-30 30z\"></path><path d=\"M27.712 37v-3.672h-7.104v-2.016h5.616V27.64h-5.616v-1.968h7.104V22H16v15h11.712zm12.792-6.48L35.176 22h-5.088v15h4.392v-8.496l5.4 8.64h5.016V22h-4.392v8.52z\"></path></g></svg></div><div ng-if=\"button.type === \'lang-de\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M30.664 29.392c0-4.464-3-7.392-8.448-7.392H16v15h5.88c5.664 0 8.784-3 8.784-7.608zm-4.752.144c0 2.664-1.416 3.84-3.768 3.84h-1.416v-7.752h1.176c2.76 0 4.008 1.128 4.008 3.912zM44.512 37v-3.672h-7.104v-2.016h5.616V27.64h-5.616v-1.968h7.104V22H32.8v15h11.712z\"></path><path d=\"M30 53c12.703 0 23-10.297 23-23S42.703 7 30 7 7 17.297 7 30s10.297 23 23 23zm0 7C13.43 60 0 46.57 0 30S13.43 0 30 0s30 13.43 30 30-13.43 30-30 30z\"></path></g></svg></div><div ng-if=\"button.type === \'share\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><title>share</title><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M13.737 46.263c8.982 8.983 23.544 8.983 32.526 0 8.983-8.982 8.983-23.544 0-32.526-8.982-8.983-23.544-8.983-32.526 0-8.983 8.982-8.983 23.544 0 32.526zm-4.95 4.95c-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0z\"></path><path d=\"M36.253 33.856a4.728 4.728 0 0 0-3.5 1.547l-7.54-3.626c.18-.502.282-1.04.282-1.603s-.103-1.1-.283-1.603l7.54-3.625a4.732 4.732 0 0 0 3.5 1.55 4.747 4.747 0 1 0-4.746-4.748c0 .25.025.496.063.737l-8.028 3.86a4.72 4.72 0 0 0-2.795-.916 4.746 4.746 0 0 0 0 9.493c1.046 0 2.01-.342 2.794-.916l8.028 3.86c-.037.24-.063.486-.063.737a4.747 4.747 0 1 0 4.748-4.744z\"></path></g></svg></div><div ng-if=\"button.type === \'facebook\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><title>facebook</title><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M13.737 46.263c8.982 8.983 23.544 8.983 32.526 0 8.983-8.982 8.983-23.544 0-32.526-8.982-8.983-23.544-8.983-32.526 0-8.983 8.982-8.983 23.544 0 32.526zm-4.95 4.95c-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0z\"></path><path d=\"M36.048 16.006l-3.5-.006c-3.935 0-6.477 2.608-6.477 6.645v3.063h-3.52a.55.55 0 0 0-.55.55v4.44c0 .304.247.55.55.55h3.52v11.2c0 .306.247.552.55.552h4.595a.55.55 0 0 0 .55-.55v-11.2h4.116a.55.55 0 0 0 .552-.552l.002-4.44a.55.55 0 0 0-.55-.55h-4.12V23.11c0-1.247.3-1.88 1.925-1.88l2.357-.002a.55.55 0 0 0 .55-.55v-4.122a.55.55 0 0 0-.55-.55z\"></path></g></svg></div><div ng-if=\"button.type === \'twitter\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><title>twitter</title><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M13.737 46.263c8.982 8.983 23.544 8.983 32.526 0 8.983-8.982 8.983-23.544 0-32.526-8.982-8.983-23.544-8.983-32.526 0-8.983 8.982-8.983 23.544 0 32.526zm-4.95 4.95c-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0z\"></path><path d=\"M43 21.595c-.994.44-2.06.74-3.18.872a5.562 5.562 0 0 0 2.434-3.062 11.166 11.166 0 0 1-3.52 1.345 5.54 5.54 0 0 0-9.438 5.05 15.725 15.725 0 0 1-11.415-5.788 5.497 5.497 0 0 0-.748 2.784c0 1.922.98 3.617 2.463 4.61a5.54 5.54 0 0 1-2.508-.696v.07a5.544 5.544 0 0 0 4.442 5.43 5.61 5.61 0 0 1-1.46.195c-.358 0-.704-.036-1.043-.103A5.542 5.542 0 0 0 24.2 36.15a11.113 11.113 0 0 1-6.88 2.366c-.446 0-.886-.027-1.32-.076a15.656 15.656 0 0 0 8.49 2.492c10.19 0 15.758-8.44 15.758-15.76l-.018-.716a11.06 11.06 0 0 0 2.77-2.86z\"></path></g></svg></div><div ng-if=\"button.type === \'pinterest\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><title>pinterest</title><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M37.47 18.767C35.61 16.983 33.037 16 30.226 16c-4.295 0-6.937 1.76-8.396 3.237-1.798 1.82-2.83 4.237-2.83 6.63 0 3.006 1.257 5.313 3.362 6.17.142.06.284.088.423.088.444 0 .796-.29.918-.756.07-.27.236-.928.308-1.215.154-.566.03-.838-.304-1.23-.61-.722-.893-1.574-.893-2.683 0-3.293 2.453-6.793 6.998-6.793 3.607 0 5.847 2.05 5.847 5.348 0 2.082-.448 4.01-1.263 5.43-.566.986-1.56 2.162-3.09 2.162-.66 0-1.254-.272-1.628-.745-.354-.447-.47-1.025-.328-1.628.16-.68.38-1.39.592-2.076.387-1.252.752-2.436.752-3.38 0-1.616-.993-2.7-2.47-2.7-1.88 0-3.35 1.906-3.35 4.342 0 1.194.317 2.087.46 2.43-.236 1.003-1.642 6.963-1.91 8.087-.153.655-1.082 5.837.456 6.25 1.728.464 3.272-4.583 3.43-5.153.127-.464.572-2.218.846-3.296.834.805 2.177 1.348 3.483 1.348 2.464 0 4.68-1.11 6.24-3.12 1.51-1.954 2.344-4.675 2.344-7.663 0-2.336-1.002-4.64-2.75-6.318z\"></path><path d=\"M13.737 46.263c8.982 8.983 23.544 8.983 32.526 0 8.983-8.982 8.983-23.544 0-32.526-8.982-8.983-23.544-8.983-32.526 0-8.983 8.982-8.983 23.544 0 32.526zm-4.95 4.95c-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0z\"></path></g></svg></div><div ng-if=\"button.type === \'email\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><title>mail</title><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M13.737 46.263c8.982 8.983 23.544 8.983 32.526 0 8.983-8.982 8.983-23.544 0-32.526-8.982-8.983-23.544-8.983-32.526 0-8.983 8.982-8.983 23.544 0 32.526zm-4.95 4.95c-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0z\"></path><path d=\"M29.53 32.027h.007a.96.96 0 0 0 .525-.155l.04-.026c.01-.006.02-.01.03-.017l.475-.395 11.367-9.38a.134.134 0 0 0-.107-.055H17.132c-.03 0-.06.01-.082.03l11.893 9.802c.15.124.363.195.588.195zM17 23.33v13.903l8.52-6.882L17 23.33zm16.49 7.068l8.51 6.84V23.374l-8.51 7.023zm-2.706 2.232a1.97 1.97 0 0 1-1.25.432 1.97 1.97 0 0 1-1.25-.43l-1.95-1.61L17 38.563v.024c0 .072.06.133.134.133h24.734c.07 0 .132-.062.132-.134v-.022l-9.326-7.494-1.89 1.56z\"></path></g></svg></div></div>");
$templateCache.put("app/components/ui-chaptercover/ui-chaptercover.html","<div class=\"ui-chaptercover__container\" ng-class=\"{\'unfixed\' : vm.unfixed}\"><hr class=\"ui-chaptercover__progressor\"><div class=\"ui-chaptercover ui-chaptercover--{{vm.theme}}\" ng-class=\"{\'active\' : vm.active}\"><p ng-if=\"vm.showprogress\" style=\"position: absolute; padding: 20px; z-index: 2; background: white\">{{vm.progress}}</p><div class=\"ui-chaptercover__inner\" ng-attr-style=\"-ms-transform: {{vm.styles.inner.transform}}; transform: {{vm.styles.inner.transform}}\"><div class=\"ui-chaptercover__title\"><div class=\"g-row\"><div class=\"ui-chaptercover__title-inner\"><ng-transclude></ng-transclude></div></div></div></div><div class=\"ui-chaptercover__background\" ng-attr-style=\"-ms-transform: {{vm.styles.background.transform}}; transform: {{vm.styles.background.transform}}\"></div><div class=\"ui-chaptercover__image\" ng-attr-style=\"-ms-transform: {{vm.styles.image.transform}}; transform: {{vm.styles.image.transform}}\"><ui-img alt=\"\" image=\"{{vm.img}}\" cover=\"true\" crop=\"top\"></ui-img></div><div class=\"ui-chaptercover__underlay\" ng-style=\"vm.styles.underlay\"></div></div></div>");
$templateCache.put("app/components/ui-check-device/ui-check-device.html","<div class=\"ui-check-device\" ng-class=\"{\'missing-features\' : !vm.features, \'wrong-ratio\' : !vm.ratio}\"><div class=\"ui-check-device__inner\"><h1 class=\"msg msg--missing-features\"><svg width=\"100\" height=\"87\" viewbox=\"0 0 100 87\" xmlns=\"http://www.w3.org/2000/svg\"><title>legacy</title><g fill=\"#000\" fill-rule=\"evenodd\"><path d=\"M86.098 59.007c-1.182 0-2.33.15-3.426.427l-8.164-21.976c-2.98-8.024-8.273-14.895-15.306-19.87a42.56 42.56 0 0 0-6.462-3.77l5.538-5.524a1.59 1.59 0 0 0 .346-1.734 1.596 1.596 0 0 0-1.474-.982H46.32c-.88 0-1.594.712-1.594 1.59 0 .88.714 1.592 1.595 1.592h6.977l-3.73 3.722A42.23 42.23 0 0 0 36.308 9.84V3.182h2.658c.88 0 1.596-.712 1.596-1.592 0-.878-.715-1.59-1.596-1.59h-8.51c-.882 0-1.596.712-1.596 1.59 0 .88.714 1.593 1.595 1.593h2.66v14.35C14.714 18.37 0 33.56 0 52.117c0 19.09 15.572 34.62 34.713 34.62 19.14 0 34.713-15.53 34.713-34.62 0-18.556-14.715-33.747-33.117-34.582v-4.51C52 13.67 66.02 23.77 71.515 38.565l8.175 22.01c-4.447 2.314-7.494 6.956-7.494 12.297 0 7.646 6.237 13.866 13.902 13.866 7.666 0 13.902-6.22 13.902-13.865 0-7.644-6.236-13.863-13.902-13.863zm-19.864-6.89c0 17.333-14.14 31.436-31.52 31.436C17.33 83.553 3.19 69.45 3.19 52.116c0-16.8 13.285-30.565 29.927-31.397v29.805H28.33c-.88 0-1.596.712-1.596 1.59 0 .88.715 1.592 1.596 1.592h12.766c.88 0 1.595-.712 1.595-1.59 0-.88-.713-1.592-1.594-1.592H36.31V20.72c16.64.83 29.924 14.595 29.924 31.396zm19.864 31.436c-5.905 0-10.71-4.792-10.71-10.682 0-3.972 2.188-7.442 5.423-9.282l3.672 9.88a1.596 1.596 0 1 0 2.992-1.105l-3.685-9.92a10.728 10.728 0 0 1 2.308-.253c5.906 0 10.71 4.79 10.71 10.68S92.005 83.554 86.1 83.554z\"></path><path d=\"M40.715 27.9C51.982 30.665 59.85 40.677 59.85 52.25c0 13.824-11.276 25.07-25.137 25.07-13.862 0-25.14-11.246-25.14-25.07 0-11.57 7.87-21.583 19.138-24.347a1.59 1.59 0 0 0-.76-3.09c-6.045 1.483-11.52 4.993-15.42 9.884-4.022 5.044-6.147 11.114-6.147 17.554 0 15.58 12.71 28.254 28.33 28.254 15.62 0 28.33-12.674 28.33-28.254 0-6.44-2.126-12.51-6.147-17.554-3.9-4.89-9.376-8.402-15.42-9.884a1.59 1.59 0 0 0-.762 3.09z\"></path></g></svg><br>Der Städel Onlinekurs erfordert einen modernen Browser und funktioniert ausschließlich auf einem Tablet oder Computer. Ihr Browser scheint leider nicht alle benötigten Features zu unterstützen. Bitte laden Sie sich einen <a href=\"http://outdatedbrowser.com/de\">modernen Browser</a> herunter um das Angebot zu nutzen.</h1><h1 class=\"msg msg--wrong-dimensions\"><svg width=\"68\" height=\"69\" viewbox=\"0 0 68 69\" xmlns=\"http://www.w3.org/2000/svg\"><title>resize</title><path d=\"M68 63.018v2.627a2.62 2.62 0 0 1-2.617 2.627h-2.616a2.62 2.62 0 0 1-2.617-2.627 2.62 2.62 0 0 1 2.617-2.627 2.62 2.62 0 0 1 2.616-2.627A2.62 2.62 0 0 1 68 63.02zm-2.617-34.24a2.62 2.62 0 0 0-2.616 2.623v5.463a2.616 2.616 0 0 0 5.233.003v-5.462a2.62 2.62 0 0 0-2.617-2.627zm0-15.807a2.623 2.623 0 0 0-2.616 2.628v5.462a2.62 2.62 0 0 0 2.616 2.627A2.623 2.623 0 0 0 68 21.057v-5.462a2.62 2.62 0 0 0-2.617-2.624zm0 31.613a2.62 2.62 0 0 0-2.616 2.627v5.46a2.62 2.62 0 0 0 2.616 2.628A2.62 2.62 0 0 0 68 52.67v-5.46a2.62 2.62 0 0 0-2.617-2.627zm0-44.583h-2.616a2.623 2.623 0 0 0-2.617 2.627 2.62 2.62 0 0 0 2.617 2.627 2.62 2.62 0 0 0 2.616 2.627A2.623 2.623 0 0 0 68 5.25V2.628A2.62 2.62 0 0 0 65.383 0zm-18.36 5.25h5.44a2.623 2.623 0 0 0 2.617-2.626A2.62 2.62 0 0 0 52.463 0h-5.44a2.623 2.623 0 0 0-2.616 2.627 2.62 2.62 0 0 0 2.616 2.624zm-31.49 0h5.44a2.623 2.623 0 0 0 2.618-2.626A2.62 2.62 0 0 0 20.978 0h-5.44a2.62 2.62 0 0 0-2.617 2.627c0 1.45 1.17 2.624 2.614 2.624zm15.747 0h5.44a2.62 2.62 0 0 0 2.614-2.626c0-1.45-1.17-2.624-2.614-2.624h-5.44a2.62 2.62 0 0 0-2.614 2.627c0 1.45 1.17 2.624 2.614 2.624zM2.617 7.88A2.623 2.623 0 0 0 5.233 5.25 2.623 2.623 0 0 0 7.85 2.625 2.623 2.623 0 0 0 5.23 0H2.618A2.623 2.623 0 0 0 0 2.627v2.627a2.622 2.622 0 0 0 2.617 2.624zm0 15.806a2.623 2.623 0 0 0 2.616-2.627v-5.462a2.623 2.623 0 0 0-2.616-2.627A2.623 2.623 0 0 0 0 15.595v5.462a2.623 2.623 0 0 0 2.617 2.627zm49.846 39.334h-5.44a2.62 2.62 0 0 0-2.616 2.627 2.62 2.62 0 0 0 2.616 2.627h5.44a2.62 2.62 0 0 0 2.617-2.627 2.62 2.62 0 0 0-2.617-2.627zm3.778-52.354l-16.183 2.03c-.715.086-.88.58-.375 1.088l5.543 5.565-17.34 17.412H5.23v-5.356a2.62 2.62 0 0 0-2.616-2.624A2.618 2.618 0 0 0 0 31.404v5.46c0 .468.152.883.364 1.26-.212.38-.364.795-.364 1.262V65.645a2.623 2.623 0 0 0 2.617 2.627h26.155c.465 0 .88-.153 1.257-.366.37.21.788.363 1.25.363h5.44a2.62 2.62 0 0 0 2.614-2.628 2.62 2.62 0 0 0-2.614-2.627h-5.337V40.28l17.343-17.415 5.538 5.56c.51.51.998.34 1.088-.377l2.02-16.248c.096-.71-.418-1.226-1.13-1.136z\" fill=\"#000\" fill-rule=\"evenodd\"></path></svg><br>Dieser Kurs ist aus Gründen der Nutzerfreundlichkeit und zur verbesserten Darstellung der Kursinhalte ausschließlich für Computer und Tablets ausgelegt. Melden Sie sich daher bitte von einem Gerät mit größerem Bildschirm an.</h1><h1 class=\"msg msg--wrong-orientation\"><svg width=\"143\" height=\"88\" viewbox=\"0 0 143 88\" xmlns=\"http://www.w3.org/2000/svg\"><title>orientation</title><g fill=\"#000\" fill-rule=\"evenodd\"><path d=\"M76 70.19H60.077c0 1.23.263 2.515.79 3.86a36.66 36.66 0 0 0 1.58 3.533c.528 1.012.792 1.734.792 2.165 0 .863-.314 1.61-.94 2.24-.626.63-1.367.947-2.224.947H34.78c-.855 0-1.596-.316-2.222-.947-.626-.63-.938-1.378-.938-2.24 0-.465.263-1.194.79-2.19a35.35 35.35 0 0 0 1.58-3.485c.528-1.326.79-2.622.79-3.883H7.906c-2.174 0-4.034-.78-5.583-2.34C.774 66.29 0 64.418 0 62.226V8.06c0-2.19.774-4.065 2.322-5.625C3.872.875 5.732.095 7.905.095h79.047c2.174 0 4.034.78 5.582 2.34 1.55 1.56 2.323 3.435 2.323 5.625V38h-6.324V8.06c0-.43-.156-.804-.47-1.12a1.512 1.512 0 0 0-1.11-.472H7.905c-.428 0-.8.158-1.112.472-.313.316-.47.69-.47 1.12v41.42c0 .432.158.804.47 1.12.313.315.684.473 1.112.473H76V70.19zM141.13 24.78a1.32 1.32 0 0 0-.966-.41c-.37 0-.692.137-.964.41l-2.786 2.764a16.6 16.6 0 0 0-5.25-3.355c-1.973-.794-4.003-1.19-6.09-1.19-3.928 0-7.358 1.19-10.287 3.57-2.93 2.378-4.858 5.482-5.787 9.31v.15a.66.66 0 0 0 .204.483.66.66 0 0 0 .482.204h4.265c.315 0 .53-.164.644-.493.6-1.43.98-2.265 1.136-2.508 1-1.628 2.33-2.907 3.987-3.836a10.786 10.786 0 0 1 5.358-1.393c2.872 0 5.366.978 7.48 2.936l-2.958 2.958a1.32 1.32 0 0 0-.407.965c0 .372.136.693.407.965.272.27.594.407.965.407h9.602c.372 0 .693-.136.965-.407.27-.272.406-.593.406-.965v-9.602c0-.37-.135-.693-.407-.964z\"></path><path d=\"M142.99 83.523v-38.18A4.34 4.34 0 0 0 138.64 41H83.344A4.343 4.343 0 0 0 79 45.344v38.18c0 2.398 1.948 4.344 4.344 4.344h55.298a4.342 4.342 0 0 0 4.347-4.345zM80.627 64.435a2.58 2.58 0 0 1 5.162 0 2.584 2.584 0 0 1-2.583 2.584 2.582 2.582 0 0 1-2.58-2.585zm7.422 19.037V45.4h49.717V83.47H88.05z\"></path></g></svg><br>Der Städel Onlinekurs ist für Breitbild optimiert. Bitte nutzen Sie diese Webapp im Breitbild-Seitenverhältnis oder drehen Sie ggf. Ihr Tablet um 90°.</h1></div></div>");
$templateCache.put("app/components/ui-dropmore/ui-dropmore.html","<div class=\"ui-dropmore is-{{dm.state}} ui-dropmore--{{dm.direction}} ui-dropmore--{{dm.color}}\"><div class=\"ui-dropmore__buttoncont\" ui-scrollmove=\"{{dm.aniDir}}\" end-at-y=\"0.5\" buffer=\"250\" end-at-x=\"dm.buttonStartPos\" force-pos-x=\"dm.forcedEndPos\"><ui-button type=\"openclose\" state=\"{{dm.state}}\" ng-click=\"dm.toggle()\"></ui-button></div><div class=\"ui-dropmore__container\" ng-style=\"dm.state === \'open\' && {\'height\' : dm.innerHeight + \'px\'}\"><div class=\"ui-dropmore__inner\"><ng-transclude></ng-transclude></div></div></div>");
$templateCache.put("app/components/ui-imagecarousel/ui-imagecarousel.html","<div class=\"ui-imagecarousel {{vm.type}}\"><ks-swiper-container class=\"ks-swiper-container\" swiper=\"vm.carouselSwiper\" override-parameters=\"vm.carouselSwiperParams\" ,=\"\" on-ready=\"vm.onReadySwiper(swiper)\"><ks-swiper-slide class=\"swiper-slide\" ng-repeat=\"i in vm.items track by $index\" on-last-repeat=\"vm.slidesReady = true\"><div ng-click=\"vm.goto($index)\"><figure><div ng-style=\"{\'padding-top\' : (vm.ratio * 100) + \'%\'}\"><ui-img alt=\"{{i.caption[vm.lang]}}\" image=\"{{i.img}}\" cover=\"true\" crop=\"\'top\'\"></ui-img></div><figcaption>{{i.caption[vm.lang]}}</figcaption></figure><p>{{i.text[vm.lang]}}</p></div></ks-swiper-slide></ks-swiper-container><div class=\"ui-imagecarousel__arrows\"><ui-button ng-style=\"{\'top\' : vm.arrowsTop + \'px\'}\" ng-hide=\"vm.isBeginning\" type=\"arrow-left\" class=\"ui-imagecarousel__arrowleft\" ng-click=\"vm.prev()\"></ui-button><ui-button ng-style=\"{\'top\' : vm.arrowsTop + \'px\'}\" ng-hide=\"vm.isEnd\" type=\"arrow-right\" class=\"ui-imagecarousel__arrowright\" ng-click=\"vm.next()\"></ui-button></div></div>");
$templateCache.put("app/components/ui-mapline/ui-mapline.html","<div class=\"ui-mapline\"><ui-img image=\"{{ml.image}}\"></ui-img><div class=\"ui-mapline__holder\" ng-class=\"{\'is-at-end\' : ml.progress >= (1/ml.progressAcc)}\"><div class=\"ui-mapline__mask\" ng-style=\"{\'width\' : ml.lineLength}\"><div class=\"ui-mapline__line\"></div></div></div></div>");
$templateCache.put("app/components/ui-parallax/ui-parallax.html","<div class=\"ui-parallax\" ng-attr-style=\"-ms-transform: {{vm.styles.transform}}; transform: {{vm.styles.transform}}\" ng-class=\"{\'active\' : vm.active}\"><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/ui-scrollfix/ui-scrollfix.html","<div class=\"ui-scrollfix\" ng-style=\"sf.stylesOuter\"><ng-transclude class=\"ui-scrollfix__content\" ng-style=\"sf.stylesInner\"></ng-transclude></div>");
$templateCache.put("app/components/ui-socialicon/ui-socialicon.html","<a href=\"{{icon.href}}\" ng-attr-target=\"{{icon.newWindow ? \'_blank\' : \'\'}}\" class=\"ui-socialicon ui-socialicon--{{icon.type}} ui-socialicon--{{icon.theme}}\" ng-click=\"icon.blurCond()\"><svg ng-if=\"icon.type === \'facebook\'\" xmlns=\"http://www.w3.org/2000/svg\" width=\"96.124\" height=\"96.123\" viewbox=\"0 0 96.124 96.123\"><path d=\"M72.09.02L59.623 0C45.62 0 36.57 9.285 36.57 23.656v10.907H24.037a1.96 1.96 0 0 0-1.96 1.96v15.804a1.96 1.96 0 0 0 1.96 1.96H36.57v39.876a1.96 1.96 0 0 0 1.96 1.96h16.352a1.96 1.96 0 0 0 1.96-1.96V54.287h14.654a1.96 1.96 0 0 0 1.96-1.96l.006-15.803a1.963 1.963 0 0 0-1.96-1.96H56.84v-9.247c0-4.444 1.06-6.7 6.848-6.7l8.397-.003a1.96 1.96 0 0 0 1.96-1.96V1.98A1.96 1.96 0 0 0 72.088.02z\"></path></svg><svg ng-if=\"icon.type === \'twitter\'\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 612 612\"><path d=\"M612 116.258a250.714 250.714 0 0 1-72.088 19.772c25.93-15.527 45.777-40.155 55.184-69.41-24.322 14.378-51.17 24.82-79.775 30.48-22.906-24.438-55.49-39.66-91.63-39.66-69.333 0-125.55 56.218-125.55 125.514 0 9.828 1.11 19.427 3.25 28.606-104.325-5.24-196.834-55.223-258.75-131.174-10.822 18.51-16.98 40.078-16.98 63.1 0 43.56 22.182 81.994 55.836 104.48A125.556 125.556 0 0 1 24.63 232.21v1.568c0 60.806 43.29 111.554 100.692 123.104-10.517 2.83-21.607 4.398-33.08 4.398-8.107 0-15.947-.803-23.634-2.333 15.985 49.907 62.336 86.2 117.253 87.194-42.946 33.655-97.098 53.656-155.915 53.656-10.134 0-20.116-.612-29.944-1.72 55.568 35.68 121.537 56.484 192.44 56.484 230.947 0 357.187-191.29 357.187-357.188l-.42-16.253C573.87 163.525 595.21 141.42 612 116.257z\" fill=\"#010002\"></path></svg><svg ng-if=\"icon.type === \'gplus\'\" xmlns=\"http://www.w3.org/2000/svg\" width=\"96.828\" height=\"96.827\" viewbox=\"0 0 96.828 96.827\"><path d=\"M62.617 0H39.525C29.235 0 22.112 2.256 15.7 7.552c-5.04 4.35-8.05 10.672-8.05 16.912 0 9.614 7.33 19.83 20.913 19.83 1.306 0 2.752-.133 4.028-.252l-.187.457c-.546 1.307-1.063 2.54-1.063 4.467 0 3.75 1.81 6.063 3.558 8.298l.22.283-.39.027c-5.61.384-16.05 1.1-23.676 5.787-9.007 5.355-9.707 13.145-9.707 15.404 0 8.988 8.376 18.06 27.09 18.06 21.76 0 33.146-12.005 33.146-23.863.003-8.77-5.14-13.1-10.6-17.698l-4.604-3.582c-1.423-1.18-3.195-2.646-3.195-5.364 0-2.673 1.773-4.437 3.337-5.993l.163-.165c4.973-3.917 10.61-8.358 10.61-17.964 0-9.658-6.036-14.65-8.938-17.048h7.663a.488.488 0 0 0 .266-.077l6.602-4.15A.5.5 0 0 0 62.617 0zM34.614 91.535c-13.264 0-22.176-6.195-22.176-15.416 0-6.022 3.645-10.397 10.824-12.998 5.75-1.935 13.17-2.03 13.244-2.03 1.257 0 1.89 0 2.893.125C48.68 67.822 53.14 71.29 53.14 77.895c0 8.414-7.1 13.64-18.528 13.64zm-.125-50.78c-11.133 0-15.753-14.632-15.753-22.467 0-3.984.906-7.042 2.77-9.35 2.023-2.532 5.487-4.167 8.825-4.167 10.22 0 15.873 13.74 15.873 23.234 0 1.498 0 6.055-3.148 9.22-2.117 2.113-5.56 3.532-8.568 3.532zM94.982 45.223H82.814V33.098a.5.5 0 0 0-.5-.5H77.08a.5.5 0 0 0-.5.5v12.125H64.473a.5.5 0 0 0-.5.5v5.304a.5.5 0 0 0 .5.5H76.58V63.73a.5.5 0 0 0 .5.5h5.234a.5.5 0 0 0 .5-.5V51.525h12.168a.5.5 0 0 0 .5-.5v-5.302a.5.5 0 0 0-.5-.5z\"></path></svg><svg ng-if=\"icon.type === \'youtube\'\" width=\"143\" height=\"100\" viewbox=\"0 0 143 100\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.743 0C8.393 0 0 8.393 0 18.743v61.852c0 10.35 8.393 18.743 18.743 18.743h104.96c10.35 0 18.743-8.393 18.743-18.743V18.743C142.446 8.393 134.054 0 123.704 0H18.744zm41.222 74.858v-50.38l33.112 25.19-33.112 25.19z\" fill=\"#000\" fill-rule=\"evenodd\"></path></svg><svg ng-if=\"icon.type === \'instagram\'\" width=\"100\" height=\"100\" viewbox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.835 0h74.33C94.226 0 100 5.226 100 12.834v74.333C100 94.775 94.224 100 87.166 100h-74.33C5.773 100 0 94.776 0 87.168V12.834C0 5.226 5.774 0 12.835 0zm60.01 11.11a4.513 4.513 0 0 0-4.5 4.503V26.39a4.513 4.513 0 0 0 4.5 4.5H84.15a4.515 4.515 0 0 0 4.5-4.5V15.612a4.515 4.515 0 0 0-4.5-4.502H72.845zM88.7 42.29h-8.8c.832 2.72 1.283 5.6 1.283 8.58 0 16.632-13.918 30.115-31.085 30.115-17.165 0-31.082-13.483-31.082-30.116 0-2.983.45-5.862 1.284-8.58h-9.184v42.242a3.987 3.987 0 0 0 3.975 3.976h69.637a3.987 3.987 0 0 0 3.976-3.976V42.29H88.7zM50.094 30.323c-11.09 0-20.083 8.712-20.083 19.46 0 10.748 8.993 19.46 20.084 19.46 11.093 0 20.086-8.712 20.086-19.46 0-10.748-8.992-19.46-20.086-19.46z\" fill=\"#000\" fill-rule=\"evenodd\"></path></svg><svg ng-if=\"icon.type === \'mail\'\" width=\"100\" height=\"75\" viewbox=\"0 0 100 75\" xmlns=\"http://www.w3.org/2000/svg\"><title>Shape</title><path d=\"M99.995 62.497c0 2.19-.615 4.225-1.6 6.01L66.817 33.183 98.05 5.86c1.22 1.93 1.95 4.2 1.95 6.64v49.997h-.005zm-49.997-22.9L93.455 1.576A12.35 12.35 0 0 0 87.495 0H12.5c-2.17 0-4.18.6-5.95 1.575l43.448 38.023zm12.114-2.3l-10.065 8.8a3.12 3.12 0 0 1-4.1 0l-10.074-8.8L5.905 73.072c1.915 1.2 4.16 1.926 6.59 1.926H87.49a12.35 12.35 0 0 0 6.59-1.925L62.112 37.3zM1.95 5.86A12.346 12.346 0 0 0 0 12.5v49.997c0 2.19.615 4.225 1.6 6.01l31.573-35.33L1.95 5.86z\" fill=\"#3A3A3A\" fill-rule=\"evenodd\"></path></svg></a>");
$templateCache.put("app/components/ui-zipper/ui-zipper.html","<div class=\"ui-zipper\"><span ng-repeat=\"line in vm.lines\" class=\"ui-zipper__line\"><span ng-repeat=\"w in line\" class=\"ui-zipper__word {{w.cssClass}}\" ng-attr-data-index=\"{{$index}}\">{{w.word}}</span> <span></span></span></div>");
$templateCache.put("app/components/ui-zoomimage/ui-zoomimage.html","<div class=\"ui-zoomimage\" ng-style=\"{\'padding-top\' : (zi.ratio * 100) + \'%\'}\"><div class=\"ui-zoomimage__inner\"><div></div></div></div>");}]);